export const caMessages = {
  public_occupancy: {
    occupied: 'Ocupat',
    invalid_parameters: 'Cal indicar l’entitat a la ruta. Si s’indica classrooms_id, ha de ser un identificador d’espai vàlid.',
    load_error: 'No s’ha pogut carregar l’ocupació.',
    retry: 'Torna-ho a provar'
  },
  tickets_discounts: {
    session_help: 'Marca els descomptes que es poden aplicar en aquesta sessió.',
    session_config_button: 'Configuració de descomptes',
    session_empty: 'No hi ha descomptes configurats.',
    session_load_error: 'No s’han pogut carregar els descomptes de la sessió.',
    priority: 'Ordre', invalid_priority: 'L’ordre ha de ser un nombre enter vàlid.',
    title: 'Descomptes', desc: 'Configura els descomptes per defecte de la venda d’entrades.',
    create: 'Crear descompte', edit: 'Modificar descompte', data: 'Dades', fares: 'Tarifes', application: 'Aplicació',
    active: 'Actiu', type: 'Tipus', value: 'Valor', quantity_x: 'Obté X', quantity_y: 'Paga Y', percentage: 'Percentatge',
    application_type: 'Com s’aplica aquest descompte',
    application_FARES: 'Automàticament seleccionant entrades de les tarifes',
    application_BASKET: 'Automàticament a la cistella completa',
    application_CODE: 'Introduint un codi de descompte', discount_code: 'Codi de descompte',
    BUY_X_PAY_Y: 'Obté X, paga Y', PERCENTAGE: 'Percentatge de descompte', SECOND_UNIT_PERCENTAGE: 'Percentatge de descompte a la 2a unitat',
    fares_help: 'Tarifes a les quals es pot aplicar aquest descompte',
    no_fares: 'Encara no hi ha tarifes configurades.',
    invalid_name: 'Indica un nom de fins a 255 caràcters.', invalid_type: 'Selecciona un tipus de descompte.',
    invalid_quantities: 'X i Y han de ser enters, X major que Y i Y igual o major que zero.',
    invalid_percentage: 'El percentatge ha d’estar entre 0 i 100.',
    invalid_application_type: 'Selecciona com s’aplica aquest descompte.',
    invalid_discount_code: 'Indica un codi de descompte de fins a 20 caràcters.'
  },
  ra: {
    action: {
      add_filter: 'Afegir filtre',
      add: 'Afegir',
      back: 'Tornar',
      bulk_actions: '1 element seleccionat |||| %{smart_count} elements seleccionats',
      cancel: 'Cancel·lar',
      clear_input_value: 'Netejar valor',
      clone: 'Clonar',
      create: 'Afegir',
      create_item: 'Afegir', /* %{item} */
      delete: 'Esborrar',
      edit: 'Modificar',
      export: 'Exportar',
      list: 'Llistar',
      refresh: 'Refrescar',
      remove_filter: 'Esborrar aquest filtre',
      remove: 'Esborrar',
      save: 'Desar',
      search: 'Cercar',
      show: 'Mostrar',
      sort: 'Ordenar',
      undo: 'Desfer',
      confirm: 'Confirmeu',
      unselect: 'Desseleccionar',
      expand: 'Ampliar',
      close: 'Tanca',
      open_menu: 'Obre el menú',
      close_menu: 'Tanca el menú',
    },
    boolean: {
      true: 'Si',
      false: 'No',
      null: ' ',
    },
    page: {
      create: 'Afegir', /* %{name} */
      dashboard: 'Inici',
      edit: '%{name} #%{id}',
      error: 'S\'ha produït un error',
      list: 'Llista de %{name}',
      loading: 'Carregant...',
      not_found: 'No s\'ha trobat',
      show: '%{name} #%{id}',
      empty: 'Encara no hi ha %{name}.',
      invite: 'Vols afegir-ne una?',
    },
    input: {
      file: {
        upload_several: 'Arrossega els fitxers a pujar o clica per seleccionar-ne un.',
        upload_single: 'Arrossega el fitxer a pujar o clica per seleccionar-lo.',
      },
      image: {
        upload_several: 'Arrossega les imatges a pujar o clica per seleccionar-ne una.',
        upload_single: 'Arrossega la imatge a pujar o clica per seleccionar-la.',
      },
      references: {
        all_missing: 'No s\'han pogut trobar referències.',
        many_missing: 'Almenys una de les referències associades no sembla estar disponible.',
        single_missing: 'La referència associada ja no està disponible.',
      },
      password: {
        toggle_visible: 'Amagueu la contrasenya',
        toggle_hidden: 'Mostrar contrasenya',
      },
    },
    message: {
      about: 'Sobre',
      are_you_sure: 'Està segur?',
      bulk_delete_content: 'Està segur d\'esborrar l\'element %{name}? |||| Està segur d\'esborrar aquests %{smart_count} elements?',
      bulk_delete_title: 'Esborrar %{name} |||| Esborrar %{smart_count} %{name} elements',
      delete_content: 'Està segur d\'esborrar-lo?',
      delete_title: 'Esborrar registre' , /* %{name} #%{id}" */
      details: 'Detalls',
      error: 'S\'ha prodït un error al client i la seva petició no s\'ha pogut completar.',
      invalid_form: 'El formulari no és vàlid. Si us plau, revisa els errors',
      loading: 'La pàgina s\'està carregant, esperi un moment si us plau',
      no: 'No',
      not_found: 'O bé ha escrit una URL incorrecta, o bé ha navegat a un enllaç erroni.',
      yes: 'Sí',
      unsaved_changes: 'Alguns dels canvis no s\'han desat. Esteu segur que voleu ignorar-les?',
    },
    navigation: {
      no_results: 'No hi ha registres',
      no_more_results: 'La pàgina número %{page} està fora de rang. Provi amb la pàgina anterior.',
      page_out_of_boundaries: 'Pàgina número %{page} fora de rang',
      page_out_from_end: 'No es pot anar més enllà de la última pàgina',
      page_out_from_begin: 'No es pot anar més enllà de la pàgina 1',
      page_range_info: '%{offsetBegin} - %{offsetEnd} de %{total}',
      page_rows_per_page: 'Files per pàgina:',
      next: 'Següent',
      prev: 'Anterior',
      skip_nav: 'Ves al contingut',
    },
    sort: {
      sort_by: 'Ordenar per %{field} %{order}',
      ASC: 'ascendent',
      DESC: 'descendent',
    },
    auth: {
      user_menu: 'Perfil',
      username: 'Usuari',
      password: 'Contrasenya',
      sign_in: 'Inicia sessió',
      sign_in_error: 'Ha fallat l\'autenticació, si us plau torni a provar-ho',
      logout: 'Tancar sessió',
      auth_check_error: 'Inicieu la sessió per continuar',
      error: 'Usuari o contrasenya incorrecta',
      auth_account_locked: 'El compte està bloquejat. Espera uns minuts i torna a provar-ho',
      auth_too_many_attempts:'S\'han fet massa intents d\'inici de sessió. Per seguretat el compte ha quedat bloquejat durant 5 minuts.',
      auth_invalid_credentials:'Usuari o contrasenya incorrecta',
      error_network: 'Ups! Alguna cosa no ha anat bé. Torna-ho a provar en uns minuts.',
    },
    notification: {
      updated: 'Registre actualitzat |||| %{smart_count} registres actualitzats',
      created: 'Registre creat',
      deleted: 'Registre eliminat |||| %{smart_count} registres eliminats',
      bad_item: 'Element incorrecte',
      logged_out: 'La seva sessió ha finalitzat, torneu a connectar-se.',
      item_doesnt_exist: 'L\'element no existeix',
      http_error: 'Error de comunicació amb el servidor',
      data_provider_error: 'Error del dataProvider. Comprova la consola per més detalls.',
      canceled: 'Acció cancel·lada',
      i18n_error: 'No es poden carregar les traduccions per a l\'idioma especificat',
    },
    validation: {
      required: 'Obligatori',
      minLength: 'Longitud mínima de %{min} caràcters',
      maxLength: 'Màxim %{max} caràcters',
      minValue: 'El valor mínim és %{min}',
      maxValue: 'El valor màxim és %{max}',
      number: 'Número invàlid',
      email: 'Ha de ser una adreça electrònica vàlida',
      oneOf: 'Ha de ser un d\'aquests valors: %{options}',
      regex: 'Ha de complir el format (expressió regular): %{pattern}', 
    }
  },


  common : {
    id : 'Id',
    name : 'Nom',
    name_internal : 'Nom intern',
    description : 'Descripció',
    email : 'Correu electrònic',
    image : 'Imatge',
    action : 'Acció',
    actions : 'Accions',
    search : 'Cercar',
    actived : 'Actiu',
    actived_female : 'Activa',
    edit : 'Editar',
    visible: 'Visible',
    priority: 'Ordre',
    comment: 'Comentari',
    loading: 'Carregant...',
    data: 'Dades',
    type: 'Tipus',
    status: 'Estat',
    month_1: 'Gen',
    month_2: 'Feb',
    month_3: 'Mar',
    month_4: 'Abr',
    month_5: 'Mai',
    month_6: 'Jun',
    month_7: 'Jul',
    month_8: 'Ago',
    month_9: 'Set',
    month_10: 'Oct',
    month_11: 'Nov',
    month_12: 'Des',     
    months_1: 'Gener',
    months_2: 'Febrer',
    months_3: 'Març',
    months_4: 'Abril',
    months_5: 'Maig',
    months_6: 'Juny',
    months_7: 'Juliol',
    months_8: 'Agost',
    months_9: 'Setembre',
    months_10: 'Octubre',
    months_11: 'Novembre',
    months_12: 'Desembre',    
    year : 'Any',
    language: 'Idioma',
    language_association: 'Idioma corporatiu de l\'entitat',
    language_0: 'Català',
    language_1: 'Castellà',
    notification : { 
      updated: 'Element actualitzat',
      error: 'S\'ha produït un error'
    },
    validation: {
      required: 'Obligatori',
      minLength: 'Longitud mínima de %{min} caràcters',
      maxLength: 'Màxim %{max} caràcters',
      minValue: 'El valor mínim és %{min}',
      maxValue: 'El valor màxim és %{max}',
      number: 'Número invàlid',
      email: 'El format del correu electrònic no és correcte',
      oneOf: 'Ha de ser un d\'aquests valors: %{options}',
      regex: 'Ha de complir el format (expressió regular): %{pattern}',
      minMaxLengthAndCharacters: '%{min}-%{max} caràcters, amb un número, lletra, majúscula, minúscula i caràcter especial',
      date_finish_after_start: 'La data final ha de ser posterior a la data d\'inici',
      invalid_date: 'La data no és vàlida',
    },
    yes: 'Sí',
    no: 'No' ,
    labels: 'Etiquetes',
    day_week_1: 'Dill',
    day_week_2: 'Dm',
    day_week_3: 'Dim',
    day_week_4: 'Dij',
    day_week_5: 'Div',
    day_week_6: 'Dis',
    day_week_7: 'Diu',
    day_week_complete_1: 'Dilluns',
    day_week_complete_2: 'Dimarts',
    day_week_complete_3: 'Dimecres',
    day_week_complete_4: 'Dijous',
    day_week_complete_5: 'Divendres',
    day_week_complete_6: 'Dissabte',
    day_week_complete_7: 'Diumenge',
    title: 'Títol',
    link: 'Enllaç',
    notFoundPage: 'La pàgina no existeix',
    goBack: 'Tornar enrere',
    date_from: 'Des del ',
    date_to: ' fins el ',
    time_to: 'A les ',
    download_ok: 'El fitxer s\'ha generat correctament. Consulta la carpeta de descàrregues del navegador',
    excel: 'Excel',
    pdf: 'PDF',    
  },
  main_menu : {
    home: 'Inici',
    groups: 'Grups',
    users: 'Contactes',
    recercat_users: 'Carnets',
    recercat_centers: 'Centres',
    docs_fac: 'Documents',
    remittances: 'Rebuts',
    classrooms: 'Espais',
    users_groups : 'Assignació a grup',
    associations: 'Clients',
    modules: 'Mòduls',
    modules_view: 'Més Apps...',
    real_state: 'Immobles',
    agreements: 'Convenis',
    insurances: 'Assegurances',
    permissions: 'Permisos',
    subscriptions: 'Subscripcions',
    options: 'Opcions',
    contacts: 'Contactes FAC',
    events: 'Agenda',
    reports: 'Informes',
    ara_tiquets: 'ENTRADES',
    ara_tiquets_superadmin: 'Entrades',
    ara_tiquets_events: 'Esdeveniments',
    ara_tiquets_categories: 'Categories',
    ara_tiquets_topics: 'Pàgines temàtiques',
    ara_tiquets_statistics: 'Estadístiques',
    ara_tiquets_configuration: 'Configuració',
    payments: 'Liquidacions',
  },
  superadmin_payments: {
    title: 'Liquidacions a les entitats',
    mode: 'Mòdul',
    settlement_type: 'Operació',
    payments: 'Pagaments',
    collections: 'Cobraments',
    donations: 'Donatius',
    tickets: 'Entrades',
    only_pending: 'Només pendents',
    association: 'Entitat',
    project: 'Projecte',
    project_status: 'Estat del projecte',
    in_progress: 'En procés',
    finished: 'Acabat',
    date_finish: 'Data finalització',
    total_collected: 'Import total recollit',
    management_expenses: 'Despeses de gestió',
    management_tax: 'IVA de les despeses de gestió',
    total_to_transfer: 'Total a transferir a l\'entitat',
    total_transferred: 'Total ja transferit',
    pending_transfer: 'Pendent de transferir',
    total_to_collect: 'Total a cobrar de l\'entitat',
    total_already_collected: 'Total ja cobrat',
    pending_collection: 'Pendent de cobrar',
    send_statement: 'Enviar liquidació',
    send_statement_ask: 'Vols enviar la liquidació a l\'entitat?',
    send_statement_ask_again: 'Vols tornar a enviar la liquidació a l\'entitat?',
    statement_sent: 'S\'ha iniciat l\'enviament de l\'estat de liquidació',
    statement_date: 'Data d\'enviament',
    statement_status: 'Estat de l\'enviament',
    send_status_0: 'No enviat',
    send_status_1: 'Enviant',
    send_status_2: 'Error d\'enviament',
    send_status_3: 'Enviat',
    send_status_4: 'Error del servidor',
    add_payment: 'Afegir pagament',
    empty_payments: 'Encara no hi ha pagaments a l\'entitat. Vols afegir-ne?',
    edit_payment: 'Modificar pagament',
    add_movement_0: 'Afegir pagament',
    add_movement_1: 'Afegir cobrament',
    edit_movement_0: 'Modificar pagament',
    edit_movement_1: 'Modificar cobrament',
    registered_movement_0: 'S\'ha registrat el pagament',
    registered_movement_1: 'S\'ha registrat el cobrament',
    updated_movement_0: 'S\'ha modificat el pagament',
    updated_movement_1: 'S\'ha modificat el cobrament',
    empty_movements_0: 'Encara no hi ha pagaments a l\'entitat. Vols afegir-ne?',
    empty_movements_1: 'Encara no hi ha cobraments de l\'entitat. Vols afegir-ne?',
    delete_payment: 'Esborrar pagament',
    delete_payment_confirm: 'Segur que vols esborrar aquest pagament?',
    date_payment: 'Data de pagament',
    date_movement_0: 'Data de pagament',
    date_movement_1: 'Data de cobrament',
    amount: 'Import',
    amount_two_decimals: 'L\'import ha de tenir com a màxim dos decimals',
    payment_system: 'Forma de pagament',
    payment_method_movement_0: 'Forma de pagament',
    payment_method_movement_1: 'Forma de cobrament',
    bank_receipt: 'Rebut bancari',
    comment: 'Comentari (es mostrarà en el correu de liquidació, p. e. número de factura, concepte de la transferència...)',
    comment_column: 'Comentari',
    tickets_pending: 'La gestió de pagaments d\'Entrades està pendent de definir.',
  },
  ara_tiquets_admin: {
    pending: 'Apartat pendent de configurar',
    configuration_title: "Configuració general de la plataforma de venda d'entrades",
    general_configuration: 'Paràmetres generals',
    appearance: 'Aparença',
    name: 'Nom',
    public_url: 'Adreça pública',
    primary_color: 'Color principal',
    secondary_color: 'Color secundari',
    max_active_baskets: 'Número màxim de cistelles actives',
    max_active_baskets_per_ip: 'Número màxim de cistelles actives per IP',
    payment_expiration_seconds: 'Temps de caducitat del pagament (segons)',
    payment_success_limit_seconds: 'Límit de confirmació correcta del pagament (segons)',
    reminders: 'Recordatoris d\'entrades',
    reminders_help: 'Envia un correu de recordatori a les persones que han comprat entrades abans de l\'inici de la sessió. Aquesta configuració és global per a totes les entitats. Si l\'hora prevista cau fora de la franja d\'enviament, el correu s\'avançarà a l\'última hora permesa anterior.',
    reminders_enabled: 'Activar l\'enviament de recordatoris d\'entrades',
    reminder_hours_before: 'Enviar abans de la sessió (hores)',
    reminder_send_from: 'Inici de la franja d\'enviament',
    reminder_send_until: 'Final de la franja d\'enviament',
    web_logo: 'Logotip web',
    web_icon: 'Icona de la web',
    email_logo: 'Logotip correus',
    ticket_pdf_logo: 'Logotip PDF entrades',
    default_event_web_image: 'Imatge per defecte de l\'esdeveniment web',
    default_event_ticket_pdf_image: 'Imatge per defecte de l\'esdeveniment a l\'entrada en PDF',
    default_subscription_image: 'Imatge per defecte de l\'abonament',
    legal_texts: 'Textos legals',
    legal_texts_project_name_help: 'Pots utilitzar la variable %project_name%; es substituirà automàticament pel nom del projecte.',
    ticket_pdf_legal_text: 'Text legal inferior de l\'entrada en PDF',
    web_legal_text: 'Text legal de la web',
    web_privacy_policy: 'Política de privadesa de la web',
    web_cookie_policy: 'Política de cookies',
    web_terms_conditions: 'Termes i condicions generals',
    google_wallet_legal_text: 'Avís de privadesa de Google Wallet',
    pkpass_legal_text: 'Avís de privadesa del fitxer PKPass',
    configuration_saved: 'Configuració desada correctament',
    configuration_load_error: 'No s\'ha pogut carregar la configuració',
    configuration_save_error: 'No s\'ha pogut desar la configuració',
    session_date: 'Data',
    event_name: 'Esdeveniment',
    session_name: 'Sessió',
    seating_map: 'Mapa de butaques',
    sales_status: 'Estat venda',
    total_on_sale: 'Entrades posades a la venda',
      sold: 'Venudes',
      reserved: 'Reservades',
      sold_tickets: 'Entrades venudes',
      paid_bookings: 'Compres fetes',
      average_tickets_per_booking: 'Mitjana entrades/compra',
      pending_payment: 'Pendents pagament',
    in_basket: 'A cistella',
    available: 'Disponibles',
    income_total: 'Total ingressat',
    income_ticket_base: 'Base entrades',
    income_ticket_vat: 'IVA entrades',
    income_ticket_subtotal: 'Entrades (base + IVA)',
    income_subscription_base: 'Base abonaments',
    income_subscription_vat: 'IVA abonaments',
    income_subscription_subtotal: 'Abonaments (base + IVA)',
    income_management_base: 'Despeses de gestió',
    income_management_vat: 'IVA gestió',
    income_management_subtotal: 'Gestió (base + IVA)',
      view_bookings: 'Veure compres',
      view_public_event: 'Veure web pública',
      edit_event: 'Modificar esdeveniment',
    edit_session: 'Modificar sessió',
    cancel_event: 'Cancel.lar esdeveniment',
    add_event: 'Afegir esdeveniment',
    association: 'Entitat',
    sales_accumulated: 'Entrades',
    sold_online: 'Comprades en línia',
    sold_box_office: 'Comprades a guixeta',
    sold_total: 'Total entrades',
    reservations: 'Reserves',
    invitations: 'Invitacions',
    attendance_chart: 'Assistència',
    people: 'Persones',
    attended: 'Han assistit',
    not_attended: 'No han assistit',
    absolute_values: 'Valors absoluts',
    percentage_values: 'Percentatges',
    tickets_tab: 'Entrades',
    bookings_tab: 'Compres',
    entries_section: 'Entrades',
    events_section: 'Esdeveniments',
    reservations_section: 'Reserves',
    subscriptions_section: 'Abonaments',
    no_subscriptions: 'No s\'han trobat abonaments',
    no_ticketing_events: 'No s\'han trobat esdeveniments amb venda d\'entrades',
    reservation_name: 'Nom de la reserva',
    reservation_email: 'Correu de la reserva',
    reservation_phone: 'Telèfon de la reserva',
    reservation_comments: 'Comentaris',
    box_office_user: 'Taquiller',
    subscription_price: 'Tarifa',
    subscription_code: 'Codi d’abonament',
    subscription_purchases: 'Compres de l’abonament',
    view_subscription_purchases: 'Veure les compres',
    edit_subscription: 'Modificar abonament',
    view_public_subscriptions: 'Veure abonaments de l’entitat',
    price_breakdown: 'Veure el desglossament del preu',
    session_type: 'Tipus de sessió',
    created_at: 'Data de creació',
    cancelled: 'Cancel·lada',
  },
  dashboard : {
    members: 'Evolució i composició',  
    members_federation: 'Evolució',  
    birthdays: 'Aniversaris',
    members_legend_female : 'Dones',
    members_legend_male : 'Homes',
    members_legend_no_binary : 'No binaris',
    members_legend_no_informed : 'No informat',
    members_legend_companies : 'Entitats jurídiques',
    last_joins: 'més recents',    
    last_joins_pending: 'Sol·licituds pendents de validar',
    members_view: 'Veure tots',
    events_view: 'Veure totes',
    members_federation_view: 'Veure totes',
    members_view_requests: 'Veure totes',
    members_federation_view_requests: 'Veure totes',
    members_add: 'Afegir',
    people: 'persones',
    age_sufix: 'anys',
    age_pyramid: 'Piràmide d\'edats',
    today: 'Activitats d\'avui',
    next_events: 'Properes activitats',
    statistics_total_members: 'Número',
    statistics_avg_age: 'Mitjana d\'edat', 
    statistics_gender: 'Per gènere',    
    remittances: 'Rebuts',
    remittances_legend_accepted: 'Acceptats',
    remittances_legend_returned: 'Impagats',
    remittances_add: 'Crear una remesa',
    subscription_active_modules: "Mòduls actius",
    subscription_view_all_modules: "Afegir mòduls",
    subscription: 'Dades de la subscripció',
    subscription_name: 'Pla de servei',
    subscription_status: 'Estat',
    subscription_date_expiration: 'Data d\'expiració',
    subscription_users : 'contactes',        
    subscription_size : 'MB',
    subscription_change : 'Modificar',
    help: 'Suport a l\'usuari',
    help_manual_link: 'Manual d\'usuari',       
    help_description_sifac: 'Per a qualsevol consulta o suggeriment sobre l\'ús de l\'aplicatiu envia un correu electrònic a suport@sifac.cat o bé truca al telèfon 691957814 de dilluns a divendres de 9h a 13h i de 16h a 19h.',
    help_description: 'Per a qualsevol consulta o suggeriment sobre l\'ús de l\'aplicatiu envieu un correu electrònic a admin@gestioentitats.cat. Us respondrem el més aviat possible.',                
    federation_members: 'Número',
    federation_total_people: 'Número de socis d\'entitats',
    federation_avg_age: 'Mitjana d\'edat',
    federation_avg_age_associations: 'Mitjana d\'antiguitat',
    federation_economic_data_incomings: 'Ingressos',
    federation_economic_data_expenses: 'Despeses',
    federation_economic_data_inversions: 'Inversions',
    federation_users: 'Persones associades dels ateneus',
    federation_users_number: 'Número',
    federation_volunteers: 'Voluntaris',
    federation_workers: 'Personal remunerat',
    federation_managers: 'Juntes directives',
    federation_responsabilities: 'Membres',    
    federation_num_data: 'Dades de %num% entitat%s%',
    federation_gender: 'Per gènere',    
    federation_map: 'Delegacions territorials',        
    federation_associations: 'entitats',
    alert_subscription_admin: 'Algunes funcions no estan operatives perquè no s\'ha detectat cap subscripció del Gestió d\'entitats activa. Si us plau, contacta amb l\'equip de suport.',    
    facm_auditory : 'Actes a l\'auditori',
    facm_projects : 'Projectes',
    facm_num_events: 'Actes',
    facm_num_entities: 'Entitats',
    facm_num_assistants: 'Assistents',
    subscription_main_FREE: 'Període de prova',
    subscription_main_OP1: 'Bàsic',
    subscription_main_OP2: 'Mitjà',
    subscription_main_OP3: 'Avançat',
  },
  
  modules_view : {
    title: "Mòduls disponibles",
    actived: "Activat",   
    to_desactive: "Desactivar",   
    to_active_button: "Activar",    
    change_modules_title: "Activar/desactivar mòduls",
    to_activate: "Per a modificar els mòduls actius i/o el pla de servei contractat, poseu-vos en contacte per correu electrònic a admin@gestioentitats.cat. Us respondrem el més aviat possible.",
    to_activate_sifac: "Per a modificar els mòduls actius i/o el pla de servei contractat, poseu-vos en contacte per correu electrònic a suport@sifac.cat o bé truca al telèfon 691957814 de dilluns a divendres de 9h a 13h i de 16h a 19h.",    
  },
  
  reports: {
    title: 'Generar informe',  
    annuary: 'Anuari',        
    annuary_desc: 'Dades per a realitzar l\'anuari',
    annuary_item_id: 'Id',
    annuary_item_group: 'Àmbit',
    annuary_item_calc: 'Càlcul',
    annuary_item_name: 'Nom',
    annuary_item_value: 'Quantitat',
    annuary_item_percent: '%',
    annuary_item_avg: 'Mitjana',
    annuary_exporter_file_name: 'anuari',
    annuary_last_years: 'Generar l\'informe amb dades d\'anys anteriors si no existeixen dades per l\'any seleccionat',
    responsabilities: 'Directius d\'entitats',      
    responsabilities_responsability: 'Càrrec',   
    responsabilities_date: 'Data',   
    responsabilities_desc: 'Llistat de directius d\'entitats',    
    responsabilities_exporter_file_name: 'directius',
    responsabilities_list_entity_name: 'Entitat',
    responsabilities_list_entity_city: 'Població',
    generate: 'Generar',    
    left_members: 'Baixes en grups de contactes',
    left_members_desc: 'Consultar les baixes que hi ha hagut en grups de contactes',
    left_members_group: 'Grup',
    left_members_future: 'Data',
    left_members_future_0: 'Fins avui',
    left_members_future_1: 'En qualsevol data',     
    left_members_exporter_file_name: 'baixes',
    no_results: 'No hi ha resultats'
  },
  associations : {
    only_current: 'Només subscripcions actives',
    subscriptions : 'Subscripcions',
    tab_data : 'Dades',
    tab_subscriptions : 'Subscripcions',
    generate_tickets_test_event: 'Generar esdeveniment de prova d\'entrades',
    generate_tickets_test_event_confirm: 'Cada esdeveniment tindrà cinc sessions passades i futures, tarifes i entrades de prova.',
    generate_tickets_test_event_event_count: 'Nombre d\'esdeveniments',
    generate_tickets_test_event_invalid_event_count: 'Indica un nombre d\'esdeveniments entre 1 i 100',
    generate_tickets_test_event_count: 'Nombre total d\'entrades',
    generate_tickets_test_event_invalid_count: 'Indica un nombre d\'entrades entre 1 i 100.000',
    generate: 'Generar',
    test_event_created: 'S\'ha creat l\'esdeveniment de prova',
    delete_tickets_test_events: 'Eliminar els esdeveniments de prova',
    delete_tickets_test_events_confirm: 'S\'eliminaran tots els esdeveniments marcats com a proves d\'aquesta entitat, incloses les sessions, compres i entrades. Aquesta acció no es pot desfer.',
    test_events_deleted: 'S\'han eliminat els esdeveniments de prova',
    tab_admin : 'Administradors',
    tab_statistics : 'Estadístiques',
    generate_data_demo : 'Generar dades de prova',
        
    report_users: 'Usuaris',
    report_groups: 'Grups',
    report_emails: 'Emails',
    report_emails_not_sent: 'No enviats (48h)',
    report_docs: 'Docs',
    report_mb: 'MB',
    report_remittances: 'Remeses',
    report_remittances_users: 'Rebuts',
    report_last_action: 'Última acció',
    
    trial: 'Període de prova',
    begin: 'Inici subscripció',
    end: 'Període de prova exhaurit',
    
    friendly_url: 'Identificador a URL',
    
    email_sent_tooltip_button: 'Enviar notificació',
    email_sent_tooltip_sending: 'S\'està enviant notificació...',
    email_sent_tooltip_done: 'S\'ha enviat la notificació',
    email_sent: 'Notificació',
    email_sent_title: 'Enviar notificació',
    email_sent_ask: 'Segur que vols enviar-li la notificació?' ,  
    email_sent_ask_again: 'Ja s\'ha enviat anteriorment la notificació. Segur que vols tornar a enviar-li?',        
    email_sent_ko: 'La notificació no s\'ha pogut entregar al destinatari',
    
    email_property: 'Correu electrònic del propietari del compte',
    signup_message: 'S\'enviarà un missatge al propietari del compte amb les seves credencials',
        
  },
  auth: {
    error_title: 'S\'ha produït un error',
    forgot_password_title: 'No recordes la teva contrasenya?',
    forgot_password_desc: 'Introdueix el teu correu electrònic i t\'enviarem les instruccions per a crear una nova contrasenya.',
    forgot_password_ok: 'Revisa el teu correu electrònic. <br/><br/> Si ets un usuari administrador t\'hem enviat les instruccions per a canviar la contrasenya.',
    forgot_password_link: 'Ja recordo la contrasenya',
    reset_password_title: 'Escriu la teva nova contrasenya',
    reset_password_button: 'Canviar contrasenya',
    reset_password_ok: 'La teva contrasenya s\'ha actualitzat correctament',
    reset_password_ok_link: 'Anar a la pàgina d\'autenticació',
    send_button: 'Enviar',
    error: 'Error'    
  },
  signup : {
    link_or: "o",
    link: "Registra't",
    title: 'Registreu-vos per a provar l\'aplicatiu',
    register: 'Registre de nou usuari',
    desc: 'Introduiu el nom de la vostra entitat i el correu electrònic, i us enviarem l\'accés per a provar l\'aplicatiu <b>gratuïtament durant 30 dies</b>, sense introducció de dades bancàries. Transcorregut aquest període ja decidireu si voleu activar el pla de servei.',
    ok: 'Hem rebut les vostres dades correctament. <br/><br/>En breu rebreu un correu electrònic amb les credencials d\'accés a l\'aplicatiu.',
    ok_login: 'Accedir',
    name: 'Nom de l\'entitat',
    send_button: 'Registra\'t',
    
    form_lopd: 'Accepto que es tractin les meves dades per atendre la sol·licitud de registre',
    form_lopd_validator: 'Heu d\'acceptar el tractament de les dades',        
    form_lopd_link: 'política de privacitat',
    
    form_terms: 'Accepto els ',
    form_terms_link: 'termes i condicions',
    form_terms_validator: 'Heu d\'acceptar els termes i condicions',
    
    form_newsletter: 'Accepto que es tractin les meves dades per rebre les ofertes i novetats',
    
    lopd : "Política de privacitat",
    terms : "Termes i condicions",
    
  },
  
  subscriptions : {
    modules : 'Mòduls',
    module : 'Mòdul',
    options : 'Opcions',
    option : 'Opció',
    docs: 'Imatges',        
    date_init: 'Data d\'inici',
    date_expiration: 'Data d\'expiració'
  },
  permissions : {
    user : 'Usuari',
    status : 'Estat',
    status0: 'Pendent',
    status1 : 'Alta'
  },
  groups : {
    title: 'Grups',
    group: 'Grup',
    edit : 'Modificar',
    addChild: 'Afegir fill',
    tab_users : 'Persones' ,
    tab_main : 'Grup' ,
    tab_quotes : 'Quotes' ,
    tab_docs : 'Documents',
    tab_subgroups : 'Subgrups' ,
    tab_responsabilities : 'Càrrecs' , 
    num_members: 'Membres actuals' ,
    name: 'Nom del grup',
    card: 'Carnet digital',
    card_digital: 'Es poden generar carnets digitals en PDF',
    card_digital_wallets: 'Es poden generar carnets digitals a Google Wallet i Apple Wallet',
    card_digital_filename: 'Nom del carnet adjunt en el correu electrònic',
  },
  groups_cards : {
    design_title: 'Disseny del carnet',
    type: 'Element',
    name: 'Títol',
    pos_x: 'M.Esquerre (%)',
    pos_y: 'M.Superior (%)',
    size_x: 'Amplada (%)',
    size_y: 'Alçada (%)',
    num_lines: 'Núm. línies màxim',
    font_size: 'T.Lletra (%)',
    font_color: 'Color',
    opacity: 'Opacitat (%)',
    rectangle_round: 'Extrems arrodonits (%)',
    title: 'Nom del camp',
    message: 'Valor del camp',
    status: 'Visible',
    type_0: 'Nom de l\'entitat',
    type_0_default_title: 'Entitat',
    type_1: 'Logotip de l\'entitat',
    type_1_default_title: '',
    type_2: 'Nom + Cognom1 + Cognom2 (membre)',
    type_2_default_title: 'Nom',
    type_3: 'Nom + Cognom1 (membre)',
    type_3_default_title: 'Nom',
    type_4: 'Cognom1 Cognom2, Nom (membre)',
    type_4_default_title: 'Nom',
    type_5: 'Núm. membre (membre)',
    type_5_default_title: 'Número',
    type_6: 'Fotografia (membre)',
    type_6_default_title: '',
    type_7: 'DNI/NIF (membre)',
    type_7_default_title: 'DNI/NIF',
    type_8: 'Data d\'expedició',
    type_8_default_title: 'Expedició',
    type_9: 'Data d\'alta',
    type_9_default_title: 'Data ingrés',
    type_10: 'Codi QR',
    type_10_default_title: '',
    type_11: 'Nom del grup',
    type_11_default_title: 'Grup/secció',
    type_12: 'Correu electrònic (membre)',
    type_12_default_title: 'Correu electrònic',
    type_13: 'Nom (membre)',
    type_13_default_title: 'Nom',
    type_14: 'Cognom1 (membre)',
    type_14_default_title: '1r cognom',
    type_15: 'Cognom2 (membre)',
    type_15_default_title: '2n cognom',
    type_16: 'Cognom1 + Cognom2 (membre)',
    type_16_default_title: 'Cognoms',
    type_17: 'Nom del centre',
    type_17_default_title: 'Nom del centre',
    type_18: 'Població del centre',
    type_18_default_title: 'Població del centre',
    type_19: 'Adreça de l\'entitat',
    type_19_default_title: 'Adreça de l\'entitat',
    type_20: 'Població de l\'entitat',
    type_20_default_title: 'Població de l\'entitat',
    type_21: 'Telèfon de l\'entitat',
    type_21_default_title: 'Telèfon de l\'entitat',
    type_22: 'Marc semi-transparent',
    type_22_default_title: '',
    type_23: 'Color de fons',
    type_23_default_title: '',
    type_24: 'Camp de text',
    type_24_default_title: '',
    type_25: 'Color de títols dels camps',
    type_25_default_title: '',
    type_26: 'Color de lletra',
    type_26_default_title: '',
    type_27: 'Data de naixement',
    type_27_default_title: 'Data de naixement',
    position: 'Posició',
    position_0: 'Títol capçalera frontal',
    position_1: 'Títol capçalera posterior',
    position_2: 'Camp principal',
    position_3: 'Camp secundari',
    position_4: 'Camp auxiliar',
    position_5: 'Camp sota QR',
    position_6: 'Camp part posterior',
    alignment: 'Aliniament',
    alignment_0: 'Esquerre',
    alignment_1: 'Centrat',
    alignment_2: 'Dreta',
    alignment_3: 'Justificat',
    uppercase: 'Majúscules',
    pdf_view: 'Descarregar carnet en PDF',
    regenerate: 'Regenerar codi QR',
    regenerate_title: 'Regenerar codi QR',
    regenerate_text: 'Segur que vols regenerar el codi QR del carnet digital? Aquesta operació només s\'hauria de realitzar en cas de pèrdua o robatori del carnet. El carnet anterior deixarà de ser vàlid. Aquesta operació no envia el carnet al contacte, caldrà fer-ho manualment.',
    regenerated_ok: 'Codi QR regenerat correctament',
    pdf_card_filename: 'carnet.pdf',
    pdf_card_ok: 'El carnet s\'ha generat correctament. Consulta la carpeta de descàrregues del navegador',
    pdf_card_ko: 'No s\'ha pogut descarregar el carnet digital',
    pdf_card_download: 'Previsualització',        
    send_dialog_button: 'Enviar carnets digitals',
    send_dialog_action: 'Acció a realitzar',
    send_dialog_action_0: 'Enviar el carnet digital només als contactes que no s\'ha enviat (%num_pending%)',
    send_dialog_action_1: 'Enviar el carnet digital a tots els contactes del grup (%num_total%)',     
    send_dialog_action_2: 'Enviar el carnet digital als que han donat error (%num_errors%)',
    send_dialog_block_size: 'Límit enviament',                
    send_dialog_regenerate: 'Regenerar el codi QR. Si marques aquesta opció, els contactes que ja disposaven de carnet digital disposaran d\'un carnet nou i l\'anterior serà invàlid. Si no la marques, els usuaris que ja disposaven de carnet digital mantindran el seu codi QR, i l\'anterior carnet continuarà essent vàlid.',        
    send_dialog_text2: 'S\'enviarà als contactes que disposin de correu electrònic. L\'enviament s\'executarà en segon pla i pot trigar uns minuts. ',
    pdf_card_preview: 'Carregant la previsualització del carnet...',
    create: 'Afegir element',
    create_config: 'Afegir configuració',
    edit: 'Modificar element',    
    edit_config: 'Modificar configuració',
    config: 'Configuració',
    background: 'Imatge de fons',
    settings_pdf: "Carnet en PDF",
    settings_wallets_google: "Google Wallet",
    settings_wallets_apple: "Apple Wallet (fitxer .pkpass)",
    background_google_wallet: "Imatge inferior del carnet",
    back_google_wallet: "Imatge posterior del carnet",
    google_wallet_icon: "Icona",
    apple_wallet_icon: "Imatge de capçalera",
    google_wallet_background_color: "Color de fons"
  },
  users : {
    tab_main : 'Dades bàsiques',
    tab_main_0 : 'Dades personals',
    tab_main_1 : 'Dades generals',
    tab_more : 'Més dades',
    tab_groups : 'Grups' ,
    tab_responsabilities : 'Càrrecs' ,
    tab_responsabilities_fac : 'Càrrecs a la FAC' ,
    tab_quotes : 'Quotes' ,
    tab_contacts : 'Contactes relacionats',
    tab_contacts_rel : 'Contactes relacionats',
    tab_economic_data : 'Pressupost anual',
    tab_workers_0 : 'Personal remunerat',
    tab_workers_1 : 'Voluntaris',
    tab_docs : 'Documents',
    tab_images : 'Imatges',
    tab_family : 'Família',
    tab_history : 'Historial',
    ticket_purchases : 'Compres d\'entrades',
    tab_social_nets : 'Xarxes socials',
    user_type: 'Tipus',
    user_type_0: 'Física',
    user_type_1: 'Jurídica',
    group: 'Grup',
    groups: 'Grups',
    without_group : 'Sense grup',
    first_name : 'Nom',
    name_company : 'Nom fiscal',
    last_name_1 : 'Primer cognom',
    surnames : 'Llinatges',
    last_name_2 : 'Segon cognom',
    email : 'Correu electrònic',
    email_secondary : 'Correu electrònic secundari',
    email_secondary_list : 'Adreces de correu electrònic addicionals',
    code : 'Número intern',
    address : 'Adreça',
    neighborhood : 'Nucli / Barri',
    zip : 'Codi postal',
    city : 'Població',
    region : 'Comarca',
    country : 'País',
    lat: "Coord. Latitud",
    lng: "Coord. Longitud",
    phones : 'Telèfons',
    phone : 'Telèfon fix',
    mobile : 'Telèfon mòbil',
    web: 'Pàgina web',
    phone_emergency : 'Telèfon d\'emergència',
    birthday : 'Data de naixement',
    foundation_date: 'Data de fundació',
    foundation_age : 'Antiguitat',
    job : 'Professió',
    nif : 'NIF',
    nif_only : 'NIF',
    gender : 'Gènere',
    gender_1 : 'Home',
    gender_2 : 'Dona',
    gender_3 : 'No binari',
    comment : 'Observacions',
    bank_data: 'Dades bancàries',
    bank_iban: 'IBAN',
    bank_swift: 'BIC/SWIFT',
    bank_payer: 'Pagador',
    no_users_title : 'Encara no hi ha persones.',
    no_users_ask : 'Vols afegir-ne?',
    person: 'Persona',
    payment_cash: 'Paga en efectiu',
    newsletter: 'Accepto rebre comunicacions informatives relacionades amb les activitats de l\'entitat',
    lopd: 'Consentiment del tractament de les dades',
    custom_fields: 'Camps addicionals dels contactes',
    age: 'Edat',
    age_sufix: 'anys',
    others: 'Altres',
    import : 'Importar',
    import_title : 'Importar persones per a aquest grup des de Excel',
    import_template : 'Descarrega la plantilla Excel',
    add_to_group: 'Afegir a',        
    add_member_comments: 'Dubtes, comentaris o suggeriments',
    add_member_send: 'Enviar',
    validate: 'Validar',
    validate_title: 'Validar contacte',
    validate_done: 'S\'ha validat el nou contacte',
    validate_send_email: 'Enviar correu de benvinguda a l\entitat',
    validate_send_card: 'Enviar carnet digital',  
    reject: 'Denegar',
    reject_title: 'Denegar sol·licitud',
    reject_desc: 'Segur que vols denegar la sol·licitud? La persona rebrà un correu electrònic predefinit informant-lo de la denegació i s\'esborraran totes les seves dades.',
    reject_done: 'S\'ha denegat la sol·licitud',
    welcome_email_sent: 'Correu de benvinguda',
    welcome_email_sent_title: 'Correu de benvinguda',
    welcome_email_sent_ask: 'Segur que vols enviar-li el correu de benvinguda predefinit?' ,  
    welcome_email_sent_ask_again: 'Ja s\'ha enviat anteriorment el correu de benvinguda. Segur que vols tornar a enviar-li?',
    welcome_email_sent_ok: 'Enviament realitzat!',
    welcome_email_tooltip_button: 'Enviar correu de benvinguda',
    welcome_email_tooltip_sending: 'S\'està enviant el correu de benvinguda...',
    welcome_email_tooltip_done: 'S\'ha enviat el correu de benvinguda',
    welcome_email_sent_ko: 'El correu de benvinguda no s\'ha pogut entregar al destinatari',
    
    group_left_email_sent: 'Correu de baixa',
    group_left_email_sent_title: 'Correu de baixa',
    group_left_email_sent_ask: 'Segur que vols enviar-li el correu de baixa predefinit?' ,  
    group_left_email_sent_ask_again: 'Ja s\'ha enviat anteriorment el correu de baixa. Segur que vols tornar a enviar-li?',
    group_left_email_sent_ok: 'Enviament realitzat!',
    group_left_email_tooltip_button: 'Enviar correu de baixa',
    group_left_email_tooltip_sending: 'S\'està enviant el correu de baixa...',
    group_left_email_tooltip_done: 'S\'ha enviat el correu de baixa',
    group_left_email_sent_ko: 'El correu de baixa no s\'ha pogut entregar al destinatari',
        
    digital_card_send: 'Carnet digital',
    digital_card_send_title: 'Carnet digital',
    digital_card_send_ask: 'Segur que vols enviar-li el carnet digital?' ,  
    digital_card_send_ask_again: 'Ja s\'ha enviat anteriorment el carnet digital. Segur que vols tornar a enviar-li?',
    digital_card_send_ok: 'Enviament realitzat!',
    digital_card_tooltip_button: 'Enviar carnet digital',
    digital_card_tooltip_sending: 'S\'està enviant el carnet digital...',
    digital_card_tooltip_done: 'S\'ha enviat el carnet digital',
    digital_card_send_ko: 'El carnet digital no s\'ha pogut entregar al destinatari',
        
    exporter_file_name: 'contactes.xlsx',
    exporter_file_name_csv: 'contactes',
    export: 'Exportar',
    alerts: 'Avisos',    
    
    delete_all: 'Esborrar',
    delete_all_confirm_title: 'Confirmació d\'eliminació de %num_registers% registre/s',
    delete_all_confirm_description: 'S\'esborraran totes les seves dades, documents, imatges, reserves, rebuts, històric de grups, ... i qualsevol dada associada que tinguin. ',
    delete_all_confirm_description_ask: 'Estàs segur que vols eliminar els contactes seleccionats?',
    delete_all_ok: 'registres esborrats correctament',
    delete_all_ko: 'Alguns registres no s\'han pogut esborrar: ',
    
    group_changes: 'Canvis en grups',
    group_changes_title: 'Canvis pels %num_registers% contacte/s seleccionat/s',
    group_changes_action: 'Acció a realitzar',
    group_changes_action_1: 'Baixa del grup %group_name%',
    group_changes_action_2: 'Moure a grup',
    group_changes_action_3: 'Assignar a grup',
    group_changes_date_1: 'Data de baixa',
    group_changes_date_2: 'Data de moviment',
    group_changes_date_3: 'Data d\'alta',
    group_changes_confirm: 'Confirmar',
    group_changes_destination_group: 'Grup destí',
    group_changes_ok_1: '%num_registers% contactes s\'han donat de baixa correctament',
    group_changes_ok_2: '%num_registers% contactes s\'han mogut correctament',
    group_changes_ok_3: '%num_registers% contactes s\'han assignat correctament',
    group_changes_ko_1: '%num_registers% contactes no s\'han pogut donar de baixa',
    group_changes_ko_2: '%num_registers% contactes no s\'han pogut moure',
    group_changes_ko_3: '%num_registers% contactes no s\'han pogut assignar',
    
  },      
  users_filter: {
    title: 'Filtrar',
    filters: 'Filtres',
    field: 'Camp',
    operator: 'Operador',
    value: 'Valor',
    year: 'Any',
        
    filter_1: 'Nom',
    filter_2: 'Primer cognom',
    filter_3: 'Segon cognom',        
    filter_4: 'Correu-e principal',
    filter_5: 'Tipus de contacte',
    filter_6: 'Adreça',
    filter_7: 'Nucli / Barri',
    filter_8: 'Codi postal',
    filter_9: 'Població',
    filter_10: 'Comarca',
    filter_11: 'País',
    filter_12: 'NIF',
    filter_13: 'Pàgina web',
    filter_14: 'Data naixement',
    filter_15: 'Data de fundació',
    filter_16: 'Edat',
    filter_17: 'Antiguitat',
    filter_18: 'Correu-e addicional',
    filter_19: 'IBAN',
    filter_20: 'Quota',
    filter_21: 'Últim rebut',
    filter_22: 'Nom complet',
    filter_23: 'Telèfon fix',
    filter_24: 'Telèfon mòbil',
    filter_25: 'Telèfon emergència',
    filter_26: 'Gènere',
    filter_27: 'Professió',
    filter_28: 'Accepta comunicacions',
    filter_29: 'BIC/SWIFT',
    filter_30: 'Paga en efectiu',
    filter_31: 'Fotografia',
    filter_32: 'Documents',
    filter_33: 'Grup: Data alta al grup',
    filter_34: 'Grup: Núm. membre',
    filter_35: 'Xarxes socials',
    filter_36: 'Observacions',
    filter_37: 'Avisos',
    filter_38: 'Grup',  
    filter_39: 'Centre',  
    filter_40: 'Imatges',  
    filter_41: 'Correu-e secundari',
        
    filter_50: 'Grup: S\'ha enviat el correu de benvinguda',
    filter_51: 'Grup: S\'ha enviat el carnet digital',
        
    /* FEDERACIO */
    filter_80: 'Adreces: Adreça',
    filter_81: 'Adreces: Codi postal',
    filter_82: 'Adreces: Població',
    filter_83: 'Adreces: Comarca',
    filter_84: 'Adreces: Província',
    filter_85: 'Adreces: País',
    filter_86: 'Adreces: Adreça d\'enviament',
    filter_87: 'Adreces: Codi postal d\'enviament',
    filter_88: 'Adreces: Població d\'enviament',
    filter_89: 'Adreces: Comarca d\'enviament',
    filter_90: 'Adreces: Província d\'enviament',
    filter_91: 'Adreces: País d\'enviament',
        
    filter_99: 'Nom popular',
    filter_100: 'Acrònim',
    filter_101: 'Nom del registre',
    filter_102: 'Núm. del registre',
    filter_103: 'BCIN',
    filter_104: 'BCIL',
    filter_105: 'Sistema de venda d\'entrades',
    filter_106: 'Forma part de l\'XTAC',
    filter_107: 'Entitat interès cultural',
    filter_108: 'Entitat d\'utilitat pública',
    filter_109: 'Accés al Programa Cat',
    filter_110: 'Últim canvi de junta',
    filter_111: 'Proper canvi de junta',
    filter_112: 'Delegació',
    filter_113: 'Acull altres entitats',
    filter_114: 'Entitats que acull',    
    filter_121: 'Carnets de socis',
    filter_122: 'Logo de la FAC al carnet',
    filter_123: 'Reglament intern',    
    filter_125: 'Placa de la FAC',
    filter_126: 'Llicència d\'activitats',        
    filter_127: 'Titularitat de l\'ateneu',
    filter_128: 'La propietat és',
    filter_129: 'Cedit/Llogat',
    filter_130: 'Expropiat actualment',
    filter_131: 'Adaptats a la nova LOPD',
    filter_132: 'Normatives vigents de',
    filter_133: 'Memòria',
    filter_134: 'Forma part d\'altres federacions',
    filter_135: 'Federacions que forma part',
    filter_136: 'Carnet RCAT',
    filter_137: 'Entitat activa',
    filter_138: 'Entitat desapareguda',
    filter_139: 'Espoliada pel franquisme',
    filter_140: 'Data desaparició',
    filter_141: 'Personatge vinculat a ressaltar',    
        
    filter_200: 'Espais',
    filter_201: 'Espais: Total m2',
    filter_202: 'Espais: m2',
    filter_203: 'Espais: capacitat',
        
    filter_300: 'Pressupost anual',
    filter_301: 'Pressupost: total ingressos',
    filter_302: 'Pressupost: total despeses',
    filter_303: 'Pressupost: total inversió obres',
    filter_304: 'Pressupost: resultat',
    filter_305: 'Pressupost (ingressos): quotes de socis',
    filter_306: 'Pressupost (ingressos): serveis oferts',
    filter_307: 'Pressupost (ingressos): subvencions',
    filter_308: 'Pressupost (ingressos): arrendaments',
    filter_309: 'Pressupost (ingressos): venda de productes',
    filter_310: 'Pressupost (ingressos): ajuts privats',
    filter_311: 'Pressupost (ingressos): altres',
    filter_312: 'Pressupost (despeses): lloguers',
    filter_313: 'Pressupost (despeses): personal',
    filter_314: 'Pressupost (despeses): material',
    filter_315: 'Pressupost (despeses): professionals externs',
    filter_316: 'Pressupost (despeses): catxés de grups',
    filter_317: 'Pressupost (despeses): subministraments',
    filter_318: 'Pressupost (despeses): manteniment',
    filter_319: 'Pressupost (despeses): comunicació i publicitat',
    filter_320: 'Pressupost (despeses): altres',
    filter_321: 'Pressupost (inversió obres): edifici',
    filter_322: 'Pressupost (inversió obres): teatre',
    filter_323: 'Pressupost (inversió obres): bar',
    filter_324: 'Pressupost (inversió obres): accessibilitat',
    filter_325: 'Pressupost (inversió obres): seguretat',
    filter_326: 'Pressupost (inversió obres): altres',
    filter_327: 'Pressupost: Mitjana de la quota anual',
    
    filter_350: 'Dades demogràfiques',
    filter_351: 'Dades demogràfiques: Núm. de socis',
    filter_352: 'Dades demogràfiques: Mitjana d\'edat',
    filter_353: 'Dades demogràfiques: Mitjana d\'edat junta directiva',
    filter_354: 'Dades demogràfiques: Homes (%)',
    filter_355: 'Dades demogràfiques: Dones (%)',
    filter_356: 'Dades demogràfiques: No binaris (%)',
       
    filter_400: 'Personal remunerat',
    filter_401: 'Personal remunerat: total personal',
    filter_402: 'Personal remunerat: administració',
    filter_403: 'Personal remunerat: tècnic d\'activitats',
    filter_404: 'Personal remunerat: consergeria',
    filter_405: 'Personal remunerat: neteja',
    filter_406: 'Personal remunerat: comunicació',
    filter_407: 'Personal remunerat: comptabilitat',
    filter_408: 'Personal remunerat: manteniment',
    filter_409: 'Personal remunerat: gerència',
    filter_410: 'Personal remunerat: altres',
        
    filter_450: 'Voluntaris',
    filter_451: 'Voluntaris: total',
    filter_452: 'Voluntaris: administració',
    filter_453: 'Voluntaris: tècnic d\'activitats',
    filter_454: 'Voluntaris: consergeria',
    filter_455: 'Voluntaris: neteja',
    filter_456: 'Voluntaris: comunicació',
    filter_457: 'Voluntaris: comptabilitat',
    filter_458: 'Voluntaris: manteniment',
    filter_459: 'Voluntaris: gerència',
    filter_460: 'Voluntaris: altres',
    
    filter_470: 'Formacions en arts: total hores',
    filter_471: 'Formacions en arts: estudiants per formació',
    filter_472: 'Formacions en arts: estudiants per tipus de formació',
    filter_473: 'Formacions en arts: professorat remunerat per formació',
    filter_474: 'Formacions en arts: professorat remunerat per tipus de formació',
    filter_475: 'Formacions en arts: professorat voluntari per formació',
    filter_476: 'Formacions en arts: professorat voluntari per tipus de formació',
    
    filter_480: 'Formacions: total hores',
    filter_481: 'Formacions: estudiants per formació',
    filter_482: 'Formacions: estudiants per tipus de formació',
    filter_483: 'Formacions: professorat remunerat per formació',
    filter_484: 'Formacions: professorat remunerat per tipus de formació',
    filter_485: 'Formacions: professorat voluntari per formació',
    filter_486: 'Formacions: professorat voluntari per tipus de formació',
    
    filter_490: 'Projectes socials',
    filter_491: 'Projectes socials per tipus',
       
    filter_500: 'Activitats',
    filter_501: 'Activitats: total activitats anuals',        
    filter_502: 'Activitats: total assistents anuals',
    filter_503: 'Activitats: quantitat',
    filter_504: 'Activitats: assistents',
        
    filter_600: 'Espectacles',
    filter_601: 'Espectacles: total funcions',
    filter_602: 'Espectacles: total assistents',
    filter_603: 'Espectacles: total pressupost',
    filter_604: 'Espectacles: funcions',
    filter_605: 'Espectacles: assistents',
    filter_606: 'Espectacles: pressupost',
        
    filter_700: 'Seccions',
    filter_701: 'Seccions: núm. de seccions',
    filter_702: 'Seccions: total participants',
    filter_703: 'Seccions: participants',
                
    filter_750: 'Ha respost el formulari per a l\'anuari',
    filter_751: 'S\'ha enviat el formulari per a l\'anuari',
    filter_752: 'S\'ha enviat el recordatori del formulari',
       
    filter_800: 'Forma part d\'un cens',
    filter_801: 'Llibres',
    filter_802: 'Enviaments',
                                
    filter_op_1: 'Conté',        
    filter_op_2: 'És igual a',
    filter_op_3: 'És diferent a',   
    filter_op_4: 'És major que',
    filter_op_5: 'És major o igual que',
    filter_op_6: 'És menor que',
    filter_op_7: 'És menor o igual que',   
    filter_op_8: 'No conté',
    filter_op_9: 'En té',
    filter_op_10: 'No en té',
        
  },
    
  users_permissions: {
    email_sent: 'Correu d\'alta d\'administrador/a',
    email_sent_title: 'Correu d\'alta d\'administrador/a',
    email_sent_ask: 'Segur que vols enviar-li el correu d\'alta d\'administrador/a predefinit? Es generarà una nova contrasenya.' ,  
    email_sent_ask_again: 'Ja s\'ha enviat anteriorment el correu d\'alta d\'administrador/a. Segur que vols tornar a enviar-li? Es generarà una nova contrasenya.',
    email_sent_ok: 'Enviament realitzat!',
    email_tooltip_button: 'Enviar correu d\'alta d\'administrador/a',
    email_tooltip_sending: 'S\'està enviant el correu de d\'alta d\'administrador/a...',
    email_tooltip_done: 'S\'ha enviat el correu d\'alta d\'administrador/a',
    email_sent_ko: 'El correu d\'alta d\'administrador no s\'ha pogut entregar al destinatari',  
    role: 'Permisos',
    role_SIFAC: 'Superadministrador',
    role_OWNER: 'Administrador (propietari)',
    role_ADMIN: 'Administrador',
    role_ADMIN_CONTACTS: 'Administrador (lectura + edició contactes)',
    role_ADMIN_READER: 'Administrador (lectura)',
    role_ADMIN_PAYMENTS: 'Administrador (liquidacions)',
    role_ADMIN_CALENDAR_READER: 'Administrador (lectura agenda)',
    role_TICKETS_BOX_OFFICE: 'Entrades (Guixeta)',
    role_ADMIN_TICKETS: 'Administrador d\'esdeveniments i reserves',
    role_ADMIN_TICKETS_EVENTS: 'Administrador d\'esdeveniments',
    role_ADMIN_TICKETS_RESERVATIONS : 'Administrador de reserves',
    role_ADMIN_TICKETS_RESERVATIONS_EVENT : 'Administrador de reserves d\'un esdeveniment',
    role_ADMIN_TICKETS_VALIDATOR: 'Validador d\'entrades',
    role_ADMIN_TICKETS_VALIDATOR_EVENT: 'Validador d\'entrades d\'un esdeveniment',
    create: 'Afegir',
    edit: 'Editar',
  },
        
  users_federation : {
    tab: 'Dades Federació',
    tab_more: 'Més Federació',
    tab_managers: 'Junta directiva',
    tab_managers_1: 'Junta directiva actual',
    tab_managers_2: 'Membres d\'anteriors juntes directives',
    tab_managers_other: 'Membre de juntes directives d\'altres contactes',
    tab_classrooms: 'Espais',  
    name: 'Nom popular',
    acronym: 'Acrònim',
    reg_name: 'Nom del registre',
    reg_num: 'Núm. del registre',    
    bcin: 'BCIN',
    bcil: 'BCIL',
    tickets: 'Sistema de venda d\'entrades',
    xtac: 'Forma part de l\'XTAC',
    culture_interest: 'Entitat interès cultural',
    public_utility: 'Entitat d\'utilitat pública',
    soft_cat: 'Accés al Programa Cat',
    rcat: 'Carnet RCAT',
    last_managers_change: 'Últim canvi de junta',
    next_managers_change: 'Proper canvi de junta',
    delegation: 'Forma part d\'una delegació?',
    host: 'S\'acullen altres entitats',
    host_entities: 'Quines entitats?',
    more_federations: 'Forma part d\'altres federacions',
    federations: 'Quines federacions?',
    lopd: 'Adaptats nou Reglament Europeu Protecció Dades (LOPD)',
    members_cards: 'Carnets de socis',
    logo_federation: 'Hi ha logo de la FAC',
    internal_regulation: 'Reglament intern',
    federation_plate: 'Placa de la FAC',
    ownership: 'Titularitat de l\'ateneu',
    property: 'La propietat és',
    rent: 'Cedit/Llogat',
    expropied: 'Està expropiat actualment',
    license: 'Té llicència d\'activitats',
    regulations: 'Normatives vigents de',
    
    actived: 'Entitat activa',
    missing: 'Entitat desapareguda',
    robbed: 'Espoliada pel franquisme',
    missing_date: 'Data desaparició',
    history_title: 'Història',
    history: 'Història Ateneu - L\'entitat',
    history_equipment: 'Història entitat - L\'equipament, infraestructura',
    history_current: 'Història Ateneu - Situació actual',
            
    census: 'Forma part d\'un cens',
    mailing_lists: 'Enviaments',
    activities_users: 'Etiquetes',
    books: 'Llibres',
                            
    edited_books_title: 'Publicacions de l\'entitat',
    edited_books_books: 'Llibres editats',
    edited_books_book_entity: 'Llibres publicats de l\'entitat',
    edited_books_newsletter: 'Butlletí electrònic',
    edited_books_magazine: 'Revista',
    highlighted_dates: 'Dates a ressaltar',
    notable_individuals: 'Personatges vinculats a ressaltar',
    links: 'Enllaços d\'interès',
    edited_books_memory: 'Memòria',
    edited_books_date: 'Data',
    edited_books_date_year: 'Any de publicació',
    edited_books_period: 'Periodicitat',
    event: 'Esdeveniment',
        
    recognitions: 'Reconeixements',
    recognitions_date: 'Data',
        
    schedules: 'Horaris',
    schedules_day_week: 'Dia',
    schedules_time_start: 'Hora inici',
    schedules_time_finish: 'Hora fi',
                
    addresses: 'Adreces',
    ship_address: 'Adreça d\'enviament',
    province: 'Província',
    gmaps: 'Google Maps',
    addresses_create: 'Afegir adreça',
    addresses_edit: 'Modificar adreça',
    is_foundation_address: 'És l\'adreça de fundació de l\'entitat',
    ship_to_same: 'L\'adreça d\'enviament és la mateixa adreça',
    building: 'Edifici',
    regultations: 'Regulacions',
    others: 'Altres',
    classrooms: 'Espais',        
    total_m2: 'Total m2',    
        
  },
    
  users_groups :{
    date_join : 'Data alta',
    date_left : 'Data baixa',
    responsability: 'Càrrec',
    num_member : 'Núm. membre',
    last_num_inserted: 'Núm. membre més recent: ',
    exporter_file_name: 'carrecs',
    qr_code: 'Codi QR',
    left: 'Donar de baixa',
    left_send_email: 'Enviar correu electrònic predefinit de baixa a la persona ara',
  },
  groups_quotes: {
    title: 'Periodicitats i imports',
    date_payment : 'Data de pagament',
    month_payment : 'Inici',
    period : 'Periodicitat',
    quantity: 'Import',
    apply_to_all: 'Aplicar la quota a tots els membres automàticament',
    is_donation: 'És un donatiu',    
    apply_to_all_list: 'S\'aplica automàticament',
    apply_to_all_donation: 'Aplicar a rebuts',
    apply_to_all_donation_title: 'Establir rebuts existents com a donatius',
    apply_to_all_donation_desc: 'Estàs segur que vols establir tots els rebuts ja emesos per aquesta quota com a donatius? Aquesta acció no es pot desfer.',
    apply_to_all_donation_ok: 'S\'han establert tots els rebuts d\'aquesta quota com a donatius',
    apply_to_all_donation_ko: 'No s\'ha pogut realitzar l\'acció',
  },
  users_groups_quotes : {
    group: 'Grup',
    group_quote : 'Quota',
    group_quote_period : 'Periodicitat',
    quantity : 'Import',
    discount_ini : 'Inici',
    discount_end : 'Fi',
    discount_percent : 'Dte (%)',        
    discount_quantity : 'Dte (€)',
    manual_quantity : 'Import manual (€)',
    comment: 'Comentari'
  },
  remittances: {
    tab_main: 'Remesa',
    tab_remittances_users: 'Rebuts',
    concept: 'Concepte',
    quantity: 'Import',
    date_creation : 'Data',
    count_users: 'Rebuts',
    sum_quantity : 'Import',
    sepa: 'Fitxer SEPA',
    pdf: 'Rebuts PDF',
    link_user: 'Persona',
    status: 'Estat',
    status0: 'Acceptat',
    status1: 'Impagat',
    statusFilterAll: 'Tots',
    statusFilter0: 'Acceptats',
    statusFilter1: 'Impagats',        
    payer: 'Pagador',
    iban: 'IBAN',
    nif: 'NIF',       
    status_form: 'Canviar estat del rebut', 
    status_new: 'Nou estat', 
    check_reemit: 'Es podrà tornar a generar el rebut en una nova remesa',
    check_sent_return_notification: 'Enviar la notificació d\'impagament al prémer Desar',
    comments: 'Observacions',
    comments_form: 'Observacions sobre l\'estat del rebut',
    default_name: 'Remesa_',
    groups_with_quotes: 'Generar automàticament els rebuts de',
    edit_state : 'Modificar',
    returns: 'Incorporar rebuts impagats d\'altres remeses',
    refresh_payer: 'Actualitzar dades',
    refresh_payer_confirm: 'S\'han actualitzat les dades de pagament de l\'usuari',
    no_remittances_users_title : 'remeses de rebuts',
    no_remittances_users_ask : 'Vols afegir-ne una?',
    payer_payment_cash : 'És un pagament en efectiu',
    payment_system : 'Forma de pagament',
    bank: 'Rebut bancari',
    cash : 'Efectiu',
    pdf_filename: 'rebuts',
    pdf_ok: 'El fitxer s\'ha generat correctament. Consulta la carpeta de descàrregues del navegador',
    ref: 'Ref.',
    resume_total_plural: 'contactes a la remesa',
    resume_total: 'contacte a la remesa',
    resume_bank_plural: 'rebuts domiciliats',
    resume_bank: 'rebut domiciliat',
    resume_cash_plural: 'rebuts en efectiu',
    resume_cash: 'rebut en efectiu',
    create: 'Afegir rebut', 
    create_remittance: 'Afegir remesa' ,
    check_partial_quotes: 'Incloure quotes proporcionals dels nous membres. Per exemple, si hi ha un nou membre al febrer i la propera quota periòdica no és fins el gener de l\'any següent, es generarà un rebut amb la part proporcional dels mesos restants.',
    name: 'Remesa',
    last_receips: 'Últims rebuts emesos',
    send_returned_notification_title: 'Enviar notificació d\'impagament',
    send_returned_notification_content: 'Segur que vols enviar-li el correu d\'impagament predefinit?',
    send_returned_notification_content_again: 'Ja s\'ha enviat anteriorment el correu. Segur que vols tornar a enviar-li el correu d\'impagament predefinit?',  
    send_returned_ko: 'El correu no s\'ha pogut entregar al destinatari',
    send_returned_tooltip_button: 'Enviar notificació d\'impagament',
    send_returned_tooltip_sending: 'S\'està enviant la notificació d\'impagament...',
    send_returned_tooltip_done: 'S\'ha enviat la notififcació d\'impagament',        
    exporter_file_name: 'rebuts',
    exporter_header_returned_status: 'Notificació d\'impagament enviada',
    is_donation: 'És un donatiu',    
  },   
  ibans : {
    create_iban: 'Afegir compte',
    public_id: 'Identificador',
    name: 'Nom del compte',
    ordering: 'Ordenant',
    iban: 'IBAN',
    swift: 'BIC/SWIFT',
    sufix: 'Sufix',
    nif: 'NIF/CIF',
    returns_tax: 'Comissió de devolució (€)',
    bank_country_iso: 'País (ISO)',        
    create: 'Afegir compte', 
    edit: 'Editar compte', 
    no_ibans: 'comptes configurats',
    name_create_remittance: 'Compte',
  },
  senders: {
    title: 'Remitents de correu electrònic',
    desc: 'Configuració dels remitents dels correus electrònics',
    smtp_settings_title: 'Configuració SMTP',
    smtp_settings_desc: 'Configura els servidors SMTP de plataforma.',
    smtp_settings_create: 'Afegir configuració SMTP',
    smtp_settings_edit: 'Modificar configuració SMTP',
    create: 'Afegir remitent',
    edit: 'Modificar remitent',
    email: 'Correu electrònic del remitent',
    platform_sender: 'Remitent genèric de la plataforma',
    name: 'Nom del remitent',
    name_vars: 'Variable disponible: %project_name%',
    context: 'Context',
    default_sender: 'Remitent genèric per defecte de la plataforma',
    context_0: 'Gestió d\'entitats',
    context_1: 'Entrades',
    platform_role: 'Rol',
    platform_role_none: 'Cap',
    platform_role_default_generic: 'Correu genèric per defecte',
    platform_role_platform_smtp: 'Servidor SMTP de plataforma',
    type: 'Tipus',
    type_0: 'Correu genèric de Gestió d\'entitats',
    type_0_desc: 'S\'enviarà amb una adreça genèrica de Gestió d\'entitats. No cal configurar DNS ni validar el remitent.',
    type_1: 'Servidor de correu de Gestió d\'entitats (SMTP)',
    type_1_desc: 'S\'utilitzarà la infraestructura SMTP de Gestió d\'entitats amb l\'adreça indicada per l\'entitat. Requereix configuració DNS del domini del correu per millorar l\'entregabilitat.',
    type_2: 'Amazon SES de Gestió d\'entitats',
    type_2_desc: 'S\'utilitzarà Amazon SES gestionat per la plataforma. És una opció estable, però el domini no queda verificat com a domini propi de l\'entitat.',
    type_3: 'Servidor de correu de l\'entitat (SMTP)',
    type_3_desc: 'L\'entitat utilitzarà el seu propi servidor SMTP. No requereix configuració DNS del domini. No controlem quins missatges han estat entregats al destinatari, retornats, oberts...',
    type_4: 'Plataforma AWS SES amb el domini de l\'entitat',
    type_4_desc: 'Requereix configuració DNS per millorar l\'entregabilitat. És l\'opció recomanada perquè millora la reputació, la traçabilitat i l\'entregabilitat. Hi ha control de quins missatges han estat entregats al destinatari, retornats, oberts...',
    type_4_disabled: 'Opció temporalment no disponible.',
    type_4_recommended: 'Plataforma AWS SES amb el domini de l\'entitat',
    dns_configuration: 'Configuració DNS',
    dns_configuration_help: 'Afegeix aquests registres DNS al domini del correu electrònic perquè el remitent pugui quedar validat.',
    dns_configuration_help_smtp_own: 'Es comprova si el domini del correu electrònic disposa de SPF i DMARC. En SMTP propi no es recomana cap valor concret perquè depèn del servidor que faci l\'enviament.',
    dns_check: 'Refrescar',
    dns_download_document: 'Descarregar document',
    dns_download_error: 'No s\'ha pogut descarregar el document DNS.',
    dns_found: 'Registre trobat',
    dns_not_found: 'Registre no trobat',
    dns_status: 'Estat del DNS',
    dns_record_type: 'Tipus de registre',
    dns_record_value: 'Valor',
    dns_expected_value: 'Valor que cal configurar',
    dns_recommended_value: 'Valor recomanat',
    dns_spf_merge_help: 'Si ja tens un SPF, no el substitueixis ni n\'afegeixis un de nou: afegeix-hi només els includes necessaris i conserva la resta d\'IPs o dominis.',
    dns_current_values: 'Valors actuals',
    dns_valid: 'La configuració DNS és correcta.',
    dns_invalid: 'Encara falten registres DNS o no coincideixen amb els valors esperats.',
    dns_no_records: 'Aquest tipus de remitent no requereix configuració DNS.',
    dns_ses_not_enabled: 'Amazon SES no està activat en aquest entorn. Quan s\'activi, es mostraran aquí els registres DNS reals que cal configurar.',
    dns_verified_at: 'DNS validat el',
    dns_not_verified_tooltip: 'DNS no validat',
    domain: 'Domini',
    smtp_configuration: 'Configuració SMTP',
    smtp_active: 'Actiu',
    smtp_active_yes: 'SMTP actiu',
    smtp_active_no: 'SMTP inactiu',
    smtp_host: 'Servidor SMTP',
    smtp_port: 'Port',
    smtp_username: 'Usuari SMTP',
    smtp_pswd: 'Contrasenya',
    smtp_protocol: 'Protocol',
    smtp_ssl: 'Protocol SSL/TLS',
    smtp_auth: 'Requereix autenticació',
    smtp_starttls: 'Usa STARTTLS',
    smtp_test: 'Prova SMTP',
    smtp_verified_at: 'SMTP comprovat el',
    smtp_not_verified_tooltip: 'SMTP no comprovat',
    smtp_test_ok: 'Connexió SMTP correcta.',
    smtp_test_ko: 'No s\'ha pogut connectar amb l\'SMTP.',
    duplicate: 'Duplicar remitent',
    duplicate_confirm: 'Vols duplicar aquest remitent?',
    duplicate_ok: 'S\'ha duplicat el remitent.',
    delete: 'Esborrar remitent',
    validation_request: 'Enviar petició de validació',
    validation_request_confirm: 'Vols enviar la petició de validació de remitent?',
    validation_request_disabled: 'Cal indicar un correu electrònic vàlid abans de demanar la validació',
    validation_request_ok: 'S\'ha enviat la petició de validació.',
    validation_not_required_ses: 'No cal validar el correu electrònic. Amb Amazon SES es valida el domini mitjançant DNS.',
    apply_templates: 'Fes servir aquest remitent per totes les plantilles de correu',
    apply_templates_disabled: 'Només es pot aplicar un remitent validat',
    apply_templates_confirm: 'Segur que vols aplicar aquest remitent a totes les plantilles de correu corresponents?',
    apply_templates_ok: 'S\'ha aplicat el remitent a les plantilles de correu.',
    validate_email: 'S\'enviarà una petició de confirmació al correu electrònic',
    actived: 'Estat',
    actived_0: 'Pendent de validar',
    actived_1: 'Validat',
    validated_at: 'Remitent validat el',
    validate_ok: 'El teu correu s\'ha validat correctament.',
    validate_ko: 'El teu correu no s\'ha pogut validar. L\'enllaç no és vàlid o ha caducat.',
  }, 
  payment_systems: {
    main_menu_title: 'Passarel·les bancàries',
    create: 'Afegir passarel·la',
    edit: 'Modificar passarel·la',
    public_id: 'Identificador',
    plattform: 'Tipus',
    plattform_0: 'Redsys',
    plattform_1: 'Addon Payments',
    name: 'Nom',
    merchant: 'Comerç',
    pswd: 'Contrasenya',
    terminal: 'Terminal / Account',
    url_ok: 'Url retorn OK',
    url_ko: 'Url retorn KO',
    url_async: 'Url de notificació',
    real: 'Entorn real',
    url: 'Url connexió (mode REAL)',
    url_test: 'Url connexió (mode TEST)',
    currency: 'Moneda',
    encrypt: 'Clau d\'encriptació',
    transaction_type: 'Tipus de transacció',
    exporter_file_name: 'pasarelles',
  }, 
  donations_projects: {
    id: 'Id projecte',
    main_menu_title: 'Donatius',
    associations_id: 'Id entitat',
    associations_name: 'Entitat',
    reports_title: 'Projectes per a rebre donacions de les entitats federades',    
    name: 'Projecte',
    create: 'Afegir projecte',
    description_short: 'Descripció curta per mostrar al llistat públic de projectes',
    description: 'Descripció llarga',
    video: 'Adreça de vídeo Youtube',
    date_start: 'Inici de la campanya',
    date_finish: 'Finalització',
    minimum_amount: 'Import mínim del donatiu (€)',
    amount: 'Objectiu recaptació (€)',
    public_entity: 'Públic a la web',
    public_fac: 'Públic a la web de la FAC',
    public_fac_date: 'Data límit publicació',
    public_sum_donations: 'Publicar total aportacions',
    payment_card: 'Targeta',
    payment_systems_id: 'Passarel·la de pagament',
    payment_systems_fac: 'Formes de pagament de la FAC',
    payment_transfer: 'Transferència bancària',
    payment_transfer_ibans_id: 'Al compte bancari',
    ibans_iban: 'Abonament al compte bancari',
    legal_text_1: 'Text legal',
    legal_text_2: 'Text legal',
    legal_text_3: 'Paràgraf de justificació en el certificat de donació',
    confirmation_text_1: 'Text de confirmació',
    confirmation_text_2: 'Text de confirmació',
    confirmation_email_1: 'Text correu-e de confirmació',
    count_donations: 'Finançadors',
    sum_donations: 'Import finançadors',
    sum_donations_percent: '% recaptat',
    remaining_days: 'Temps restant',
    minute: 'minut',
    minutes: 'minuts',
    hour: 'hora',
    hours: 'hores',
    day: 'dia',
    days: 'dies',
    seconds: 'segons',
    second: 'segon',
    filter_only_current: 'Projectes vigents',
    only_pending: 'Pendents de validació',
    event_data: 'Dades de l\'esdeveniment',
    event_type: 'Tipus d\'esdeveniment',
    event_without_registrations: 'Sense inscripcions',
    event_with_registrations_ticketing: 'Amb inscripcions i/o venda d\'entrades',
    session_data: 'Dades de la sessió',
    place: 'Lloc',
    organization: 'Organització',
    visibility: 'Visualització',
    seating_map: 'Mapa de butaques',
    default_price: 'Preu per defecte',
    tickets_on_sale: 'Número d\'entrades a la venda',
    ticketing_later_values_hint: '* Més endavant podràs modificar aquests valors',
    images: 'Imatges',
    legal_text: 'Textos legals',
    payment_systems: 'Forma de pagament',
    public: 'Publicació',
    preview: 'Previsualització',
    view: 'Web',
    fac_validation_status: 'Validació FAC',
    fac_validation_status_0: 'Mode edició',
    fac_validation_status_1: 'Pendent de validació',
    fac_validation_status_2: 'Validat',
    fac_validation_status_3: 'Rebutjat',
    fac_validation_actions: 'Accions',
    fac_validation_actions_1: 'Sol·licitar validació',
    edit: 'Modificar',
    validate: 'Validar',
    target_by_date: 'Objectiu en un interval de dates',
    reports: 'Donatius: Projectes de les entitats',
    reports_desc: 'Validar els projectes de les entitats federades, consultar mecenes i afegir donatius en efectiu o transferència bancària.',
    reports_transfer_validations: 'Donatius: Validació de transferències bancàries',    
    reports_transfer_validations_desc: 'Validar els donatius realitzats mitjançant transferència bancària.',
    reports_payments: 'Donatius: Pagaments a les entitats',
    reports_payments_desc: 'Consulta dels imports a transferir a les entitats',
    reports_certificates: 'Donatius: Certificats de donació',
    reports_certificates_desc: 'Genera els certificats de donació',    
    validate_request: 'Sol·licitar validació',
    validate_request_button: 'Sol·licitar',
    validate_request_desc: 'Sol·licitar que la FAC revisi i validi el projecte per a publicar-se i poder començar a rebre donatius. A partir d\'aquest moment no podreu modificar el projecte',
    exporter_file_name: 'projectes',
    view_web: 'Veure a la web',
    friendly_url: 'Identificador a URL',
    city: 'Població',
    phone: 'Telèfon de contacte',
    email: 'Correu-e de contacte',
    comments_actived: 'Comentaris actius',
    contact_data: 'Dades de contacte',
  }, 
  utils : {
    copy_clipboard_success: 'S\'ha copiat al porta-retalls',
    copy_clipboard_error: 'No s\'ha pogut copiar al porta-retalls',
  },
  public_donations_projects: {
    not_actived: 'L\'entitat no té projectes de donatius actius',
    for: 'Per',
    live: 'En marxa!',
    early: 'Començarà aviat',
    finished: 'Finalitzat!',
    count_donations: 'Finançadors',
    goal: 'Objectiu',
    view_all_projects: 'Tots els projectes',
    remain: 'Queden',
    remain_1: 'Queda',
    win: 'Aconseguits',
    more_info: '+ Info',
    contribute: 'Aportar',
    association_not_found : 'L\'entitat no s\'ha trobat o hi ha hagut un error',
    not_found : 'El projecte no s\'ha trobat o hi ha hagut un error',
    view_web: 'Agenda web',
    go_back: 'Tornar enrere',
    search: 'Cercar',
    filter_date_after: 'Comença després de',
    filter_date_before: 'Comença abans de',
    filter_organizer_all: 'Totes les entitats',
    comments: 'Comentaris de finançadors',
    ago: 'fa',
    close: 'D\'acord',
    return: 'Tornar',
    preview: 'Aquesta pàgina és una previsualització del projecte'
  },
  donations_users: {
    main_menu_title: 'Finançadors',
    create: 'Afegir donatiu',
    create_to: 'Fer aportarció a ',
    edit: 'Modificar',
    cancel: 'Cancel·lar',
    pay: 'Pagar',
    donations_projects_id: 'Id projecte',
    donations_projects_name: 'Nom projecte',
    associations_id: 'Id entitat',
    associations_name: 'Entitat',
    order_id: 'Referència',
    date_time: 'Data donació',
    user_type: 'Persona',
    first_name: 'Nom',
    last_name_1: 'Cognom 1',
    last_name_2: 'Cognom 2',
    email: 'Correu-e',
    nif: 'DNI/NIF',
    address: 'Adreça',
    zip: 'Codi postal',
    city: 'Població',
    country: 'País',
    phone: 'Telèfon',
    payment_method: 'Forma de pagament',
    payment_method_0: 'Transferència',
    payment_method_1: 'Targeta',
    payment_method_2: 'Efectiu',
    amount: 'Import',
    status: 'Estat',
    status_0: 'Pendent',
    status_1: 'Confirmat',
    status_2: 'Rebutjat',
    date: 'Data de l\'ingrés',    
    send_confirmation: 'Enviar correu de confirmació al donant',
    transaction_id: 'Codi de transacció',
    comment: 'Comentari',
    certificate: 'Certificat donació',
    send_status: 'Certificat enviat',
    send_date_time: 'Data enviament',
    confirmation_status: 'Confirmació enviada al donant',
    confirmation_date_time: 'Data enviament',
    only_accepted: 'Només pagaments confirmats',
    only_pending: 'Només pagaments pendents',    
    only_certificate_not_sent: 'Només certificats no enviats',
    pdf_download: 'Descarregar',
    validate: 'Confirmar',
    validate_transfer: 'Confirmar transferència',
    pdf_certificate_filename: 'certificat_donacio.pdf',
    pdf_certificate_ok: 'El certificat de donació s\'ha generat amb èxit. Consulteu la carpeta de descàrregues del navegador.',
    pdf_certificate_ko: 'El certificat de donació no s\'ha pogut generar.',
    actions: 'Accions',
    email_sent: 'Certificat de donació',
    email_sent_title: 'Certificat de donació',
    email_sent_ask: 'Segur que vols enviar-li el certificat de donació?' ,  
    email_sent_ask_all: 'Segur que vols enviar el certificat de donació predefinit a totes les persones que encara no s\'hagi enviat?' ,  
    email_sent_ask_again: 'Ja s\'ha enviat anteriorment el certificat de donació. Segur que vols tornar a enviar-li?',        
    email_send_all_button: 'Certificats de donació',
    email_send_all_button_title: 'Enviar certificats de donació',
    email_sent_ko: 'El certificat de donació no s\'ha pogut entregar al destinatari',
    email_sent_tooltip_button: 'Enviar certificat de donació',
    email_sent_tooltip_sending: 'S\'està enviant el certificat de donació...',
    email_sent_tooltip_done: 'S\'ha enviat el certificat de donació',
    email_sent_confirmation: 'Confirmació del donatiu',
    email_sent_confirmation_title: 'Confirmació del donatiu',
    email_sent_confirmation_ask: 'Segur que vols enviar-li la confirmació de la donació?' ,  
    email_sent_confirmation_ask_again: 'Ja s\'ha enviat anteriorment la confirmació de la donació. Segur que vols tornar a enviar-li?',        
    email_sent_confirmation_ko: 'La confirmació del donatiu no s\'ha pogut entregar al destinatari',
    email_sent_confirmation_tooltip_button: 'Enviar confirmació del donatiu',
    email_sent_confirmation_tooltip_sending: 'S\'està enviant confirmació del donatiu...',
    email_sent_confirmation_tooltip_done: 'S\'ha enviat la confirmació del donatiu',
    exporter_file_name: 'financadors',
    want_certificate: 'Vol certificat de donació',
    copy: 'Copiar',
    copy_title: 'Copiar transferència',
    donations_users_rel: 'Donatiu relacionat'
  }, 
  donations_certificates : {
      title: 'Certificats de donació',
      generate: 'Veure',
      status : 'Estat enviament',
      date_time : 'Data enviament',
      exporter_file_name: 'certificats',
  },
  donations_model_182: {
      title: 'Donatius: model 182',
      menu_description: 'Revisa els donatius que es poden declarar i genera el fitxer del model 182.',
      description: 'Els donatius inclosos s’agrupen per NIF i, per als partits polítics, també per clau F/G. Els exclosos no formaran part del fitxer mentre no es corregeixi el motiu indicat.',
      included_title: 'Dades que es poden incloure',
      included_description: 'Donants amb les dades necessàries per incorporar-los al model 182. Els donatius inclosos s’agrupen per NIF i, per als partits polítics, també per clau F/G.',
      excluded_title: 'Dades que no es poden incloure',
      excluded_description: 'Donatius que no es poden incorporar al model amb les dades actuals.',
      generate_button: 'Generar model 182',
      configure_entity_fiscality: 'Configurar la fiscalitat de l’entitat',
      file_name_prefix: 'model',
      receipt_number: 'Número de justificant (13 dígits, començant per 182)',
      receipt_number_invalid: 'El número de justificant ha de començar per 182 i tenir 13 dígits.',
      contact_phone: 'Telèfon de contacte (9 dígits)',
      contact_phone_invalid: 'El telèfon de contacte ha de tenir 9 dígits.',
      contact_name: 'Cognoms i nom de la persona de contacte',
      entered_when_generating: 'S’introdueix en el moment de generar el model',
      generate_success: 'El fitxer del model 182 s’ha generat correctament.',
      generate_error: 'No s’ha pogut generar el fitxer del model 182.',
      summary_error: 'No s’ha pogut carregar el resum del model 182.',
      fiscal_years_error: 'No s’han pogut consultar els exercicis configurats del model 182.',
      no_fiscal_years: 'No hi ha cap exercici configurat per generar el model 182. Contacta amb l’administrador de la plataforma.',
      loading_fiscal_years: 'Carregant els exercicis disponibles…',
      previous_year_not_configured: 'L’exercici anterior (%year%) encara no està configurat per Superadmin. Selecciona un altre exercici configurat o contacta amb l’administrador de la plataforma.',
      nif: 'NIF',
      donor: 'Donant',
      amount: 'Import',
      total: 'Total',
      exclusion_reason: 'Motiu',
      no_data: 'No hi ha dades.',
      open_user: 'Obrir la fitxa del contacte',
      edit_donation: 'Modificar el donatiu',
      reason_missing_nif: 'Falta el NIF',
      reason_invalid_nif: 'El NIF no té un format admès',
      reason_missing_name: 'Falta el nom o la raó social',
      reason_invalid_amount: 'L’import no és vàlid',
      reason_invalid_user_type: 'No consta si és persona física o jurídica',
      reason_conflicting_user_type: 'El mateix NIF consta com a persona física i jurídica',
      reason_invalid_province: 'Falta el codi postal o la província no és vàlida',
      reason_political_legal_donor: 'Els partits polítics no poden rebre donatius o aportacions de persones jurídiques',
      reason_invalid_political_key: 'La quota o aportació no té una clau F/G vàlida',
      generation_error_invalid_association_nif: 'Cal configurar un NIF vàlid per a l’entitat abans de generar el model.',
      generation_error_missing_association_name: 'Cal configurar el nom de l’entitat abans de generar el model.',
      generation_error_unsupported_declarant_nature: 'La naturalesa fiscal seleccionada requereix dades per donatiu que el mòdul actual no recull i encara no permet generar el model 182.',
      generation_error_missing_declarant_nature: 'Cal configurar la naturalesa fiscal de l’entitat abans de generar el model 182.',
      generation_error_ambiguous_autonomous_deduction: 'Hi ha més d’una deducció autonòmica seleccionada amb percentatges diferents per al mateix exercici i comunitat. Cal deixar-ne només una o configurar-les amb el mateix percentatge.',
      fiscal_data_title: 'Criteris fiscals aplicats',
      fiscal_data_description: 'Aquestes són les dades de configuració i els percentatges que s’utilitzaran per generar el fitxer.',
      autonomous_deductions_title: 'Deduccions autonòmiques assignades per a aquest exercici',
      autonomous_deductions_none: 'No hi ha cap deducció autonòmica assignada per a aquest exercici.',
      autonomous_community: 'Comunitat autònoma',
      autonomous_deduction: 'Deducció autonòmica',
      declarant_nature: 'Naturalesa del declarant',
      deduction_key: 'Clau del donatiu',
      deduction_key_a: 'Donatiu ordinari no inclòs en activitats prioritàries de mecenatge',
      deduction_key_f: 'Quotes d’afiliació i aportacions a partits polítics',
      deduction_key_g: 'Altres donacions i aportacions rebudes per partits polítics',
      deduction_key_f_g: 'F / G - Quotes, aportacions i donatius a partits polítics',
      percentage_source: 'Origen dels percentatges',
      percentage_source_statutory_by_year: 'Calculats segons la normativa de l’exercici',
      percentage_source_entity_configuration: 'Configurats a les dades de l’entitat',
      percentage_source_superadmin_year_configuration: 'Configurats per Superadmin per a aquest exercici',
      percentage_source_not_supported: 'No disponible',
      percentage_source_not_configured: 'Sense configurar',
      donor_type: 'Tipus de donant',
      donor_type_individual: 'Persona física',
      donor_type_legal: 'Persona jurídica',
      tranche: 'Tram de l’import anual',
      tranche_first: 'Primers %amount% €',
      tranche_remainder: 'Import que excedeix de %amount% €',
      tranche_full: 'Import complet',
      tranche_affiliation: 'Quota d’afiliació o aportació',
      recurrence: 'Recurrència',
      recurring_yes: 'Sí',
      recurring_no: 'No',
      percentage: 'Percentatge de deducció',
      detail: 'Detall',
      open_detail: 'Veure el detall del càlcul',
      detail_title: 'Detall del càlcul',
      income_history: 'Ingressos utilitzats per exercici',
      year: 'Exercici',
      source: 'Origen',
      source_donation: 'Donatiu',
      source_remittance: 'Rebut emès',
      date: 'Data',
      concept: 'Concepte o projecte',
      no_income_found: 'No s’han trobat ingressos en aquest exercici',
      applied_tranches: 'Trams aplicats a l’import de l’exercici',
      no_applied_tranches: 'No s’aplica cap tram perquè el registre està exclòs del model.',
      deduction_amount: 'Deducció calculada',
      applied_tranche_first_tranche: 'Primer tram',
      applied_tranche_remainder: 'Resta de l’import',
      applied_tranche_full_amount: 'Import complet',
      applied_tranche_affiliation: 'Quota d’afiliació o aportació',
      recurrence_previous_two_years_required: 'Cal trobar ingressos en els dos exercicis anteriors.',
      recurrence_amounts_must_not_decrease: 'Hi ha ingressos en els dos exercicis anteriors, però algun import disminueix respecte de l’any precedent.',
      recurrence_income_found_for_three_years_without_decrease: 'S’han trobat ingressos en els tres exercicis i els imports no disminueixen.',
      recurrence_not_evaluated_invalid_nif: 'No es pot comparar l’històric perquè el NIF no és vàlid.',
      recurrence_not_evaluated_missing_nif: 'No es pot comparar l’històric perquè falta el NIF.',
      recurrence_not_evaluated: 'No s’ha pogut avaluar la recurrència.',
  },
  donations_payments : {
      title: 'Pagaments a les entitats',
      date_from: 'Des de',
      date_to: 'Fins',
      generate: 'Veure',      
      reports_title: 'Pagament de les donacions a les entitats entre el %date_from% i %date_to%',
      exporter_file_name: 'pagaments'
  },
  postal_labels : {
    create: 'Afegir format',
    edit: 'Editar format',
    name: 'Nom',
    colxrows: "Columnes x files",
    margins_cell: "Marges de l'etiqueta (cm)",
    margins_page: "Marges de la pàgina (cm)",
    num_columns: "Núm. columnes",
    num_rows: "Núm. files",   
    template: "Plantilla",
    available_fields: "Camps disponibles:",
    fields: "%nom% | %cognom1% | %cognom2% | %adreca% | %cp% | %poblacio% | %comarca% | %provincia% | %pais%",
    font_size: "Mida de lletra (punts)",
    line_separator: "Separació entre línies (punts)",
    margin_cell_left: "Esquerre",
    margin_cell_top: "Superior",
    margin_cell_right: "Dret",
    margin_cell_bottom: "Inferior",
    margin_page_left: "Esquerre",
    margin_page_top: "Superior",
    margin_page_right: "Dret",
    margin_page_bottom: "Inferior",
    last_row: "Emplenar l'última fila de cada pàgina",
    priority: "Ordre",    
    generate_button_title : "Etiquetes",
    generate_modal_title : "Generar etiquetes postals",
    generate_modal_desc : "Vols generar un document PDF (DIN A4) amb les etiquetes de les adreces postals dels contactes?",
    generate_modal_button : "Generar",
    generate_format : "Format de la pàgina (columnes x files)",    
    generate_pdf_filename: "etiquetes.pdf",
    generate_ok_message : "Les etiquetes s'han generat amb èxit. Consulteu la carpeta de descàrregues del navegador.",
    add_formats: "Afegir formats",
  },
  classrooms: {
    no_classrooms_title : 'Encara no hi ha espais',
    no_classrooms_ask : 'Vols afegir-ne un?',
    create: 'Afegir espai',
    seats: 'Capacitat (persones)',
    type: 'Tipus d\'espai',
    type0: 'Cafeteria / Restaurant',
    type1: 'Teatre',
    type2: 'Sala exposicions',
    type3: 'Arxius',
    type4: 'Biblioteca',
    type5: 'Equipaments esportius',
    type6: 'Sales polivalents',
    type7: 'Sales de cinema',
    type8: 'Auditori',
    type9: 'Jardí/Pati exterior',
    type10: 'Altres',
    m2: 'Mida (m2)',
    is_public: 'L\'espai és visible a la pàgina web',
    show_fac: 'L\'espai és visible a la pàgina de la FAC',
    is_requestable: 'Es pot demanar l\'ús d\'aquest espai a través de la pàgina web',
    is_for_events: 'Es poden programar esdeveniments en aquest espai',
    data: 'Dades',
    photos: 'Fotografies',
    docs: 'Fitxa tècnica',
    color: 'Color en el calendari',
    overlapable: 'Es permet la superposició d\'esdeveniments en aquest espai',
    link_back: 'Tornar',
    accessible: 'És accessible',
    cession: 'En cessió',
    rent: 'Llogat',
    rentable: 'Disponible per a llogar',
    lift: 'Té ascensor',
    visibility: 'Visibilitat',
    events: 'Esdeveniments',
    outdoor: 'És exterior',
  },

  events_sessions: {
    title: 'Sessions',
    name: 'Nom de la sessió',
    type: 'Tipus de sessió',
    type0: 'Entrades no numerades',
    type1: 'Entrades numerades amb mapa de seients',
    type2: 'Fila 0 (col·laboració sense entrada)',
    session_date_section: 'Data de la sessió',
    payment_period_section: 'Data límit de pagament de les reserves',
    reservation_payment_period_finish: 'Data límit de pagament de les reserves',
    access_section: 'Accés',
    update_price_periods_title: "Actualitzar els horaris i períodes de la sessió?",
    update_price_periods_description: "Has modificat la data d’inici o de finalització de la sessió. Què vols fer amb l’obertura de portes, el període de validació d’entrades i les dates de venda i reserva de les tarifes?",
    update_price_periods_keep: 'Mantenir les dates',
    update_price_periods_keep_description: "Manté les dates d’obertura de portes, validació, venda i reserva sense desplaçar-les ni recalcular-les.",
    update_price_periods_shift: 'Desplaçar les dates',
    update_price_periods_shift_description: "Desplaça les dates de venda i reserva amb la sessió. L’obertura de portes i l’inici de validació segueixen el canvi de l’inici; el final de validació segueix el canvi del final.",
    update_price_periods_defaults: 'Recalcular',
    update_price_periods_defaults_description: "Recalcula l’obertura de portes, la validació i les dates de venda i reserva segons la configuració general de l’entitat, substituint les dates personalitzades.",
    date_start: 'Data inici',
    date_finish: 'Data final',
    sale_start: 'Data inici venda',
    sale_finish: 'Data final venda',
    box_office_start: 'Data inici venda a guixeta',
    box_office_finish: 'Data final venda a guixeta',
    validators_start: 'Data validadors inici',
    validators_finish: 'Data validadors final',
    open_doors_start: 'Obertura de portes',
    create: 'Afegir sessió',
    total_capacity: 'Aforament màxim',
    total_assistants: 'Total Assistents',
    map: 'Mapa de butaques',
    without_map: 'Sense mapa',
    actived: 'Activa',
    duplicate: 'Duplicar',    
    delete_all_confirm_title: 'Confirmació d\'eliminació de %num_registers% sessió/ns',
    delete_all_confirm_description: 'S\'esborrarà la configuració de les sessions seleccionades: dates, preus, validadors i qualsevol dada associada.',
    delete_all_confirm_ask: 'Segur que vols esborrar les sessions seleccionades?',
    delete_all_min_remaining_error: 'No es poden esborrar totes les sessions. Com a mínim ha de quedar una sessió.',
    prices: 'Tarifes',
    validators: 'Validadors'
  }, 
  events_sessions_prices: {
    title: 'Preus',
    create: 'Afegir tarifa',
    delete_title: 'Eliminar tarifa',
    delete_ask: 'Segur que vols eliminar aquesta tarifa?',
    tickets_groups_id: 'Tarifa',
    price: 'Preu',
    priority: 'Ordre',
    total_capacity: 'Màxim d\'entrades',
    actived: 'Venda en línia',
    box_office_sale_enabled: 'Venda a guixeta',
    audience_type: 'Públic que pot adquirir aquest tipus d\'entrades',
    audience_type_0: 'Tothom',
    audience_type_0_desc: 'Tothom pot adquirir aquest tipus d\'entrada',
    audience_type_1: 'Abonats',
    audience_type_1_desc: 'Només els abonats poden adquirir aquest tipus d\'entrada. L\'usuari haurà d\'introduir el codi d\'abonat que se li ha facilitat en el moment de comprar l\'abonament.',
    audience_type_2: 'Codi',
    audience_type_2_desc: 'S\'haurà d\'introduir un codi per poder adquirir aquest tipus d\'entrada',
    audience_type_3: 'Grup de contactes',
    audience_type_3_desc: 'Només els membres d\'un grup de contactes poden adquirir aquest tipus d\'entrada. L\'usuari haurà d\'estar autenticat en el moment de fer la compra i el correu electrònic d\'autenticació ha de coincidir amb el correu electrònic principal del contacte.',
    audience_code_min_length: 'Longitud mínima del codi',
    audience_code_max_length: 'Longitud màxima del codi',
    audience_groups_id: 'Grup de contactes',
    audience_max_tickets_per_contact_session: 'Màxim número d\'entrades per contacte i sessió',
    edit_group: 'Editar tarifa',
    sale_start: 'Data inici venda',
    sale_finish: 'Data final venda',
    box_office_start: 'Data inici venda a guixeta',
    box_office_finish: 'Data final venda a guixeta',
    online_sales: 'Venda d\'entrades en línia',
    box_office_sales: 'Venda d\'entrades a guixeta',
    validators: 'Validació d\'entrades',
    reservations: 'Reserves',
    box_office_reservation_enabled: 'Reserves a guixeta',
    reservation_period_start: 'Inici del període per fer reserves',
    reservation_period_finish: 'Fi del període per fer reserves',
  },
  
  events_sessions_validators: {    
    create: 'Afegir validador',    
    send_email: 'Enviar correu electrònic amb l\'enllaç ara',
    active: 'Actiu',
    link: 'Enllaç de validació d\'entrades',
    send_link: 'Enviament de l\'enllaç',
    email_sent: 'Enllaç de validació',
    email_sent_tooltip_button: 'Enviar enllaç de validació',
    email_sent_tooltip_sending: 'S\'està enviant l\'enllaç de validació...',
    email_sent_tooltip_done: 'S\'ha enviat l\'enllaç de validació',
    email_sent_ko: 'L\'enllaç de validació no s\'ha pogut entregar al destinatari',
    email_sent_title: 'Enllaç de validació',
    email_sent_ask: 'Segur que vols enviar-li l\'enllaç de validació?' ,  
    email_sent_ask_again: 'Ja s\'ha enviat anteriorment l\'enllaç de validació. Segur que vols tornar a enviar-li?',        
  }, 

  events_topics: {
    title: 'Temes d\'esdeveniments',
    create: 'Afegir tema',
    name: 'Nom',
    url: 'URL',
    friendly_url: 'URL amigable',
    description: 'Descripció',
    actived: 'Actiu',
    public_page: 'Pàgina pública',
    delete_title: 'Esborrar tema',
    delete_content: 'Segur que vols esborrar aquest tema? També s\'esborraran les relacions amb els esdeveniments.',
    delete_success: 'Tema esborrat',
    image_width_prompt: 'Amplada de la imatge (ex: 300, 50% o auto)',
    image_height_prompt: 'Al\u00e7ada de la imatge (deixa-ho buit o auto per mantenir proporci\u00f3)',
    exporter_file_name: 'temes',
  },

  events_topics_items: {
    title: 'Esdeveniments',
    create: 'Afegir esdeveniment',
    event: 'Esdeveniment',
    association: 'Entitat',
    events_id: 'Esdeveniment',
    events_topics_id: 'Tema',
    date_start: 'Data inici',
    date_finish: 'Data final',
    label: 'Etiqueta',
    order: 'Ordre',
    exporter_file_name: 'esdeveniments_tema',
  },

  events_categories: {
    title: 'Categories d\'esdeveniments',
    visible_in_categories: 'Visible en les següents categories',
    create: 'Afegir categoria',
    name: 'Nom',
    actived: 'Activa',
    order: 'Ordre',
    exporter_file_name: 'categories_esdeveniments',
  },

  tickets: {
    title: 'Configuració de venda d\'entrades',
    description: 'Configuració sobre la venda d\'entrades i inscripcions a esdeveniments'    
  }, 

  tickets_general: {
    event_access: "Accés a l'esdeveniment",
    tickets_validators_start_minutes: 'Inici de validació (minuts abans de l’inici)',
    tickets_validators_finish_minutes: 'Final de validació (minuts després del final)',
    tickets_open_doors_minutes: 'Obertura de portes (minuts abans de l’inici)',
    tickets_max_per_purchase: 'Màxim d’entrades per compra',


    taxes: 'Impostos',
    management_fees: 'Despeses de gestió',
    vat_percent_default: 'IVA per defecte de les entrades (%)',
    vat_included_default: 'L’IVA està inclòs en el preu per defecte',
    management_fees_included_default: 'Les despeses de gestió estan incloses en el preu per defecte',
    vat_percent: 'IVA de les entrades (%)',
    vat_included: 'L’IVA està inclòs en el preu',
    management_fees_included: 'Les despeses de gestió estan incloses en el preu',
    title: 'Configuració general',
    desc: 'Valors per defecte de venda de les tarifes de cada sessió',
    enabled: 'Venda d\'entrades activa',
    online_sale_period: 'Període per defecte de venda en línia',
    box_office_sale_period: 'Període per defecte de venda a guixeta',
    ticket_header_logo: 'Logo superior de l\'entrada',
    start_days: 'Inici (dies abans de la sessió, a les 08:00)',
    finish_days: 'Final (dies abans de la fi de la sessió; 0 manté la data i hora de fi)',
  },

  tickets_reservations: {
    reservation_payment: 'Pagament de reserves',
    title: 'Reserves i venda d\'entrades a guixeta',
    desc: 'Configuració de les reserves i vendes fetes des de guixeta',
    box_office_sale_enabled: 'Es poden fer vendes a guixeta',
    enabled: 'Es poden fer reserves a guixeta',
    booking_period: 'Període per defecte per poder fer reserves a guixeta',
    payment_period: 'Data límit de pagament per defecte',
    start_days: 'Inici (dies abans de la sessió)',
    end_days: 'Final (dies abans de la sessió)',
    payment_deadline_days: 'Data límit de pagament (dies abans de la sessió)',
    payment_reminder_hours: 'Avís de pagament de la reserva (hores abans de la data límit)',
    auto_cancel: 'Cancel·lació automàtica de les reserves no pagades',
    auto_cancel_delay_hours: 'Hores posteriors a la data límit per cancel·lar automàticament la reserva',
    notify_box_office_users: 'Enviar notificacions a tots els usuaris de guixeta',
    ibans_id: 'Compte per ingressar les reserves',
  },
  

  tickets_groups : {
      title: 'Tarifes',
      desc: 'Configuració sobre les tarifes dels esdeveniments',    
      create: 'Afegir tarifa',   
      edit: 'Editar tarifa',
      audience_type: 'Públic que pot adquirir aquest tipus d\'entrades',
      audience_type_0: 'Tothom',
      audience_type_0_desc: 'Tothom pot adquirir aquest tipus d\'entrada',
      audience_type_1: 'Abonats',
      audience_type_1_desc: 'Només els abonats poden adquirir aquest tipus d\'entrada. L\'usuari haurà d\'introduir el codi d\'abonat que se li ha facilitat en el moment de comprar l\'abonament.',
      audience_type_2: 'Codi',
      audience_type_2_desc: 'S\'haurà d\'introduir un codi per poder adquirir aquest tipus d\'entrada',
      audience_type_3: 'Grup de contactes',
      audience_type_3_desc: 'Només els membres d\'un grup de contactes poden adquirir aquest tipus d\'entrada. L\'usuari haurà d\'estar autenticat en el moment de fer la compra i el correu electrònic d\'autenticació ha de coincidir amb el correu electrònic principal del contacte.',
      audience_code_min_length: 'Longitud mínima del codi',
      audience_code_max_length: 'Longitud màxima del codi',
      audience_groups_id: 'Grup de contactes',
      audience_max_tickets_per_contact_session: 'Màxim número d\'entrades per contacte i sessió',
      priority: 'Ordre',    
      apply_default: 'Afegir automàticament a les noves sessions',
      require_check: 'El validador necessitarà comprobar algun document addicional (DNI, carnet de membre...)',
      require_check_message: 'Missatge que veurà el validador',
  },
  events_subscriptions : {
    publication_period: 'Període de publicació',
    title: 'Abonaments',
    desc: 'Llistat dels abonaments disponibles',
    create: 'Crear abonament',
    images: 'Imatges',
    prices: 'Preus',
    events: 'Esdeveniments',
    event: 'Esdeveniment',
    add_price: 'Afegir tarifa',
    add_event: 'Afegir esdeveniment',
    publication_start: 'Data d\'inici de publicació a la web',
    publication_finish: 'Data final de publicació a la web',
    sale_start: 'Data d\'inici de compra a la web',
    sale_finish: 'Data final de compra a la web',
    total_capacity: 'Unitats a la venda',
    events_count: 'Esdeveniments',
    type_code: "L'usuari rep un codi d'abonament per correu electrònic i selecciona les entrades posteriorment",
    type_tickets: "L'usuari selecciona les entrades en el moment d'adquirir l'abonament",
    allow_different_sessions: 'Es poden comprar entrades de diferents sessions pel mateix esdeveniment',
    tickets_limit_mode: 'Entrades incloses',
    tickets_limit_one_each_event: 'Una per cada esdeveniment',
    tickets_limit_max_number: 'Límit d\'entrades',
    max_tickets: 'Número d\'entrades incloses',
    event_added: 'S\'ha afegit l\'esdeveniment a l\'abonament'
  },
  tickets_validators: {
    title: 'Validadors d\'entrades',
    desc: 'Configuració sobre els validadors d\'entrades dels esdeveniments',    
    create: 'Afegir validador',
    edit: 'Editar validador',
    name: 'Nom/Codi del dispositiu',
    email: 'Correu electrònic d\'enviament de l\'enllaç',    
    apply_default: 'Afegir automàticament a les noves sessions',    
    active: 'Actiu',
    permissions_default_title: 'Permisos per defecte',    
    permission_validate: 'Pot validar entrades',
    permission_unvalidate: 'Pot cancel·lar validacions d\'entrades',
    permission_booking_data: 'Pot veure dades del comprador',
    permission_custom_fields: 'Pot veure dades de cada reserva',
    permission_statistics: 'Pot veure número d\'entrades venudes i validades de l\'esdeveniment',
  }, 
  tickets_maps: {
    main_menu_title: "Mapes de butaques",
    associations_id: "Entitat",
    description: "Descripció",
    created_at: "Creat",
    exporter_file_name: "mapes_butaques",
    assignments: "Esdeveniments / sessions",
    sessions_assigned: 'Sessions assignades',
    sessions: 'Sessions',
    sessions_assigned_to_map: 'Sessions assignades al mapa',
    assignments_info: "Veure esdeveniments i sessions assignats",
    assignments_empty: "Aquest mapa no està assignat a cap sessió.",
    assignments_error: "No s’han pogut carregar les assignacions.",
    events_count_label: "esdeveniments",
    sessions_count_label: "sessions",
    assignment_event: "Esdeveniment",
    assignment_session: "Sessió",
    assignment_date: "Data i hora",
    title: 'Mapes de butaques',
    desc: 'Configuració dels mapes de butaques dels esdeveniments',    
    create: 'Afegir mapa',   
    duplicate: 'Duplicar',
    edit: 'Editar mapa',
    download_svg: 'Descarregar SVG',
    name: 'Nom del mapa',
    preview: 'Previsualització',
    status_available_everyone: 'Disponibles',
    status_available_only_box_office: 'Disponibles només a guixeta',
    status_blocked: 'No disponibles',
    status_basket: 'Seleccionades a cistella',
    status_pending_payment: 'Pendents de pagament',
    status_reserved: 'Reservades',
    status_invitation: 'Invitacions',
    status_purchased: 'Comprades',
    total_on_sale: 'Entrades posades a la venda',
    occupied_total: 'Ocupació actual',
    capacity_above_occupied: 'La capacitat ha de ser superior a les %{occupied} unitats ja assignades',
    total_capacity: 'Aforament total',
    num_zones: 'Número de zones',
    num_seats: 'Número de seients',
    active: 'Actiu'
  }, 
  tickets_validations_log: {
    title: 'Registre de validacions',
    events_sessions_id: 'Sessió',
    tickets_booking_items_id: 'tickets_booking_items_id',
    users_groups_id: 'users_groups_id',
    created_at: 'Creat',
    mode: 'mode',
    result: 'result',
    ip: 'ip',
    user_agent: 'user_agent',
    os: 'os',
    browser: 'browser',
    comments: 'comments',
    events_sessions_validators_id: 'events_sessions_validators_id',
    exporter_file_name: 'tickets_validations_log',
  }, 
  tickets_zones: {
    main_menu_title: 'tickets_zones',
    create: 'Afegir tickets_zones',
    tickets_maps_id: 'tickets_maps_id',
    name: 'Zona',
    numbered_seats: 'Seients numerats',
    access: 'access',
    capacity: 'Aforament',
    available_capacity: 'Places disponibles',
    edit_available_capacity: 'Modificar places disponibles',
    available_everyone_capacity: 'Disponibles',
    available_only_box_office_capacity: 'Disponibles només a guixeta',
    blocked_capacity: 'Bloquejades',
    exporter_file_name: 'tickets_zones',
  }, 
  tickets_seats: {
    main_menu_title: 'tickets_seats',
    create: 'Afegir tickets_seats',
    tickets_zones_id: 'tickets_zones_id',
    row: 'Fila',
    seat: 'Seient',
    exporter_file_name: 'tickets_seats',
  }, 
  tickets_fares: {
    main_menu_title: 'tickets_fares',
    create: 'Afegir tickets_fares',
    tickets_zones_id: 'tickets_zones_id',
    tickets_groups_id: 'tickets_groups_id',
    price: 'price',
    exporter_file_name: 'tickets_fares',
  }, 
  
  tickets_booking: {
    main_menu_title: 'tickets_booking',
    create: 'Afegir tickets_booking',
    reference: 'Referència',
    events_sessions_id: 'Sessió',
    users_id: 'Usuari',
    first_name: 'Nom',
    last_name_1: 'Cognom 1',
    last_name_2: 'Cognom 2',
    phone: 'Telèfon',
    email: 'Email',
    booking_date_time: 'Data compra',
    amount_total: 'Import total',
    payment_status: 'Estat pagament',
    payment_method: 'Forma pagament',
    is_box_office: 'Guixeta',
    beneficiary_name: 'Nom beneficiari',
    beneficiary_email: 'Email beneficiari',
    send_invoice: 'Enviar factura',
    send_invoice_pending: 'Enviament de factura pendent d\'implementar',
    tickets_count: 'Número d\'entrades',
    origin: 'Origen',
    download_pdf: 'Descarregar PDF',
    send_ticket: 'Enviar entrada',
    send_ticket_pending: 'Enviament d\'entrades pendent d\'implementar',
    send_status: 'Confirmació enviada',
    remember_status: 'Recordatori enviat',
    resend_confirmation: 'Reenviar confirmació',
    resend_confirmation_pending: 'Reenviament de confirmació pendent d\'implementar',
    resend_reminder: 'Reenviar recordatori',
    resend_reminder_pending: 'Reenviament de recordatori pendent d\'implementar',
    payment_date: 'Data pagament',
    created_at: 'Creat',
    updated_at: 'Actualitzat',
    exporter_file_name: 'tickets_booking',
  }, 

  tickets_booking_items: {
    main_menu_title: 'tickets_booking_items',
    create: 'Afegir tickets_booking_items',
    tickets_booking_id: 'Compra',
    events_sessions_id: 'Sessió',
    events_sessions_prices_id: 'Tarifa sessió',
    tickets_booking_subscription_id: 'Abonament',
    attendance: 'Assistència',
    search_ticket_code: 'Buscar per codi d\'entrada',
    attendance_check: 'Assistència',
    session_date: 'Data sessió',
    export_date: 'Data exportació',
    event_name: 'Esdeveniment',
    session_name: 'Sessió',
    session_date_start: 'Inici sessió',
    session_date_finish: 'Fi sessió',
    venue_name: 'Espai',
    venue_address: 'Adreça',
    prices_name: 'Tarifa',
    ticket_code: 'Codi entrada',
    booking_reference: 'Referència compra',
    download_pdf: 'Descarregar PDF',
    requires_id_check: 'Requereix DNI',
    validated_at: 'Data validació',
    validated_by: 'Validat per',
    validated_for: 'Validador',
    unvalidated_at: 'Data desvalidació',
    unvalidated_by: 'Desvalidat per',
    unvalidated_for: 'Validador desvalidacio',
    status: 'Estat',
    num_validations: 'Validacions',
    num_unvalidations: 'Desvalidacions',
    price_base: 'Preu base',
    price_service_fee: 'Despeses gestió',
    price_total: 'Preu total',
    tax_event_percent: 'IVA entrada',
    tax_service_percent: 'IVA gestió',
    seat_access: 'Accés',
    seat_zone: 'Zona',
    seat_row: 'Fila',
    seat_number: 'Número',
    seat_label: 'Seient',
    created_at: 'Creat',
    updated_at: 'Actualitzat',
    exporter_file_name: 'tickets_booking_items',
  }, 
  tickets_checkers: {
    main_menu_title: 'tickets_checkers',
    create: 'Afegir tickets_checkers',
    associations_id: 'associations_id',
    events_id: 'events_id',
    name: 'name',
    email: 'Email',
    token: 'token',
    active: 'active',
    created_at: 'Creat',
    send_status: 'send_status',
    send_date_time: 'send_date_time',
    exporter_file_name: 'tickets_checkers',
  }, 
  tickets_checkers_in: {
    main_menu_title: 'tickets_checkers_in',
    create: 'Afegir tickets_checkers_in',
    events_sessions_id: 'Sessió',
    tickets_checkers_id: 'tickets_checkers_id',
    bookings_items_id: 'bookings_items_id',
    scanned_at: 'scanned_at',
    mode: 'mode',
    result: 'result',
    ip: 'ip',
    user_agent: 'user_agent',
    os: 'os',
    browser: 'browser',
    comments: 'comments',
    exporter_file_name: 'tickets_checkers_in',
  }, 
  tickets_custom_fields: {
    title: 'Camps de reserves',
    create: 'Afegir tickets_custom_fields',
    events_id: 'events_id',
    custom_fields_id: 'custom_fields_id',
    priority: 'priority',
    exporter_file_name: 'tickets_custom_fields',
  }, 
  tickets_ticket: {
    title: 'Disseny entrada',
    preview: 'Previsualització',
    preview_save_title: 'Desar els canvis?',
    preview_save_message: 'Hi ha canvis sense desar. Vols desar-los abans de generar la previsualització?',
    preview_save_confirm: 'Desar i previsualitzar',
    download: 'Descarregar PDF',
    download_error: 'No s\'ha pogut generar l\'entrada de prova',
    show_prices: 'Mostrar preus',
    show_custom_fields: 'Mostrar camps de reserves',
    primary_text: 'Text breu dins l\'entrada',
    secondary_text: 'Descripció de l\'esdeveniment',
    main_image: 'Imatge de l\'esdeveniment',
    ads_image: 'Imatge inferior de publicitat'
  }, 
  real_state: {
      create: 'Afegir immoble',      
      address: "Adreça",
      city: "Població",
      use: "Ús",
      use_0: "Altres",
      use_1: "En lloguer",
      use_2: "En cessió",
      use_others: 'Altres usos',
      identifier: "Identificador",
      acquisition_date: 'Data d\'adquisició',
      sale_date: 'Data de venda',
      amount: 'Valor comptable',
      guaranteed_value: 'Valor assegurat',
      cadastral_reference: 'Referència cadastral',
      comments: 'Observacions',
      docs: 'Documents',
      description: 'Descripció',
      insurance: 'Assegurança',
      insurances: 'Assegurances',
      docs_deed: 'Escriptures propietat, registre mercantil...',
      docs_map: 'Plànols',
      activities: 'Activitat',
      activities_in_real_state: 'Activitats en immobles',
      payments: 'Despeses',
      agreements: "Convenis",
      filter_only_current: "Només actuals",      
      exporter_file_name: 'immobles',
  },
  real_state_activities : {      
      create: 'Afegir activitat',
      name: 'Nom de l\'activitat',
      user: 'Contacte',
      type: 'Tipus de relació',
      type_0: 'Altres',
      type_1: 'Conveni',
      type_2: 'Contracte',
      type_other: 'Tipus de relació',
      agreements_id: 'Conveni',
      date_start: "Data inici",
      date_finish: "Data final",
      date_alert: "Data preavís",
      insurance_who: 'Responsable assegurança',
      insurance_who_0: 'La persona',
      insurance_who_1: 'Nosaltres',
      relations: 'Relació amb la comunitat propietaris',      
      comments: 'Observacions',
      docs: 'Documents',
      docs_contracts: 'Contractes',
      docs_insurances: 'Assegurances',
      real_state_id: 'Id immoble',
      real_state: 'Nom immoble',
      exporter_file_name: 'activitat_immobles'
  },
  real_state_payments : {
      create: 'Afegir despesa',
      type: 'Tipus',
      type_0: 'Altres',
      type_1: 'Llum',
      type_2: 'Aigua',
      type_3: 'Gas',
      type_4: 'Telèfon',
      type_5: 'Assegurança',
      type_6: 'Obres',
      type_7: 'Manteniment',
      type_8: 'Reparacions',
      type_9: 'Transformacions',
      type_other: 'Tipus',
      date_payment: "Data pagament",
      amount: 'Import',
      payer: 'Pagador',
      payer_0: 'Altres',
      payer_1: 'Nosaltres',
      payer_2: 'Comunitat',
      payer_3: 'Llogater',
      payer_other: 'Pagador',
      financing: 'Finançament',
      financing_type: 'Tipus de finançament',
      docs: 'Documents',
      docs_billing: 'Factures',
      comments: 'Observacions',
      exporter_file_name: 'pagaments'
  },
  agreements: {
      create: 'Afegir conveni',
      date_start: "Data inici",
      date_finish: "Data final",
      date_alert: "Data preavís",
      date_renewal: "Data renovació",
      renewal_duration: "Duració renovació",
      date_renewal_quote: "Renovació quota",
      comments: 'Observacions',
      users: "Contactes",
      real_state: "Immobles",      
      docs: 'Documents',
      filter_only_current: "Només vigents",
      exporter_file_name: 'convenis',
  },
  classrooms_activities: {
      create: 'Afegir activitat',
  },
  classrooms_payments: {
      create: 'Afegir pagament',
  },
  insurances: {
      create: 'Afegir assegurança',
      real_state: 'Immobles',
      date_start: 'Data inici',
      date_finish: 'Data final',
      date_alert: 'Data alerta',
      date_renewal: 'Data renovació',
      renewal_duration: 'Durada renovació',
      comments: 'Observacions',
      docs: 'Documents',
      filter_only_current: "Només vigents",
      exporter_file_name: 'assegurances',
  },
  alerts: {      
      create: 'Afegir alerta',      
      type: 'Tipus',
      type_1: 'Genèrica puntual',
      type_2: 'Periòdica anual',
      type_3: 'Periòdica mensual',
      type_4: 'Preavís activitat immoble',
      type_5: 'Preavís conveni',
      type_6: 'Renovació conveni',
      type_7: 'Actualització quota conveni',
      type_8: 'Preavís assegurança',
      type_9: 'Esdeveniment',
      message: 'Missatge a mostrar',
      date_alert: 'Data puntual',
      date_day: 'Dia del mes',
      date_month: 'Mes',
      actions: 'Accions',
      action_send_email: 'Enviament de correu electrònic als administradors',
      action_popup: 'Mostrar missatge a la finestra d\'alertes dels administradors',
      actived: 'Activa',
      delete_all: 'Esborrar totes les alertes',
      no_results: 'No hi ha alertes',
      filter_only_current: 'Només actives',      
      postpone: 'Posposar alerta',
      date_apply: 'Nova data',
      postpone_ok: 'S\'ha posposat l\'alerta',
      delete: 'Esborrar',
      delete_ok: 'S\'ha esborrat l\'alerta',
      delete_all_ok: 'S\'han esborrat totes les alertes',
  },  
  docs: {
    docs: 'Documents',
    create: 'Afegir',
    edit: 'Canviar el nom',
    actions: 'Accions',
    download: 'Descarregar',
    size : 'Mida',
    fieldExcel : 'Document .xlsx (màx. %size%MB)',
    fieldDoc : 'Document (màx. %size%MB)',
    fieldImg : 'Imatge (màx. %size%MB)',
    fieldSVG : 'Fitxer .svg (màx. %size%MB)',
    change : 'Canviar',
    webcam: 'Foto des de webcam',
    webcam_capture: 'Capturar',
    webcam_error: 'No s\'ha detectat la webcam',
    delete_photo_title : 'Esborrar fotografia',
    delete_photo_ask : 'Segur que vols esborrar la fotografia?',        
    imported: 'Importació finalitzada correctament. S\'han importat %num% registres',
    imported_none: 'No hi ha registres per importar',
    copy_link: 'Adreça pública',    
  },
  events: {
    create: 'Afegir esdeveniment',
    edit: 'Modificar',
    name: 'Nom de l\'esdeveniment',
    description: 'Descripció',
    start: 'Data inici',
    end: 'Data fi',
    classroom: 'Espai',
    activity: 'Activitat',
    categories: 'Categories',
    is_public: 'Web de l\'entitat',
    is_public_filter: 'Publicades a web',
    show_fac: 'Web de la FAC',
    show_fac_filter: 'Publicades a FAC',
    xtac: 'Espectacle XTAC',
    ticketing: 'Venda d\'entrades',
    ara_tiquets_status: 'Estat',
    ara_tiquets_draft: 'Esborrany',
    ara_tiquets_published: 'Publicat',
    preview: 'Previsualització',
    view: 'Visualització',
    view_public_web: 'Veure a la web de l\'entitat',
    view_ara_tiquets: 'Veure a %project_name%',
    repetitive: 'Generar repeticions',
    repetitive_limit: 'Finalitza el dia',
    repetitive_mode_edition_title_save: 'Edita l\'esdeveniment periòdic',
    repetitive_mode_edition_title_delete: 'Esborrar l\'esdeveniment periòdic',
    repetitive_mode_edition_only_one: 'Aquest esdeveniment',
    repetitive_mode_edition_only_future: 'Aquest esdeveniment i els següents',
    repetitive_mode_edition_all: 'Tots els esdeveniments',
    repetitive_mode_edition_save: 'Desar',
    repetitive_mode_edition_delete: 'Esborrar',
    repetitive_mode_edition_delete_confirmation: 'Segur que vols esborrar els esdeveniments?',
    repetitive_mode_edition_delete_confirmation_2: 'Estàs segur/a que vols esborrar els esdeveniments?',
    repetitive_mode_edition_cancel: 'Cancel·lar',
    overlapable_title: 'Superposició d\'esdeveniments',
    overlapable_ask: 'Vols permetre la celebració de diversos esdeveniments en el mateix espai i temps?',
    data: 'Dades',
    event_data: 'Dades de l\'esdeveniment',
    event_type: 'Tipus d\'esdeveniment',
    event_without_registrations: 'Sense inscripcions',
    event_with_registrations_ticketing: 'Amb inscripcions i/o venda d\'entrades',
    session_data: 'Dades de la sessió',
    place: 'Lloc',
    organization: 'Organització',
    visibility: 'Publicació',
    seating_map: 'Mapa de butaques',
    default_price: 'Preu per defecte',
    tickets_on_sale: 'Número d\'entrades a la venda',
    ticketing_later_values_hint: '* Més endavant podràs modificar aquests valors',
    images: 'Imatges',
    images_desc: '* Pots marcar les imatges que s\'enviaran en el correu electrònic de confirmació de la compra. Tingues en compte de reduir al màxim el pes dels arxius.',
    docs: 'Documents',
    docs_desc: '* Pots marcar els documents que s\'enviaran en el correu electrònic de confirmació de la compra. Tingues en compte de reduir al màxim el pes dels arxius.',
    docs_mark: 'Adjunt al correu de confirmació (*)',
    docs_mark_tooltip: 'Adjuntar aquest document en el correu de confirmació de la compra',
    images_mark_tooltip: 'Adjuntar aquesta imatge en el correu de confirmació de la compra',
    bookings: 'Persones',
    exporter_file_name: 'activitats',
    exporter_header_id: 'Identificador intern',
    exporter_header_title: 'Esdeveniment',
    exporter_header_date_start: 'Data inicial',
    exporter_header_date_finish: 'Data final',
    exporter_header_classrooms_name: 'Espai',
    exporter_header_activities_name: 'Activitat',
    exporter_header_is_public: 'És públic',
    export_title: 'Exportar activitats',
    export_form_text: 'Data d\'inici',
    export_form_from: 'Des del',
    export_form_to: 'Fins el',
    pdf_filename: 'esdeveniments',
    organizer: 'Organitzador',
    address: 'Adreça de l\'esdeveniment',
    city: 'Població',
    alert_days: 'Avís als administradors',
    alert_days_none: 'Sense avís',
    alert_days_0: 'El mateix dia',
    alert_days_1: '1 dia abans',
    alert_days_2: '2 dies abans',
    alert_days_3: '3 dies abans',
    alert_days_4: '4 dies abans',
    alert_days_5: '5 dies abans',
    alert_days_6: '6 dies abans',
    alert_days_7: '7 dies abans',
    alert_days_8: '8 dies abans',
    alert_days_9: '9 dies abans',
    alert_days_10: '10 dies abans',
    alert_days_11: '11 dies abans',
    alert_days_12: '12 dies abans',
    alert_days_13: '13 dies abans',
    alert_days_14: '14 dies abans',
    tickets_url: 'URL venda d\'entrades',
    max_assistants: 'Número d\'assistents',
    is_internal: 'És un esdeveniment intern',
    is_internal_filter: 'Esdeveniment intern',
    friendly_url: 'Identificador a URL'    
  },
  public_events: {
    not_actived: 'L\'entitat no té l\'agenda activa',
    association_not_found : 'L\'entitat no s\'ha trobat o hi ha hagut un error',
    event_not_found : 'L\'activitat no s\'ha trobat o hi ha hagut un error',
    view_web: 'Agenda web',
    go_back: 'Tornar enrere',
    search: 'Cercar',
    filter_date_after: 'Comença després de',
    filter_date_before: 'Comença abans de',
    filter_activity: 'Activitat',
    filter_organizer: 'Organitzador',
    filter_province: 'Província',
    filter_region: 'Comarca',
    filter_city: 'Població',
    filter_organizer_all: 'Totes les entitats',
    filter_activity_all: 'Totes les activitats',
    filter_category_all: 'Totes les categories',
    filter_province_all: 'Totes les províncies',
    filter_region_all: 'Totes les comarques',
    filter_city_all: 'Totes les poblacions',
    more_info: '+ Info',
    tickets: 'Entrades',
    buy_ticket: 'Comprar entrades',
    quantity: 'Número d\'entrades',
  },
  recercat_centers:
    {
      public_id: 'Codi',
      name: 'Nom',
      city: 'Població',
      email: 'Correu electrònic',
      actived: 'Actiu',
      create: 'Afegir centre',
      no_centers_title : 'centres',
      no_centers_ask : 'Vols afegir-ne un?',
      column_center: 'Centre',      
      column_city: 'Població (seu de l\'entitat)',      
      actions: 'Accions',
      actions_revoke: 'Revocar',
      actions_validate: 'Validar', 
      actions_deny: 'Denegar', 
      actions_title0: 'Revocar carnet',    
      actions_title1: 'Validar sol·licitud de carnet',    
      actions_title2: 'Denegar sol·licitud de carnet',
      actions_title3: 'Validar sol·licitud de carnet',
      actions_title4: 'Revocar carnet',
      actions_title5: 'Denegar sol·licitud de carnet',
      actions_title6: 'Validar sol·licitud de carnet',        
      action_button0: 'Revocar',
      action_button1: 'Validar',
      action_button2: 'Denegar',
      action_button3: 'Validar',
      action_button4: 'Revocar',
      action_button5: 'Denegar',
      action_button6: 'Validar',        
      validate_num_member: 'Número de carnet',    
      validate_send_email: 'Enviar el carnet digital a la persona',    
      revoke_send_email: 'Enviar missatge de confirmació a la persona',
      revoke_title: 'Revocar carnet',    
      revoke_ask: 'Segur que vols revocar el carnet? S\'esborraran les dades personals i no es podran recuperar.',    
      deny_ask: 'Segur que vols denegar la sol·licitud de carnet? S\'esborraran les dades personals i no es podran recuperar.',    
      revoke_comment: 'Motiu',    
      revoke_button: 'Revocar',        
      resume_send: 'Enviament de resum',
      resume_send_title: 'Enviament de resum',
      resume_send_ask: 'Segur que vols enviar un resum dels carnets al centre?' ,  
      resume_send_ask_again: 'Ja s\'ha enviat anteriorment un resum dels carnets al centre. Segur que vols tornar a enviar-lo?',
      resume_send_ok: 'Enviament realitzat!',
      resume_send_tooltip_button: 'Enviar resum de carnets',
      resume_send_send_tooltip_sending: 'S\'està enviant el resum de carnets...',
      resume_send_tooltip_done: 'S\'ha enviat el resum de carnets',
      resume_send_ko: 'El resum de carnets no s\'ha pogut entregar al destinatari',
        
      dashboard_resume_title: 'Estat de carnets',
      dashboard_resume_num_members: 'Carnets actius',
      dashboard_resume_num_centers: 'Total de centres actius',
      dashboard_graphic_title: 'Carnets validats',
      dashboard_graphic_cards: 'Carnets',
                
      validation_email_code_0: 'La vostra sol·licitud per obtenir el Carnet digital Recercat ha estat acceptada correctament.<br/><br />Properament us enviarem el Carnet digital Recercat a la vostra adreça electrònica.<br /><br />Reviseu la carpeta de correu brossa de la vostra bústia.<br /><br />',
      validation_email_code_1: 'El codi de l\'adreça no és correcta',
      validation_email_code_2: 'La sol·licitud no s\'ha trobat o ja no està activa',
      validation_email_code_3: 'La teva sol·licitud ja està en curs.',
      validation_email_code_4: 'L\'entitat de l\'adreça no és correcta.',
      validation_email_code_5: 'El formulari de sol·licitud està desactivat.',
      validation_email_code_6: 'L\'enllaç ja no és vàlid. Si us plau, torneu a fer la sol·licitud.',
      validation_email_error: 'S\'ha produït un error intentant validar la sol·licitud',
        
      form_title: 'Formulari de sol·licitud del Carnet digital Recercat',
      form_title_send_email: 'Formulari de sol·licitud del Carnet digital Recercat',
      form_title_validate_ok: 'Confirmació de sol·licitud del carnet Recercat',
      form_title_validate_ko: 'Sol·licitud del carnet Recercat',
      required_fields: '* Tots els camps són necessaris',        
        
      resume_title: 'Estat dels carnets Recercat',
      resume_pending_center: 'Pendents de validació centre',
      resume_pending_irmu: 'Pendents de validació per l\'IRMU',
      resume_validated: 'Validats per l\'IRMU',
      resume_error: 'No s\'han pogut recuperar les dades, l\'adreça no és vàlida.',
      resume_actions_accept: 'Acceptar',
      resume_actions_deny: 'Denegar',
      resume_actions_revoke: 'Revocar',
      resume_actions_logout: 'Tancar sessió',
        
      resume_dialog_title_3: 'Acceptar sol·licitud de carnet',
      resume_dialog_desc_3: 'La sol·licitud continuarà el seu procés i passarà a l\'estat Pendent de Validació IRMU.',
      resume_dialog_button_3: 'Acceptar',
      resume_dialog_title_5: 'Denegar sol·licitud',
      resume_dialog_desc_5: 'Segur que vols denegar la sol·licitud de carnet? La persona rebrà un correu electrònic predefinit informant-lo de la denegació i s\'esborraran totes les seves dades.',
      resume_dialog_button_5: 'Denegar',
      resume_dialog_title_4: 'Revocar carnet',
      resume_dialog_desc_4: 'Segur que vols revocar el carnet? La persona rebrà un correu electrònic predefinit informant-lo de la baixa i s\'esborraran totes les seves dades.',
      resume_dialog_button_4: 'Revocar',
      resume_dialog_title_8: 'Tancar sessió',
      resume_dialog_desc_8: 'Segur que vols tancar la sessió? L\'enllaç deixarà de ser vàlid i només podràs tornar a accedir a aquesta pàgina si reps un nou correu d\'estat de carnets Recercat.',
      resume_dialog_button_8: 'Tancar sessió',
        
      delete_center_title: 'Segur que vols esborrar el centre? ',
      delete_center_ask: 'Es revocaran tots els seus carnets actuals, es denegaran les sol·licituds de carnet pendents i es devincularà el centre de qualsevol carnet en el passat. S\'enviarà una notificació a totes les persones afectades.',
        
    },
    
  documents_fac : {
    title: 'Documents de la FAC',
    description: 'En aquest apartat podeu consultar els documents disponibles per a les associacions federades.'
  },
    
  bookings: {
    create_user_button: 'Persona',
    create_user_title: 'Afegir persona',
    create_group_button: 'Grup',
    create_group_title: 'Afegir grup',
        
    status_0: 'Invitació',
    email_sent_0: 'Correu d\'invitació',
    email_sent_title_0: 'Correu d\'invitació',
    email_sent_ask_0: 'Segur que vols enviar-li el correu d\'invitació predefinit?' ,  
    email_sent_ask_all_0: 'Segur que vols enviar el correu d\'invitació predefinit a totes les persones que encara no s\'hagi enviat?' ,  
    email_sent_ask_again_0: 'Ja s\'ha enviat anteriorment el correu d\'invitació. Segur que vols tornar a enviar-li?',        
    email_send_all_button_0: 'Invitacions',
    email_send_all_button_title_0: 'Enviar invitacions',
    email_sent_ko_0: 'La invitació no s\'ha pogut entregar al destinatari',
    email_sent_tooltip_button_0: 'Enviar invitació',
    email_sent_tooltip_sending_0: 'S\'està enviant la invitació...',
    email_sent_tooltip_done_0: 'S\'ha enviat la invitació',
        
    status_1: 'Recordatori',
    email_sent_1: 'Correu de recordatori',
    email_sent_title_1: 'Correu de recordatori',
    email_sent_ask_1: 'Segur que vols enviar-li el correu de recordatori predefinit?' ,  
    email_sent_ask_all_1: 'Segur que vols enviar el correu de recordatori predefinit a totes les persones que encara no s\'hagi enviat?' ,  
    email_sent_ask_again_1: 'Ja s\'ha enviat anteriorment el correu de recordatori. Segur que vols tornar a enviar-li?',              
    email_send_all_button_1: 'Recordatoris',
    email_send_all_button_title_1: 'Enviar recordatoris',
    email_sent_ko_1: 'El recordatori no s\'ha pogut entregar al destinatari',
    email_sent_tooltip_button_1: 'Enviar recordatori',
    email_sent_tooltip_sending_1: 'S\'està enviant el recordatori...',
    email_sent_tooltip_done_1: 'S\'ha enviat el recordatori',
    
    status_2: 'Tiquet',
    email_sent_2: 'Correu amb el tiquet',
    email_sent_title_2: 'Correu amb el tiquet',
    email_sent_ask_2: 'Segur que vols enviar-li el correu amb el tiquet predefinit?' ,  
    email_sent_ask_all_2: 'Segur que vols enviar el correu amb el tiquet predefinit a totes les persones que encara no s\'hagi enviat?' ,  
    email_sent_ask_again_2: 'Ja s\'ha enviat anteriorment el correu amb el tiquet. Segur que vols tornar a enviar-li?',        
    email_send_all_button_2: 'Tiquets',
    email_send_all_button_title_2: 'Enviar tiquets',
    email_sent_ko_2: 'El tiquet no s\'ha pogut entregar al destinatari',
    email_sent_tooltip_button_2: 'Enviar tiquet',
    email_sent_tooltip_sending_2: 'S\'està enviant el tiquet...',
    email_sent_tooltip_done_2: 'S\'ha enviat el tiquet',
        
    email_sent_ok: 'Enviament realitzat!', 
    email_only_pending: 'A les persones que encara no s\'ha enviat',
    email_all: 'A totes les persones',
    email_send_button: 'Enviar',
    email_send_all_advise: 'L\'enviament massiu s\'executarà en segon pla i pot trigar uns minuts.',
            
    email_status_0: '',
    email_status_1: 'Enviant...',
    email_status_2: 'Error enviant!',
    email_status_3: 'Enviat!',
    email_status_4: 'Retornat!',
        
    delete_all_button: 'Esborrar',        
    delete_all_button_title: 'Esborrar persones',
    delete_all_ask: 'Segur que vols esborrar totes les persones de l\'esdeveniment?' ,  
    reminder: 'Enviar recordatori a totes les persones',
    reminder_0: 'No enviar',
    reminder_1: 'El mateix dia a les 7h',
    reminder_2: 'El mateix dia a les 8h',
    reminder_3: 'El mateix dia a les 9h',
    reminder_4: 'El mateix dia a les 10h',  
    reminder_5: 'El dia anterior a les 19h',    
    reminder_6: 'El dia anterior a les 20h',        
    reminder_7: 'El dia anterior a les 21h',        
    reminder_8: 'El dia anterior a les 22h',  
        
    exporter_file_name: 'persones_esdeveniment',
    exporter_header_id : 'Identificador',
  },
  social_nets : {
    title : 'Xarxa social',
    link : 'Nom d\'usuari'
  },
  users_families : {
    name : 'Nom'
  },
  users_activities: {
    title: 'Activitats',
    create_button: 'Afegir',
    create: 'Afegir resum anual d\'activitats',
    edit: 'Modificar resum anual d\'activitats',
    name: 'Activitat',
    quantity: 'Quantitat',
    assistants: 'Assistents',
    adult: 'Públic',
    total_quantity: 'Núm. activitats',
    total_assistants: 'Total assistents',
  },
  users_trainings : {
    title0: 'Formació en arts',
    title1: 'Formacions',
    create_button: 'Afegir',
    create0: 'Afegir resum anual de formacions en arts',
    create1: 'Afegir resum anual de formacions',
    edit0: 'Modificar resum anual de formacions en arts',
    edit1: 'Modificar resum anual de formacions',        
    type: 'Formació',
    training_type: 'Tipus d\'activitat',
    training_type0: 'Curs',
    training_type1: 'Taller',
    training_type2: 'Esplai',
    training_type3: 'Aula',
    training_type99: 'Altres',
    training_type_others: 'Tipus d\'activitat (si no està a la llista)',
    periodicities: 'Periodicitat',
    periodicity0: 'Diària',
    periodicity1: 'Setmanal',
    periodicity2: 'Mensual',
    periodicity3: 'Curs lectiu',
    periodicity4: 'Estiu',
    periodicity5: 'Nadal',
    periodicity6: 'Setmana Santa',
    ages: 'Franja d\'edats',
    ages0: 'Infantil (menys de 12 anys)',
    ages1: 'Juvenil (12-18 anys)',
    ages2: 'Adults (18-40 anys)',
    ages3: 'Veterans (40+ anys)',
    ages4: 'Mix de diferents edats',
    num_classrooms: 'Núm. d\'espais',
    formal: 'Formal / No formal',
    students: 'Estudiants',
    teachers_workers: 'Professorat remunerat',
    teachers_volunteers: 'Professorat voluntari',
    total_hours: 'Total d\'hores',
    total_quantity0: 'Núm. formacions en art',
    total_quantity1: 'Núm. formacions',
    total_teachers_workers: 'Total professorat remunerat',
    total_teachers_volunteers: 'Total professorat voluntari',
    total_students: 'Total estudiants',
    type0: 'Teatre',
    type1: 'Dansa',
    type2: 'Circ',
    type3: 'Coral',
    type4: 'Cant',
    type5: 'Instruments musicals',
    type6: 'Arts plàstiques',
    type7: 'Arts audiovisuals-digitals',
    type8: 'Escriptura i expressió literària',
    type9: 'Fotografia',
    type10: 'Dansa iniciació',
    type11: 'Dansa contemporània',
    type12: 'Música instrument',
    type13: 'Llenguatge musical',
    type14: 'Combo',
    type15: 'Pintura artística',
    type16: 'Manga',
    type99: 'Altres',    
    type20: 'Idiomes',
    type21: 'Esportives - Altres',
    type22: 'Esportives - Futbol',
    type23: 'Esportives - Bàsquet',
    type24: 'Esportives - Tennis taula',
    type25: 'Esportives - Escacs',
    type26: 'Esportives - Excursionisme',
    type27: 'Curs Robòtica/Tecnologia',
    formal_art_0: 'Formal',
    formal_art_1: 'No formal',
    formal_0: 'Formal/federada',
    formal_1: 'No formal'    
  },  
  
  users_healthy: {
    title: 'Àrea esportiva i d\'activitats de la salut i el benestar',    
    create_button: 'Afegir',
    create: 'Afegir resum anual d\'àrea esportiva, activitats de la salut i el benestar',    
    edit: 'Modificar resum anual d\'àrea esportiva, activitats de la salut i el benestar',
    type: 'Modalitat o disciplina Esportiva',  
    type_other: 'Nom de la modalitat o disciplina',
    type0: 'Caminades en grup',
    type1: 'Taitxí',
    type2: 'Gimnàstica de Manteniment',
    type3: 'Ball esportiu (zumba, dansa, ball fitness)',
    type4: 'Futbol sala',
    type5: 'Bàsquet',
    type6: 'Tennis taula',
    type7: 'Escacs',
    type8: 'Ioga',
    type9: 'Pilates',
    type10: 'Ciclisme',
    type11: 'Grups excursionista FEEC/ Trail',
    type12: 'Natació',
    type13: 'Billar',
    type99: 'Altres',
    formal: 'La modalitat o disciplina esportiva està federada?',
    formal_0: 'No',
    formal_1: 'Sí',
    federation: 'Federació',
    federation_other: 'Nom de la federació',
    federation0 : 'Federació Catalana de Basquetbol',
    federation1 : 'Federació Catalana de Billar',
    federation2 : 'Federació Catalana de Ball Esportiu',
    federation3 : 'Federació Catalana d\'Entitats Excursionistes de Catalunya',
    federation4 : 'Federació Catalana d\'Escacs',
    federation5 : 'Federació Catalana de Futbol',
    federation6 : 'Federació Catalana de Futbol Sala',
    federation7 : 'Federació Catalana de Ciclisme',
    federation8 : 'Federació Catalana de Natació',
    federation9 : 'Federació Catalana de Tennis Taula',
    federation99 : 'Altres',
    federation_licenses: 'Amb quantes fitxes federatives compteu?',
    profile: 'Perfil dels participants',
    profile_1: 'Infantil (menys de 12 anys)',
    profile_1_male: 'Homes',
    profile_1_female: 'Dones',
    profile_1_no_binary: 'No binaris',
    profile_2: 'Juvenil (12-18 anys)',
    profile_2_male: 'Homes',
    profile_2_female: 'Dones',
    profile_2_no_binary: 'No binaris',
    profile_3: 'Adults (18-40 anys)',
    profile_3_male: 'Homes',
    profile_3_female: 'Dones',
    profile_3_no_binary: 'No binaris',
    profile_4: 'Veterans ( més de 40 anys)',
    profile_4_male: 'Homes',
    profile_4_female: 'Dones',
    profile_4_no_binary: 'No binaris',
    profile_5: 'Mixt de diferents edats',
    profile_5_male: 'Homes',
    profile_5_female: 'Dones',
    profile_5_no_binary: 'No binaris',
    teachers_workers: 'Professorat remunerat',
    teachers_volunteers: 'Professorat voluntari',
    periodicity: 'Periodicitat',
    periodicity0: 'Diària',
    periodicity1: 'Setmanal',
    periodicity2: 'Mensual',
    periodicity3: 'Esporàdica',    
    total_teachers_workers: 'Total professorat remunerat',
    total_teachers_volunteers: 'Total professorat voluntari',
    total_students: 'Total participants',
    total_quantity: 'Núm. disciplines',
  }, 

  users_social_projects: {
    title: 'Projectes socials',
    create_button: "Afegir",
    create: 'Afegir resum anual de projectes socials',    
    edit: 'Modificar resum anual de projectes socials',
    type: "Tipus de destinatari",
    quantity: "Quantitat",
    total_quantity: "Quantitat total",
    type0: 'Migració',
    type1: 'Violència masclista',
    type2: 'Discapacitat',
    type3: 'Atur',
    type4: 'Famílies monoparentals',
    type5: 'Tercera edat (persones grans)',
    type6: 'Salut mental',
    type7: 'Inserció sociolaboral',
    type8: 'Altres'
  },
  users_sections: {
    title: 'Seccions',
    create_button: 'Afegir',
    create: 'Afegir resum anual de seccions',
    edit: 'Modificar resum anual de seccions',
    participants: 'Participants',
    num_sections: 'Núm. seccions',
    total_participants: 'Total participants',
    name: 'Secció',
    quantity: 'Quantitat',
    assistants: 'Assistents',
    total_quantity: 'Núm. activitats',
    total_assistants: 'Total assistents',
  },
  users_shows: {
    title: 'Espectacles',
    create_button: 'Afegir',
    create: 'Afegir resum anual d\'espectacles',
    edit: 'Modificar resum anual d\'espectacles',
    name: 'Espectacle',
    total_quantity: 'Núm. funcions',
    total_assistants: 'Total assistents',
    total_inversion: 'Total pressupost',
    type: 'Tipus',
    type_1: 'Teatre',
    type_2: 'Dansa',
    type_3: 'Música',
    type_4: 'Altres',
    amateur: 'Amateur/Professional',
    amateur_1: 'Amateur',
    amateur_2: 'Professional',
    adult: 'Públic',
    adult_1: 'Infantil',
    adult_2: 'Adult',
    adult_3: 'Per a tots els públics',
    quantity: 'Núm. funcions',
    assistants: 'Assistents',
    inversion: 'Pressupost',
    occupancy: 'Ocupació (%)',        
  },
  check_members: {
    not_found: 'El carnet no és vàlid',
    status_1: 'Vàlid',
    status_2: 'No vàlid',
    status_3: 'No vàlid',
    checker_name: 'Nom i cognoms',
    checker_nif: 'DNI',
    checker_birthday: 'Data de naixement',
    checker_num_member: 'Número',
    checker_minor: 'Menor d\'edat',
    checker_association_name: 'Entitat',
    checker_group_name: 'Grup',
    checker_date_join: 'Data d\'alta',
    checker_date_left: 'Data de baixa',
    checker_date: 'Data de validació',
  },
  users_annuary : {
    tab: 'Anuari',   
    title: 'Formulari per a l\'anuari',        
    answered_status: 'Respost',
    answered_status_0: 'No',
    answered_status_1: 'Sí',
    answered_date_time: 'Data de resposta',
    expiration_date: 'Data límit per a respondre',
    sent_status: 'Enviament',
    reminder_status: 'Recordatori'  ,
    confirm_status: 'Confirmació'  ,
    send: 'Enviar',
    create_button: 'Enviar nou formulari',
    edit: 'Editar formulari',
    send_dialog_button: 'Formulari anuari',
    send_dialog_action: 'Acció a realitzar',
    send_dialog_action_0: 'Enviar enllaç del formulari a tots els contactes',
    send_dialog_action_1: 'Enviar recordatori amb l\'enllaç al formulari a tots els contactes',        
    send_dialog_text1_0: 'S\'enviarà un missatge predefinit a tots els contactes del grup als quals encara no s\'hagi enviat amb l\'enllaç per a respondre el formulari.',
    send_dialog_text1_1: 'S\'enviarà un recordatori amb l\'enllaç del formulari a tots els membres del grup que ja s\'hagi enviat i encara no hagin respost.',
    send_dialog_text2: 'La data límit per a respondre el formulari serà la que indiquis a continuació.',
    send_dialog_text3: 'L\'enviament s\'executarà en segon pla i pot trigar uns minuts. Podràs consultar l\'estat de l\'enviament i de les repostes a la fitxa de cada contacte o usant els filtres del llistat de contactes.',
        
    not_found: 'El formulari no s\'ha trobat o no està disponible',
    expired: 'S\'ha acabat el termini per a respondre el formulari, si us plau, posa\'t en contacte amb la FAC.',
        
    email_sent_0: 'Correu amb el formulari',
    email_sent_title_0: 'Correu amb enllaç al formulari',
    email_sent_ask_0: 'Segur que vols enviar-li l\'enllaç al formulari?' ,   
    email_sent_ask_again_0: 'Ja s\'ha enviat anteriorment el correu amb l\'enllaç al formulari. Segur que vols tornar a enviar-li? Es generarà un nou enllaç.',   
    email_sent_ko_0: 'El formulari no s\'ha pogut entregar al destinatari',
    email_sent_tooltip_button_0: 'Enviar formulari',
    email_sent_tooltip_sending_0: 'S\'està enviant la el formulari...',
    email_sent_tooltip_done_0: 'S\'ha enviat el formulari',
        
    email_sent_1: 'Correu de recordatori',
    email_sent_title_1: 'Correu de recordatori',
    email_sent_ask_1: 'Segur que vols enviar-li el correu de recordatori predefinit?' ,  
    email_sent_ask_again_1: 'Ja s\'ha enviat anteriorment el correu de recordatori. Segur que vols tornar a enviar-lo?', 
    email_sent_ko_1: 'El recordatori no s\'ha pogut entregar al destinatari',
    email_sent_tooltip_button_1: 'Enviar recordatori',
    email_sent_tooltip_sending_1: 'S\'està enviant el recordatori...',
    email_sent_tooltip_done_1: 'S\'ha enviat el recordatori',
        
    email_sent_2: 'Correu de confirmació',
    email_sent_title_2: 'Correu de confirmació',
    email_sent_ask_2: 'Segur que vols enviar-li el correu de confirmació predefinit?' ,  
    email_sent_ask_again_2: 'Ja s\'ha enviat anteriorment el correu de confirmació. Segur que vols tornar a enviar-lo?', 
    email_sent_ko_2: 'El correu de confirmació no s\'ha pogut entregar al destinatari',
    email_sent_tooltip_button_2: 'Enviar confirmació',
    email_sent_tooltip_sending_2: 'S\'està enviant el correu de confirmació...',
    email_sent_tooltip_done_2: 'S\'ha enviat el correu de confirmació',
        
    form_title: 'Formulari per a l\'anuari %year%',
    form_send: 'Enviar',
    form_already_answered: 'El formulari ja ha estat respost, si voleu modificar les vostres dades, si us plau, poseu-vos en contacte amb la FAC.',
    form_general_data: 'Dades generals de l\'entitat',
    form_activities: 'Activitats',
    form_trainings_art: 'Formacions en art',
    form_trainings: 'Formacions',
    form_classrooms: 'Espais',
    form_social_nets: 'L\'entitat a la xarxa',
    form_social_nets_title: 'Xarxes socials',
    form_economic_data: 'Dades econòmiques',
    form_economic_data_incomings: 'Ingressos',
    form_economic_data_expenses: 'Despeses',
    form_economic_data_inversion: 'Inversió',
    form_shows: 'Espectacles',
    form_sections: 'Seccions de l\'entitat',
    form_workers: 'Personal remunerat',
    form_volunteers: 'Voluntaris',
    form_edited_books_books: 'Llibres publicats de l\'entitat',
    form_edited_books_newsletters: 'Butlletí electrònic',
    form_edited_books_magazines: 'Revista',
    form_entity: 'Nom de l\'entitat',
        
    form_desc_activities: 'Les activitats que es desenvolupen al vostre ateneu. Diferents a les formacions i cursos.',
    form_desc_classrooms : 'Els espais físics o equipaments que disposeu a l\'ateneu.',
    form_desc_shows: 'Els actes que es representen a l’ateneu.',
    form_desc_sections: 'Grups de l’entitat.',
    form_desc_trainings_art: 'Cursos amb una finalitat formativa o d\'ensenyament en arts que es desenvolupen a la seva entitat.',
    form_desc_trainings: 'Cursos amb una finalitat formativa o d\'ensenyament que es desenvolupen a la seva entitat.',
    form_desc_workers: 'Persones contractades que reben un salari a la vostre entitat.',
    form_desc_volunteers: 'Persones que ofereixen el seu temps, experiència, coneixements i treball per a la vostra entitat sense rebre una compensació econòmica.',
    form_desc_social_nets: 'La vostra presència en les xarxes socials digitals.',
    form_desc_economic_data: 'Les dades generals de les despeses, ingressos i inversions generals que s\'han fet a l\'ateneu.',
    form_desc_edited_books_books: 'Llibres publicats des de la vostra entitat.',
    form_desc_edited_books_newsletters: 'Tipus de publicacions periòdiques o que publiqueu de manera regular amb les notícies del vostre ateneu.',
    form_desc_edited_books_magazines: 'Tipus de publicació periòdica amb articles de informació general o determinada del vostre ateneu.'
                
  },
  users_economic_data : {
    incomings: 'Ingressos',
    expenses: 'Despeses',
    total: 'Resultat',
    inversion: 'Inversió en obres',
    members : 'Quotes de socis',
    services : 'Serveis oferts',
    subsidies : 'Subvencions (Generalitat, Diputació, Ajuntament o altres)',
    rentals : 'Arrendaments',
    products : 'Venda de productes',
    privates : 'Ajuts privats',
    others : 'Altres',
    create: 'Afegir pressupost anual',
    create_button: 'Afegir',
    edit_title: 'Modificar pressupost anual',
    exp_rentals: 'Lloguers',
    exp_workers: 'Personal',
    exp_material: 'Material',
    exp_professionals: 'Professionals externs',
    exp_groups: 'Catxés de grups',
    exp_supplies: 'Subministraments',
    exp_maintenance: 'Manteniment',
    exp_marketing: 'Comunicació i publicitat',
    exp_others: 'Altres',
    avg_quote: 'Mitjana de la quota de soci/a anual',
    detail: 'Detall',
    inv_building: 'A l\'edifici en general',
    inv_theatre: 'Al teatre',
    inv_bar: 'Al bar',
    inv_accessibility: 'Accessibilitat',
    inv_security: 'Seguretat',
    inv_others: 'Altres',        
        
  },
  
    users_demografy: {
        title: 'Dades demogràfiques',
        create: 'Afegir',      
        edit_title: 'Modificar dades demogràfiques',
        year: 'Any',
        num_members: 'Núm. de socis',
        avg_age: 'Mitjana d\'edat',
        avg_age_managers: 'Mitjana d\'edat junta directiva',
        percent_man: 'Homes (%)',
        percent_woman: 'Dones (%)',
        percent_no_binary: 'No binaris (%)'
    }, 

  users_workers : {
    create_0: 'Afegir resum anual del personal remunerat',
    create_1: 'Afegir resum anual del voluntariat',
    create_button: 'Afegir',
    edit_title_0: 'Modificar resum anual del personal remunerat',
    edit_title_1: 'Modificar resum anual del voluntariat',
    administration: 'Administració',
    activities: 'Tècnic d\'activitats',
    concierge: 'Consergeria',
    clean_up: 'Neteja',
    comunication : 'Comunicació',
    accounting : 'Comptabilitat',
    maintenance : 'Manteniment',
    management : 'Gerència',
    others : 'Altres'      ,
    total_0: 'Total personal remunerat',
    total_1: 'Total personal voluntariat'
  },
  settings :{
    entity_general_data: "Dades generals",
    entity_logo: "Logotip de l’entitat",
    entity_contact: "Dades de contacte",
    entity_location: "Ubicació",
    entity_more_information: "Més informació",
    entity_fiscality: "Fiscalitat (model 182)",
    entity_fiscality_help: "Configuració fiscal utilitzada per generar el model 182. Comprova amb l’assessoria de l’entitat quin règim li correspon.",
    model_182_nature: "Naturalesa del declarant (model 182)",
    model_182_nature_none: "Sense configurar / model 182 no aplicable",
    model_182_nature_1: "1 - Entitat acollida al títol III de la Llei 49/2002",
    model_182_nature_2: "2 - Fundació o associació declarada d’utilitat pública (art. 68.3.b LIRPF)",
    model_182_nature_3: "3 - Patrimoni protegit de persones amb discapacitat",
    model_182_nature_4: "4 - Partit polític, federació, coalició o agrupació d’electors",
    model_182_optional_defaults_help: "Dades opcionals. Si no s’informen, es demanaran en el moment de generar el model.",
    model_182_receipt_number: "Següent número de justificant (13 dígits, començant per 182)",
    model_182_receipt_number_invalid: "El número de justificant ha de tenir 13 dígits, començar per 182 i no pot acabar en deu zeros.",
    model_182_contact_name: "Cognoms i nom de la persona de contacte",
    model_182_contact_phone: "Telèfon de contacte (9 dígits)",
    model_182_contact_phone_invalid: "El telèfon ha de tenir 9 dígits.",
    model_182_unsupported_nature: "Aquesta naturalesa necessita claus i dades específiques per aportació que el mòdul de donatius actual encara no recull; el resum impedirà generar el fitxer.",
    model_182_fiscality_tab: "Fiscalitat model 182",
    model_182_fiscal_year: "Exercici",
    model_182_nature_1_block: "Naturalesa 1 · Entitats beneficiàries de la Llei 49/2002",
    model_182_nature_1_block_help: "Percentatges estatals aplicables als donatius de les entitats beneficiàries dels incentius fiscals al mecenatge.",
    model_182_nature_2_block: "Naturalesa 2 · Fundacions i associacions d’utilitat pública",
    model_182_nature_2_block_help: "Percentatges aplicables a les entitats de l’article 68.3.b de la LIRPF que no estan incloses en la naturalesa 1.",
    model_182_nature_3_block: "Naturalesa 3 · Patrimonis protegits",
    model_182_nature_3_block_help: "Aquesta naturalesa no utilitza percentatges configurables en aquesta pantalla.",
    model_182_nature_4_block: "Naturalesa 4 · Partits polítics, federacions, coalicions o agrupacions d’electors",
    model_182_nature_4_block_help: "Aquest camp configura el percentatge de les quotes d’afiliació i aportacions amb clau F. Els donatius amb clau G utilitzen els percentatges de la naturalesa 1.",
    model_182_list_nature_1_individual: "Naturalesa 1 · Entitats beneficiàries de la Llei 49/2002 · Persones físiques",
    model_182_list_nature_1_legal: "Naturalesa 1 · Entitats beneficiàries de la Llei 49/2002 · Persones jurídiques",
    model_182_list_nature_2: "Naturalesa 2 · Fundacions i associacions d’utilitat pública",
    model_182_list_nature_4: "Naturalesa 4 · Partits polítics, federacions, coalicions o agrupacions d’electors",
    model_182_list_first_tranche_limit: "Límit 1r tram",
    model_182_list_first_tranche: "1r tram",
    model_182_list_standard: "General",
    model_182_list_recurring: "Recurrent",
    model_182_list_individual: "Persona física",
    model_182_list_legal: "Persona jurídica",
    model_182_list_key_f: "Clau F",
    model_182_individuals_block: "Persones físiques",
    model_182_legal_entities_block: "Persones jurídiques",
    model_182_add_fiscal_year: "Afegir exercici fiscal",
    model_182_copy_from_question: "Vols partir de la configuració d’un exercici existent?",
    model_182_copy_from_none: "No, crear una configuració en blanc",
    model_182_edit_fiscal_year: "Editar exercici fiscal",
    model_182_delete_fiscal_year: "Eliminar exercici fiscal",
    model_182_delete_fiscal_year_confirm: "Si l’elimines, les entitats ja no podran generar el model 182 d’aquest exercici.",
    model_182_first_tranche_amount: "Límit del primer tram (€)",
    model_182_first_tranche_percentage: "Primer tram - persona física (%)",
    model_182_individual_standard_percentage: "Persona física - percentatge general (%)",
    model_182_individual_recurring_percentage: "Persona física - percentatge recurrent (%)",
    model_182_legal_standard_percentage: "Persona jurídica - percentatge general (%)",
    model_182_legal_recurring_percentage: "Persona jurídica - percentatge recurrent (%)",
    model_182_nature_2_individual_percentage: "Naturalesa 2 - persona física (%)",
    model_182_nature_2_legal_percentage: "Naturalesa 2 - persona jurídica (%)",
    model_182_nature_4_affiliation_percentage: "Naturalesa 4 - clau F (%)",
    model_182_autonomous_deductions_catalog: "Catàleg de deduccions autonòmiques",
    model_182_autonomous_deductions_catalog_help: "Regles oficials per exercici que les entitats podran seleccionar si compleixen els requisits corresponents.",
    model_182_add_autonomous_deduction: "Afegir deducció autonòmica",
    model_182_autonomous_copy_from_question: "Vols partir de les dades d’una deducció d’un altre exercici?",
    model_182_autonomous_copy_from_none: "No, crear una deducció en blanc",
    model_182_edit_autonomous_deduction: "Editar deducció autonòmica",
    model_182_delete_autonomous_deduction: "Eliminar deducció autonòmica",
    model_182_delete_autonomous_deduction_confirm: "Aquesta regla també deixarà d’estar seleccionada a les entitats que la tinguin configurada.",
    model_182_autonomous_community_code: "Codi de comunitat autònoma",
    model_182_autonomous_community_code_invalid: "El codi ha de tenir exactament dos dígits.",
    model_182_autonomous_name: "Nom",
    model_182_autonomous_percentage: "Percentatge autonòmic (%)",
    model_182_autonomous_active: "Activa",
    model_182_autonomous_deductions: "Deduccions autonòmiques aplicables",
    model_182_autonomous_deductions_help: "Marca només les deduccions per a les quals l’entitat compleix els requisits o consta al cens oficial corresponent.",
    model_182_autonomous_deductions_load_error: "No s’ha pogut carregar el catàleg de deduccions autonòmiques.",
    model_182_autonomous_deductions_save_error: "No s’han pogut desar les deduccions autonòmiques de l’entitat.",
    entity_website: "Pàgina web corporativa",
    entity_longitude: "Longitud",
    entity_latitude: "Latitud",
    entity_about_us: "Qui som",
    entity_opening_hours: "Horaris d’obertura",

    data : 'Dades de l\'entitat',
    data_desc : 'Dades generals, logotip, dades de contacte, ubicació...',
    ibans : 'Bancs',        
    ibans_desc : 'Configuració de comptes bancaris', 
    payment_systems : 'TPV', 
    payment_systems_desc : 'Configuració de passarel·les bancàries', 
    postal_labels : 'Etiquetes postals',        
    postal_labels_desc : 'Configuració del format de les etiquetes postals', 
    alerts: 'Alertes',
    alerts_desc: 'Configuració de les alertes',
    emails: 'Plantilles de correus electrònics',        
    emails_desc: 'Continguts dels correus electrònics que reben les persones',      
    emails_logs: 'Registre d\'enviament de correus electrònics',        
    emails_logs_desc: 'Consulta el registre dels enviaments de correus electrònics als contactes',      
    association: 'Entitat',
    massive_actions: 'Registre d\'accions massives',
    massive_actions_desc: 'Consulta el progrés i cancel·la processos massius',
    users: 'Usuaris administradors',        
    users_desc: 'Persones i permissos d\'accés',    
    tickets_users: 'Venedors a guixeta',        
    tickets_users_desc: 'Usuaris amb permisos per vendre entrades a guixeta',   
    cache_management: 'Gestió de catxé',
    cache_management_desc: 'Gestionar la catxé de Redis i el CDN',
    maintenance: 'Accions de Superadmin',        
    maintenance_desc: 'Processos de base de dades...',   
    general_configuration: 'Configuració general',
    general_configuration_desc: 'Configuració general del Gestió d\'entitats',
    iva: 'IVA',
    tax_percent: 'IVA (%)',
    add_tax: 'Afegir IVA',
    edit_tax: 'Modificar IVA',
    delete_tax_title: 'Esborrar IVA',
    delete_tax_content: 'Segur que vols esborrar aquest tipus d\'IVA?',
    profile: 'Perfil d\'usuari',        
    profile_desc: 'Canvi de contrasenya',        
    subscription : 'Subscripció' ,   
    subscription_desc : 'Canviar la subscripció' ,
    returns_tax: 'Comissió de devolució (€)',
    bank_sufix: 'Sufix ordenant',
    change_password: 'Modificar contrasenya',
    version_front: 'Versió de la interfície',
    version_back: 'Versió del sistema',
    dashboard: 'Personalitza el Gestió d\'entitats',
    dashboard_desc: 'Configuració dels càlculs de les gràfiques',
    dashboard_members_group: 'Grup de contactes a partir del que es fan els càlculs de les gràfiques',
    card_validation: 'Pàgina de validació de carnets digitals',
    card_validation_desc: 'Imatges i camps visibles a la validació pública',
    card_validation_style: 'Estil',
    card_validation_background_color: 'Color de fons',
    card_validation_logos: 'Imatges',
    card_validation_top_logo: 'Imatge superior',
    card_validation_bottom_logo: 'Imatge inferior',
    card_validation_bottom_logo_fac_locked: 'En les entitats FAC, el logo inferior és el logo configurat a l\'entitat FAC.',
    card_validation_fields: 'Camps a mostrar',
    card_validation_show_name: 'Nom i cognoms',
    card_validation_show_nif: 'DNI',
    card_validation_show_birthday: 'Data de naixement',
    card_validation_show_num_member: 'Número de membre',
    card_validation_show_minor: 'Menor d\'edat',
    card_validation_show_association_name: 'Nom de l\'entitat',
    card_validation_show_group_name: 'Nom del grup',
    card_validation_show_date_join: 'Data d\'alta',
    card_validation_show_date_left: 'Data de baixa',
    commissions: 'Preus de serveis',
    commissions_help: 'Aquests preus de serveis i percentatges d\'IVA s\'aplicaran per defecte a les entitats noves. Si cal definir valors diferents per a una entitat concreta, modifica\'ls des de la fitxa de l\'entitat.',
    ara_tickets_commission: 'Preu servei entrades (%)',
    ara_tickets_minimum_fee: 'Import mínim (€ sense IVA)',
    ara_tickets_subscription_fee_per_ticket: "En els abonaments el preu s'aplica per cada entrada de l'abonament",
    service_block_tickets: "Entrades",
    service_block_subscriptions: "Abonaments",
    service_block_donations: "Projectes de donatius",
    ara_subscriptions_commission: "Abonaments (%)",
    ara_subscriptions_tax_percent: "IVA del servei dels abonaments (%)",
    ara_subscriptions_minimum_fee: "Import mínim abonaments (€ sense IVA)",
    tickets_management_fees_included: "Despeses de gestió incloses en el preu de les entrades per defecte",
    default_taxes: "IMPOSTOS",
    subscriptions_vat_percent_default: "Tipus d’IVA dels abonaments per defecte",
    subscriptions_vat_included_default: "IVA inclòs en el preu dels abonaments",
    tickets_vat_percent_default: "Tipus d’IVA per defecte de les entrades",
    tickets_vat_included_default: "IVA inclòs en el preu de les entrades per defecte",
    subscriptions_pricing: "Configuració de preus dels abonaments",
    subscriptions_vat_percent: "Tipus d’IVA dels abonaments (%)",
    subscriptions_vat_included: "IVA inclòs en el preu dels abonaments",
    subscriptions_management_fees_included: "Despeses de gestió incloses en el preu dels abonaments per defecte",
    subscriptions_vat_inherit: "Si es deixa buit, es copiarà el tipus d’IVA de l’entitat.",
    donations_commission: 'Donatius (%)',
    ara_tickets_tax_percent: 'IVA Entrades (%)',
    donations_tax_percent: 'IVA Donatius (%)',
        
    add_member: 'Sol·licitud d\'alta de membres des de la web',    
    add_member_desc: 'Configuració del formulari d\'inscripció',
    add_member_actived: 'Permetre la inscripció des de la web',
    add_member_logo: 'Mostrar la capçalera amb el logotip o el nom de l\'entitat',
    add_member_bank_data: 'Demanar dades bancàries',
    add_member_notification: 'Enviar notificació a l\'entitat al rebre una sol·licitud',
    add_member_notification_destination: 'Destinatari de la notificació',
    add_member_notification_destination_entity: 'Correu de l\'entitat',
    add_member_notification_destination_custom: 'Destinatari personalitzat',
    add_member_notification_email: 'Correu electrònic del destinatari',
    add_member_notification_no_entity_email: 'sense correu informat',
    add_member_form_text: 'Text explicatiu del formulari (HTML)',
    add_member_lopd: 'Text legal sobre el tractament de les dades (HTML)',
    add_member_form_sent: 'Text de confirmació abans de validar el correu-e (HTML)',
    add_member_confirmation: 'Text de confirmació de formulari enviat (HTML)',
    add_member_header_color: 'Color de fons',
    add_member_help: 'Com mostrem el formulari a la nostra pàgina web?',    
    add_member_help_1: 'Afegeix el següent codi HTML a la pàgina on vulguis mostrar el formulari de sol·licitud de soci:',    
    add_member_view_form: 'Accedir al formulari' ,
    add_member_edit_form: 'Configurar formulari' ,
    add_member_pending_list: 'Accedir al llistat de sol·licituds' ,
    add_member_header_show : 'Capçalera',
    add_member_header_show_0 : 'Logotip de l\'entitat',
    add_member_header_show_1 : 'Imatge personalitzada',
    add_member_header_show_2 : 'Nom de l\entitat',
    add_member_header_show_3 : 'Sense capçalera',
    add_member_texts : 'Textos',
    add_member_actions : 'Accions',
    
    add_member_title: 'Títol del formulari',
    add_member_fields: 'Camps del formulari',
    add_member_validate_email: 'L\'usuari ha de verificar el seu correu electrònic',
        
    recercat_add_member: 'Formulari de sol·licitud del Carnet digital Recercat',
    recercat_add_member_desc: 'Configuració del formulari',
    recercat_add_member_actived: 'Formulari actiu',   
    recercat_add_member_help_1: 'Afegeix el següent codi HTML a la pàgina on vulguis mostrar el formulari de sol·licitud de carnet',  
                
    emails_subject : 'Tema',
    emails_content : 'Contingut del missatge',
    emails_message : 'Missatge',
    emails_attached : 'Arxius',   
    emails_group_variants : 'Variants per grup',
    emails_group_variant_create : 'Afegir variant',
    emails_group_variant_group : 'Grup',
    emails_group_variant_empty : 'No hi ha variants per grup',
    emails_group_variant_title : 'Personalització pel grup',
    emails_group_variant_customize : 'Personalitzar plantilla per un grup',
    emails_group_variant_delete_title : 'Esborrar personalització',
    emails_group_variant_delete_confirm : 'Segur que vols esborrar aquesta personalització de plantilla?',
    emails_copy : 'Copiar plantilles necessàries a les entitats',   
    emails_copy_desc : 'Es copiaran les plantilles de correus a aquelles entitats que encara no les tinguin. Útil per quan creem una nova plantilla. Si alguna entitat ja la té, no es sobrescriurà.',   
    emails_vars : 'Variables disponibles',
        
    ibans_copy : 'Crear registre de IBAN\'s',   
    ibans_copy_desc : 'Es copiaran els IBAN\'s actuals de totes les entitats, a una taula específica d\'IBAN\'s (si encara no s\'havia fet), per a poder treballar a partir d\'ara amb múltiples IBAN\'s per entitat.',   
    done : 'Acció realitzada',
    
    backup : 'Crear còpia de seguretat',   
    backup_desc : 'Es realitza una còpia de seguretat de la base de dades en aquest moment.',   
        
    remittances_subscriptions: 'Crear subscripció a Rebuts per a totes les entitats',
    remittances_subscriptions_desc: 'Es crearà una subscripció a Rebuts de totes les entitats que tinguin la subscripció Gestió d\'entitats, sempre i quan no la tinguin ja, i no siguin l\'entitat Recercat.',
    
    sa_postal_labels: 'Crea configuració d\'etiquetes postals per a totes les entitats',
    sa_postal_labels_desc: 'Es crearà una configuració per defecte per a totes les entitats que encara no tinguin cap configuració d\'etiquetes configurada. ',
        
    emails_WELCOME : 'Correu de benvinguda de soci/a',
    emails_WELCOME_desc : 'Plantilla per defecte per als nous clients',
    emails_WELCOME_vars : '%nom_entitat% | %nom% | %nom_complet% | %nom_grup% | %num_soci% | %data_ingres%',
    
    emails_GROUP_LEFT : 'Correu de baixa de soci/a',
    emails_GROUP_LEFT_desc : 'Plantilla per defecte per a informar de la baixa de soci',
    emails_GROUP_LEFT_vars : '%nom_entitat% | %nom% | %nom_complet% | %nom_grup% | %num_soci% | %data_ingres% | %data_baixa%',
        
    emails_CLASSROOM_REQUEST : 'SISTEMA - Notificació de que s\'ha rebut una sol·licitud d\'espai',
    emails_CLASSROOM_REQUEST_desc : 'Correu que reben les entitats quan hi ha una sol·licitud d\'ús d\'espai',
    emails_CLASSROOM_REQUEST_vars : '%back_url% | %classroom_name% | %date_request% | %event_date% | %event_duration% | %event_recurrency% | %event_name% | %event_description% | %event_resources% | %comments% | %first_name% | %last_name_1% | %last_name_2% | %email% | %phone% | %association_name%',
        
    emails_ADDMEMBER_REQUEST : 'SISTEMA - Notificació de que s\'ha rebut una sol·licitud de soci/a',
    emails_ADDMEMBER_REQUEST_desc : 'Correu que reben les entitats quan hi ha una sol·licitud d\'alta de soci',
    emails_ADDMEMBER_REQUEST_vars : '%back_url%',
        
    emails_UNDELIVERED_EMAILS : 'SISTEMA - Notificació de correus no enviats /a',
    emails_UNDELIVERED_EMAILS_desc : 'Correu que reben les entitats quan alguns correus no s\'han pogut enviar',
    emails_UNDELIVERED_EMAILS_vars : '%emails_list%',
        
    emails_RESET_PSWD : 'SISTEMA - Notificació de recuperació de contrasenya',
    emails_RESET_PSWD_desc : 'Correu que reben els usuaris administradors si obliden la contrasenya',
    emails_RESET_PSWD_vars : '%reset_link%',
                
    emails_RECEIVE_RETURNED : 'Correu de rebut retornat (banc)',
    emails_RECEIVE_RETURNED_desc : 'Plantilla per defecte per als nous clients',
    emails_RECEIVE_RETURNED_vars : '%nom% | %email_entitat%',
        
    emails_RECEIVE_RETURNED_CASH : 'Correu de rebut impagat (efectiu)',
    emails_RECEIVE_RETURNED_CASH_desc : 'Plantilla per defecte per als nous clients',
    emails_RECEIVE_RETURNED_CASH_vars : '%nom% | %email_entitat%',
    
    emails_EVENT_INVITE : 'Correu d\'invitació a esdeveniment',
    emails_EVENT_INVITE_desc : 'Plantilla per defecte per als nous clients',
    emails_EVENT_INVITE_vars : '%nom% | %nom_esdeveniment% | %activitat% | %data_ini% | %espai% | %email_entitat% | %url_event%',
        
    emails_EVENT_REMINDER : 'Correu de recordatori d\'esdeveniment',
    emails_EVENT_REMINDER_desc : 'Plantilla per defecte per als nous clients',
    emails_EVENT_REMINDER_vars : '%nom% | %nom_esdeveniment% | %tipus% | %data_ini% | %data_fi% | %espai% | %url_event%',
        
    emails_ANNUARY_SEND : 'Anuari: Correu amb l\'enllaç al formulari',
    emails_ANNUARY_SEND_desc : 'Plantilla per defecte per als nous clients',
    emails_ANNUARY_SEND_vars : '%nom% | %year% | %date_expiration% | %link%',
        
    emails_ANNUARY_REMINDER : 'Anuari: Correu de recordatori amb l\'enllaç al formulari',
    emails_ANNUARY_REMINDER_desc : 'Plantilla per defecte per als nous clients',
    emails_ANNUARY_REMINDER_vars :  '%nom% | %year% | %date_expiration% | %link%',
        
    emails_ANNUARY_CONFIRM : 'Anuari: Correu de confirmació amb l\'enllaç a les dades introduïdes',
    emails_ANNUARY_CONFIRM_desc : 'Plantilla per defecte per als nous clients',
    emails_ANNUARY_CONFIRM_vars :  '%nom% | %year% | %date_expiration% | %link%',
        
    emails_DIGITAL_CARD_SEND : 'Correu d\'entrega del carnet digital',
    emails_DIGITAL_CARD_SEND_desc : 'Plantilla per defecte per als nous clients',
    emails_DIGITAL_CARD_SEND_vars :  '%nom% | %nom_complet% | %nom_entitat% | %nom_grup% | %num_membre% | %google_wallet_link% | %google_wallet_image_and_link% | %apple_wallet_link% | %apple_wallet_image_and_link%',
    
    emails_USER_VALIDATE_EMAIL : 'Correu de validació de la sol·licitud web',
    emails_USER_VALIDATE_EMAIL_desc : 'Plantilla per defecte per als nous clients',
    emails_USER_VALIDATE_EMAIL_vars : '%nom_entitat% | %nom% | %nom_complet% | %nom_entitat% | %nom_centre% | %link%',
        
    emails_USER_REQUEST_OK : 'Correu de sol·licitud acceptada',
    emails_USER_REQUEST_OK_desc : 'Plantilla per defecte per als nous clients',
    emails_USER_REQUEST_OK_vars : '%nom_entitat% | %nom% | %nom_complet% | %nom_entitat% | %nom_centre% | %link%',
        
    emails_RECERCAT_USER_REQUEST_KO : 'Correu de de sol·licitud errònia',
    emails_RECERCAT_USER_REQUEST_KO_desc : 'Plantilla per defecte per als nous clients',
    emails_RECERCAT_USER_REQUEST_KO_vars : '%nom_entitat% | %nom% | %nom_complet% | %nom_entitat% | %nom_centre% | %link%',
        
    emails_RECERCAT_CARD_REVOKED_BY_IRMU_CENTER_DELETED : 'Correu de revocació de carnet degut a centre eliminat',
    emails_RECERCAT_CARD_REVOKED_BY_IRMU_CENTER_DELETED_desc : 'Plantilla per defecte per als nous clients',
    emails_RECERCAT_CARD_REVOKED_BY_IRMU_CENTER_DELETED_vars : '%nom_entitat% | %nom% | %nom_complet% | %nom_entitat% | %nom_centre% | %link%',
        
    emails_RECERCAT_IRMU_RESUME : 'Correu de resum (IRMU)',
    emails_RECERCAT_IRMU_RESUME_desc : 'Plantilla per defecte per als nous clients',
    emails_RECERCAT_IRMU_RESUME_vars : '%nom_entitat% | %link% | %num_validats% | %num_pendents_irmu% | %num_pendents_centre%',
        
    emails_RECERCAT_CENTER_RESUME : 'Correu de resum (centre)',
    emails_RECERCAT_CENTER_RESUME_desc : 'Plantilla per defecte per als nous clients',
    emails_RECERCAT_CENTER_RESUME_vars : '%nom_entitat% | %nom_centre% | %num_membre% | %link% | %num_validats% | %num_pendents_irmu% | %num_pendents_centre%',
        
    emails_USER_REQUEST_DENIED : 'Correu de sol·licitud denegada',
    emails_USER_REQUEST_DENIED_desc : 'Plantilla per defecte per als nous clients',
    emails_USER_REQUEST_DENIED_vars : '%nom% | %nom_complet% | %nom_entitat% | %nom_centre%',
        
    emails_RECERCAT_REQUEST_DENIED_BY_CENTER : 'Correu de sol·licitud denegada des del centre',
    emails_RECERCAT_REQUEST_DENIED_BY_CENTER_desc : 'Plantilla per defecte per als nous clients',
    emails_RECERCAT_REQUEST_DENIED_BY_CENTER_vars : '%nom% | %nom_complet% | %nom_entitat% | %nom_centre%',
        
    emails_RECERCAT_CARD_REVOKED_BY_IRMU : 'Correu de carnet revocat des de l\'IRMU',
    emails_RECERCAT_CARD_REVOKED_BY_IRMU_desc : 'Plantilla per defecte per als nous clients',
    emails_RECERCAT_CARD_REVOKED_BY_IRMU_vars : '%nom% | %nom_complet% | %nom_entitat% | %nom_centre% | %num_membre%',
        
    emails_RECERCAT_CARD_REVOKED_BY_CENTER : 'Correu de carnet revocat des del centre',
    emails_RECERCAT_CARD_REVOKED_BY_CENTER_desc : 'Plantilla per defecte per als nous clients',
    emails_RECERCAT_CARD_REVOKED_BY_CENTER_vars : '%nom% | %nom_complet% | %nom_entitat% | %nom_centre% | %num_membre%',
                
    emails_ANNUARY_FORM_ANSWERED : 'FEDERACIÓ - Correu de notificació de resposta de formulari de l\'anuari',
    emails_ANNUARY_FORM_ANSWERED_desc : 'Només el rep la FAC',
    emails_ANNUARY_FORM_ANSWERED_vars :  '%name% | %year%',
        
    emails_ANNUARY_FORM_NUM_MEMBERS : 'FEDERACIÓ - Correu de notificació de canvi de número de socis',
    emails_ANNUARY_FORM_NUM_MEMBERS_desc : 'Només el rep la FAC',
    emails_ANNUARY_FORM_NUM_MEMBERS_vars :  '%nom% | %year% | %old_num_members% | %new_num_members%',
    
    emails_DONATIONS_USERS_CONFIRMATION : 'Donatius: Correu de confirmació d\'una donació',
    emails_DONATIONS_USERS_CONFIRMATION_desc : 'El rep el donant automàticament en el moment de fer la donació a través de la web',
    emails_DONATIONS_USERS_CONFIRMATION_vars :  '%nom% | %nom_complet% | %referencia% | %amount% | %nom_projecte% | %date_time% | %entitat_projecte%',
    
    emails_DONATIONS_USERS_PRE_CONFIRMATION_TRANSFER : 'Donatius: Correu amb instruccions per a fer la transferència bancària',
    emails_DONATIONS_USERS_PRE_CONFIRMATION_TRANSFER_desc : 'El rep el donant automàticament en el moment de fer la donació per transferència bancària',
    emails_DONATIONS_USERS_PRE_CONFIRMATION_TRANSFER_vars :  '%nom% | %nom_complet% | %referencia% | %amount% | %bank_ordering% | %bank_iban% | %bank_swift% | %nom_projecte% | %date_time% | %entitat_projecte%',
    
    emails_DONATIONS_USERS_CERTIFICATE : 'Correu d\'enviament del certificat de donació',
    emails_DONATIONS_USERS_CERTIFICATE_desc : 'El rep el donant',
    emails_DONATIONS_USERS_CERTIFICATE_vars : '%year% | %nom% | %nom_complet% | %nif% | %total_sum_donations%',
    
    emails_DONATIONS_RESUME_ASSOCIATION : 'Donatius: Correu de resum dels donatius',
    emails_DONATIONS_RESUME_ASSOCIATION_desc : 'El reben setmanalment les entitats. Un correu per cada projecte de donatius actius',
    emails_DONATIONS_RESUME_ASSOCIATION_vars : '%project_name% | %amount% | %count_donations% | %sum_donations% | %sum_donations_percent% | %avg_donations% | %date_start% | %date_finish% | %if_target_by_date_ini% | %if_target_by_date_end%',
    
    emails_DONATIONS_RESUME_FAC : 'Donatius: Correu de resum dels donatius',
    emails_DONATIONS_RESUME_FAC_desc : 'El rep setmanalment la FAC, amb el resum de tots els projectes actius',
    emails_DONATIONS_RESUME_FAC_vars : '%iteration_project_ini% | %iteration_project_end% | %total_projects% | %total_sum_donations% | %total_count_donations% | %total_avg_donations% | %association_name% | %project_name% | %amount% | %count_donations% | %sum_donations% | %sum_donations_percent% | %avg_donations% | %date_start% | %date_finish% | %if_target_by_date_ini% | %if_target_by_date_end%',
      
    emails_DONATIONS_VALIDATE_REQUEST : 'Donatius: Correu de sol·licitud de validació',
    emails_DONATIONS_VALIDATE_REQUEST_desc : 'El rep la FAC quan l\'entitat demana de validar el projecte',
    emails_DONATIONS_VALIDATE_REQUEST_vars : '%association_name% | %project_name%',
    
    emails_DONATIONS_VALIDATE_ACCEPTED : 'Donatius: Correu de validació de projecte',
    emails_DONATIONS_VALIDATE_ACCEPTED_desc : 'El rep l\'entitat quan la FAC ha validat el projecte.',
    emails_DONATIONS_VALIDATE_ACCEPTED_vars : '%association_name% | %project_name%',
    
    emails_DONATIONS_VALIDATE_REJECTED : 'Donatius: Correu de denegació de validació de projecte',
    emails_DONATIONS_VALIDATE_REJECTED_desc : 'El rep l\'entitat quan la FAC ha rebutjat el projecte.',
    emails_DONATIONS_VALIDATE_REJECTED_vars : '%association_name% | %project_name%',
        
    emails_NEW_ADMIN : 'SISTEMA - Correu d\'invitació d\'administrador',  
    emails_NEW_ADMIN_desc : 'El reben els nous administradors',  
    emails_NEW_ADMIN_vars : '%back_url% | %auth_user% | %auth_pswd% | %association_name%',  

    emails_NEW_ADMIN_PERMISSION : 'SISTEMA - Correu de nou permís d\'administrador',
    emails_NEW_ADMIN_PERMISSION_desc : 'S\'envia quan es concedeix a un administrador accés a una nova entitat',
    emails_NEW_ADMIN_PERMISSION_vars : '%back_url% | %auth_user% | %association_name%',
    
    emails_TICKETS_NEW_ADMIN: 'Entrades - Correu d\'invitació d\'administrador',  
    emails_TICKETS_NEW_ADMIN_desc: 'El reben els nous administradors',
    emails_TICKETS_NEW_ADMIN_vars : '%back_url% | %auth_user% | %auth_pswd% | %association_name%',
        
    emails_ASSOCIATIONS_TRIAL : 'SISTEMA - Correu de suport durant el període de prova',  
    emails_ASSOCIATIONS_TRIAL_desc : 'S\'envia manualment a les associacions durant el període de prova',  
    emails_ASSOCIATIONS_TRIAL_vars : '%nom% | %email%',  
    
    emails_ASSOCIATIONS_BEGIN : 'SISTEMA - Correu d\'inici de la subscripció',  
    emails_ASSOCIATIONS_BEGIN_desc : 'S\'envia manualment a les associacions',  
    emails_ASSOCIATIONS_BEGIN_vars : '%nom% | %email%',  
    
    emails_ASSOCIATIONS_END : 'SISTEMA - Correu de finalització de període de prova',  
    emails_ASSOCIATIONS_END_desc : 'S\'envia manualment a les associacions',  
    emails_ASSOCIATIONS_END_vars : '%nom% | %email%',  
    
    emails_NEW_SENDER : 'SISTEMA - Correu de nou remitent de correu',
    emails_NEW_SENDER_desc : 'S\'envia quan una entitat afegeix un nou remitent de correu',
    emails_NEW_SENDER_vars : '%user_email% | %email_entitat% | %sender_email% | %link%',
    
    emails_ALERT : 'SISTEMA - Alertes de les entitats',
    emails_ALERT_desc : 'Notificació d\'alerta',
    emails_ALERT_vars : '%association_name% | %message% | %date_alert%',
             
    emails_SKELETON : 'Esquelet de tots els correus',
    emails_SKELETON_desc : 'Plantilla per defecte per als nous clients',
    emails_SKELETON_vars : '%tema% | %contingut% | %nom_entitat% | %email_entitat% | %logotip%',
        
    emails_SA_SKELETON : 'SISTEMA - Esquelet de tots els correus',
    emails_SA_SKELETON_desc : 'Esquelet de tots els correus enviats des del sistema',
    emails_SA_SKELETON_vars : '%tema% | %contingut%',
    
    emails_USER_LOGIN_VALIDATE : 'Entrades - Correu de validació de compte d\'usuari',  
    emails_USER_LOGIN_VALIDATE_desc : 'S\'envia un enllaç per validar el compte de l\'usuari',  
    emails_USER_LOGIN_VALIDATE_vars : '%message% | %link%',  
    
    emails_MAGIC_LINK : 'SISTEMA - Màgic link per fer login sense contrasenya',  
    emails_MAGIC_LINK_desc : 'S\'envia un enllaç per autenticar-se sense contrasenya',  
    emails_MAGIC_LINK_vars : '%link%',  
    
    emails_TICKETS_NEW_VALIDATOR : 'Entrades - Correu de nou validador',  
    emails_TICKETS_NEW_VALIDATOR_desc : 'S\'envia un enllaç per autoritzar un nou validador d\'entrades',  
    emails_TICKETS_NEW_VALIDATOR_vars : '%event_name% | %event_session% | %event_address% | %validator_name% | %validator_date_start% | %validator_date_finish% | %link% | %associations_name%',  
        
    emails_TICKETS_CONFIRM : 'Entrades - Correu de confirmació de compra',  
    emails_TICKETS_CONFIRM_desc : 'Correu de confirmació i enllaç a les entrades',  
    emails_TICKETS_CONFIRM_vars : '%event_name% | %event_session% | %event_friendly_url% | %download_link% | %text_footer%',

    emails_TICKETS_SUBSCRIPTION_CONFIRM : 'Entrades - Correu de confirmació d\'abonament',
    emails_TICKETS_SUBSCRIPTION_CONFIRM_desc : 'Correu de confirmació amb els codis dels abonaments i les instruccions d\'ús',
    emails_TICKETS_SUBSCRIPTION_CONFIRM_vars : '%customer_name% | %subscription_name% | %subscription_codes% | %subscription_uses_total% | %subscription_link% | %subscription_info_link% | %associations_name% | %associations_email%',

    emails_TICKETS_RESERVATION_CONFIRM : 'Entrades - Correu de confirmació de reserva',
    emails_TICKETS_RESERVATION_CONFIRM_desc : 'Correu de confirmació de la reserva i de les dades de pagament',
    emails_TICKETS_RESERVATION_CONFIRM_vars : '%event_name% | %event_session% | %event_address% | %event_friendly_url% | %reservation_name% | %reservation_comments% | %associations_name% | %associations_email%',

    emails_TICKETS_RESERVATION_PAYMENT_REMINDER : 'Entrades - Avís de pagament pendent de reserva',
    emails_TICKETS_RESERVATION_PAYMENT_REMINDER_desc : 'Recorda al titular que la reserva continua pendent de pagament',
    emails_TICKETS_RESERVATION_PAYMENT_REMINDER_vars : '%reservation_name% | %reservation_comments% | %event_name% | %event_session% | %event_address% | %event_friendly_url% | %associations_name% | %associations_email% | %reservation_payment_period_finish% | %reservation_amount% | %reservation_payment_method% | %reservation_bank_ordering% | %reservation_bank_iban% | %reservation_payment_concept%',

    emails_TICKETS_RESERVATION_CANCELLED : 'Entrades - Correu de cancel·lació de reserva',
    emails_TICKETS_RESERVATION_CANCELLED_desc : 'Confirma al titular que la seva reserva ha estat cancel·lada',
    emails_TICKETS_RESERVATION_CANCELLED_vars : '%reservation_name% | %event_name% | %event_session% | %event_address% | %event_friendly_url% | %associations_name% | %associations_email%',

    emails_TICKETS_RESERVATION_CANCELLED_NON_PAYMENT : 'Entrades - Cancel·lació automàtica de reserva per impagament',
    emails_TICKETS_RESERVATION_CANCELLED_NON_PAYMENT_desc : 'Informa que la reserva s\'ha cancel·lat perquè no s\'ha pagat dins del termini',
    emails_TICKETS_RESERVATION_CANCELLED_NON_PAYMENT_vars : '%reservation_name% | %event_name% | %event_session% | %event_address% | %event_friendly_url% | %associations_name% | %associations_email%',

    emails_TICKETS_REMINDER : 'Entrades - Avís de proximitat de l\'esdeveniment',
    emails_TICKETS_REMINDER_desc : 'S\'envia abans de la sessió per recordar-ne les dades al comprador',
    emails_TICKETS_REMINDER_vars : '%event_name% | %event_session% | %event_friendly_url% | %associations_name% | %associations_email%',

    emails_TICKETS_CUSTOM : 'Entrades - Enviament personalitzat',
    emails_TICKETS_CUSTOM_desc : 'Permet enviar un missatge personalitzat relacionat amb una compra d\'entrades',
    emails_TICKETS_CUSTOM_vars : '%event_name% | %event_session% | %event_friendly_url% | %associations_name% | %associations_email% | %custom_content%',

    emails_TICKETS_SESSION_DATE_CHANGED : 'Entrades - Canvi de data de la sessió',
    emails_TICKETS_SESSION_DATE_CHANGED_desc : 'Informa de la nova data i permet cancel·lar la compra si no es pot assistir',
    emails_TICKETS_SESSION_DATE_CHANGED_vars : '%event_name% | %event_session% | %new_event_session% | %event_friendly_url% | %associations_email% | %cancel_purchase_url%',

    emails_TICKETS_BOOKING_CANCELLED : 'Entrades - Cancel·lació de les entrades',
    emails_TICKETS_BOOKING_CANCELLED_desc : 'Informa que les entrades de la compra s\'han cancel·lat i ja no són vàlides',
    emails_TICKETS_BOOKING_CANCELLED_vars : '%event_name% | %event_session% | %associations_email% | %cancellation_reason% | %refund_section%',

    emails_TICKETS_EVENT_CANCELLED : 'Entrades - Cancel·lació de l\'esdeveniment',
    emails_TICKETS_EVENT_CANCELLED_desc : 'Informa que l\'esdeveniment s\'ha cancel·lat i mostra les opcions disponibles',
    emails_TICKETS_EVENT_CANCELLED_vars : '%event_name% | %event_session% | %associations_email% | %cancellation_reason% | %refund_section% | %subscription_management_section%',

    emails_TICKETS_PAYMENT_OUT_OF_TERM : 'Entrades - Pagament fora de termini',
    emails_TICKETS_PAYMENT_OUT_OF_TERM_desc : 'Informa que el pagament ha arribat fora de termini i permet sol·licitar-ne la devolució',
    emails_TICKETS_PAYMENT_OUT_OF_TERM_vars : '%event_name% | %event_session% | %associations_email% | %refund_url%',

    emails_DONATIONS_LIQUIDATION_STATEMENT : 'DONATIUS - Correu de liquidació de pagaments',
    emails_DONATIONS_LIQUIDATION_STATEMENT_desc : 'S\'envia a l\'entitat amb el resum dels pagaments i l\'estat de la liquidació',
    emails_DONATIONS_LIQUIDATION_STATEMENT_vars : '%association_name% | %project_name% | %total_collected% | %management_expenses% | %management_tax% | %total_to_transfer% | %total_transferred% | %pending_transfer% | %payment_table%',

    emails_DONATIONS_COLLECTION_STATEMENT : 'DONATIUS - Correu de liquidació de cobraments',
    emails_DONATIONS_COLLECTION_STATEMENT_desc : 'S\'envia a l\'entitat amb el resum dels cobraments i l\'estat de la liquidació',
    emails_DONATIONS_COLLECTION_STATEMENT_vars : '%association_name% | %project_name% | %total_collected% | %management_expenses% | %management_tax% | %total_to_collect% | %total_already_collected% | %pending_collection% | %payment_table%',
    
    emails_headers : 'Capçalera',
    emails_headers_sender_name : 'Nom del remitent',
    emails_headers_sender_email : 'Correu electrònic del remitent',
    emails_headers_reply_to : 'Respondre a',
    emails_headers_cc : 'Cc',
    emails_headers_bcc : 'Bcc',
    emails_headers_vars : '%nom_entitat% | %email_entitat%', 
    emails_headers_tickets_vars : '%nom_entitat% | %email_entitat% | %project_name%',
        
    classrooms_requests: 'Sol·licitud d\'ús d\'espais des de la web',
    classrooms_requests_desc: 'Configuració de la sol·licitud d\'espais',
    classrooms_requests_actived: 'Permetre la sol·licitud d\'ús des de la web',
    classrooms_requests_logo: 'Mostrar la capçalera amb el logotip i les dades de l\'entitat en el formulari',
    classrooms_requests_notification: 'Enviar notificació a l\'entitat al rebre una sol·licitud',
    classrooms_requests_text: 'Text a la capçalera de la pàgina de resum d\'espais',
    classrooms_requests_lopd: 'Text legal de política de protecció de dades',
    classrooms_requests_form_sent: 'Text de confirmació de formulari enviat',
    classrooms_requests_help: 'Com mostrem els espais a la nostra pàgina web?',    
    classrooms_requests_help_1: 'Afegeix el següent codi HTML a la pàgina on vulguis mostrar els espais de l\'entitat:',    
    classrooms_requests_view_form: 'Accedir a la web' ,
    
    donations_certificates: 'Certificat de donacions',
    donations_certificates_desc: 'Configuració del contingut del certificat de donació (HTML)',
    donations_certificates_confirmation: 'Emetre certificat de donatiu en el correu de confirmació de donatiu',
    donations_certificates_donations_users_certificate: 'Contingut del certificat de donació',
    donations_certificates_donations_users_certificate_vars_title: 'Variables disponibles',
    
    donations_certificates_donations_users_certificate_vars: '%year% | %entitat_nom% | %entitat_address% | %entitat_zip% | %entitat_city% | %entitat_country% | %entitat_nif% | %entitat_email% | %entitat_firma% | %nom% | %cognom1% | %cognom2% | %email% | %nom_complet% | %nif% | %address% | %zip% | %phone% | %city% | %country% | %iteration_donations_ini% | %amount% | %date_time% | %nom_projecte% | %justificacio_projecte% | %iteration_donations_end% | %total_sum_donations% | %data_certificat%',
    donations_certificates_header: 'Capçalera',
    donations_certificates_sign: 'Firma del responsable',
    donations_certificates_footer : 'Peu del certificat',
    
    docs: 'Documents públics',
    docs_desc: 'Imatges, documents... de l\'entitat accessibles a través d\'una URL pública',
    
    donations_own: 'Pàgina de donatius',
    donations_own_desc: 'Configuració del disseny de la pàgina de donatius',
    donations_own_donations_own_header: 'Capçalera',
    donations_own_donations_own_footer: 'Peu',
    donations_own_donations_own_privacy: 'Política de privadesa',
    donations_own_donations_own_terms: 'Termes i condicions',
    donations_own_donations_own_fiscal: 'Beneficis fiscals',
    donations_own_donations_own_css: 'CSS addicional',
            
    annuary_form: 'Formulari per a realitzar l\'anuari',
    annuary_form_desc: 'Configuració del formulari per a realitzar l\'anuari',
    annuary_form_logo: 'Mostrar la capçalera amb el logotip i les dades de la FAC en el formulari',
    annuary_form_notification: 'Enviar notificació a la FAC al rebre una resposta',
    annuary_form_notification_association: 'Enviar notificació a l\'entitat al respondre el formulari amb un enllaç a les seves respostes',
    annuary_form_notification_num_members: 'Enviar notificació a la FAC al modificar el número de membres d\'una entitat',
    annuary_form_text: 'Text a la capçalera de la pàgina',
    annuary_form_lopd: 'Text legal de política de protecció de dades',
    annuary_form_sent: 'Text de confirmació de formulari enviat',
        
    templates_copied: 'S\'han copiat les plantilles a totes les entitats',
        
    profile_user_tab: 'Usuari',
    profile_pswd_tab: 'Contrasenya',
    profile_password: 'Nova contrasenya',
    profile_password_confirmation: 'Confirma contrasenya',
    profile_changed: 'S\'ha modificat el perfil d\'usuari',
        
        
        
  },
  contacts : {
    title: 'Contactes de la FAC',
    description: 'En aquest apartat trobaràs una base de dades general i compartida per a tots els ateneus amb la finalitat d\'ajudar-vos a tenir actualitzats els contactes d\'administracions i contactes d\'interès. <br/>Us agrairem que si trobeu algun error ens ho feu saber per poder-lo corregir el més aviat possible.'
  },
  massive_actions: {
    title: 'Accions massives',
    desc: 'Consulta el progrés dels processos massius i cancel·la les accions que encara estan en curs.',
    created_at: 'Data',
    association: 'Entitat',
    type: 'Tipus',
    status: 'Estat',
    progress: 'Progrés',
    elements: 'Elements',
    elapsed: 'Temps',
    remaining: 'Estimació',
    remaining_approx: 'Queden %{time} aprox.',
    actions: 'Accions',
    cancel: 'Cancel·lar',
    failed: 'Errors',
    skipped: 'Saltats',
    empty: 'No hi ha accions massives.',
    cancelled_ok: 'Acció cancel·lada',
    global_action: 'Acció global',
    type_bookings_email: 'Correus de reserves',
    type_digital_cards: 'Enviament de carnets digitals',
    type_unknown: 'Desconegut',
    status_queued: 'En cua',
    status_running: 'En procés',
    status_paused: 'Pausada',
    status_completed: 'Completada',
    status_completed_with_errors: 'Completada amb errors',
    status_cancelled: 'Cancel·lada',
    status_failed: 'Fallida',
    status_unknown: 'Desconegut'
  },
  redis_cache: {
    cdn_enabled: 'Les imatges i documents públics són accessibles per CDN',
    cdn_url: 'Adreça del CDN',
    cdn_updated: 'Configuració del CDN actualitzada',
    pattern: 'Patró',
    internal_id: 'Identificador intern',
    description: 'Descripció',
    key_count: 'Número de claus',
    total_size: 'Mida total',
    key: 'Key',
    keys: 'claus',
    ttl: 'TTL',
    ttl_seconds: 'TTL (segons)',
    modify_ttl: 'Modificar TTL',
    modify_configuration: 'Modificar configuració',
    priority: 'Prioritat',
    ttl_updated: 'TTL actualitzat',
    configuration_updated: 'Configuració actualitzada',
    invalid_ttl: 'El TTL ha de ser un nombre enter igual o superior a zero.',
    ttl_zero_help: 'El valor 0 desactiva aquesta catxé.',
    size: 'Mida',
    type: 'Tipus',
    content: 'Contingut',
    total_cache: 'Total catxé',
    selected_pattern: 'Patró seleccionat',
    filter: 'Filtrar keys',
    only_without_ttl: 'Només sense TTL',
    refresh: 'Refrescar',
    purge: 'Purgar',
    purge_all: 'Purgar tots',
    purge_selected: 'Purgar seleccionades',
    purged: 'Elements purgats',
    key_purged: 'Key purgada',
    purge_all_confirm: 'Segur que vols purgar totes les claus d’aquesta catxé?',
    purge_selected_confirm: 'Segur que vols purgar les keys seleccionades?',
    purge_key_confirm: 'Segur que vols purgar aquesta key?',
    copied: 'Copiat al porta-retalls',
    copy_content: 'Copiar contingut',
    load_more: 'Carregar més',
    ttl_forever: 'Sense caducitat',
    cache_disabled: 'Catxé desactivada',
    ttl_not_found: 'No existeix',
    no_keys: 'No hi ha keys per aquest pattern'
  },
  add_member : {
    association_not_found: 'No s\'ha trobat l\'entitat',
    form_not_actived: 'Disculpeu les molèsties, el formulari no està actiu.',
    form_title: 'Sol·licitud d\'alta de soci/a',
    recercat_form_title: 'Sol·licitud de carnet Recercat',
    recercat_association_not_found: 'La pàgina no s\'ha trobat',
    recercat_request_send : 'Enviar sol·licitud',
    form_lopd: 'Consento el tractament de les dades per a les finalitats descrites a l’enllaç següent: ',
    form_lopd_validator: 'Heu de consentir el tractament de les dades',        
    lopd: 'Tractament de les dades',
  },
  classrooms_requests : {
    association_not_found: 'No s\'ha trobat l\'entitat o l\'espai no està disponible',
    form_not_actived: 'No hi ha espais disponibles',
    form_title: 'Els nostres espais',
    form_request_title: 'Sol·licitud d\'ús de l\'espai',
    form_event_data_title: 'Dades de l\'activitat:',
    form_requester_data_title: 'Dades del sol·licitant:',
    form_represented_association_title: 'Entitat que representa:',
    form_association_name: 'Nom de l\'entitat',
    form_event_date: 'Data i hora',
    form_event_duration: 'Durada (hores)',
    form_event_recurrency: 'És una activitat recurrent? Indica totes les dates.',
    form_event_name: 'Nom de l\'activitat',
    form_event_description: 'Descripció',
    form_event_resources: 'Recursos que es necessiten per a l\'activitat',
    form_event_comments: 'Altres comentaris',
    form_event_phone: 'Telèfon de contacte',        
    form_send: 'Sol·licitar',   
    form_doc: 'Veure fitxa tècnica',
    form_doc_title: 'fitxa_tècnica'
  },
  emails: {
    main_menu_title: 'Correus electrònics enviats',
    create: 'Afegir emails',
    type: 'Plantilla',
    date_ordered: 'Data',
    from: 'Remitent',
    to: 'Destinatari',
    subject: 'Tema',
    content: 'Contingut',
    docs: 'Adjunts',
    date_sent: 'Data',
    status: 'Estat',
    error_message: 'Missatge d\'error',        
    status_0: 'No enviat',
    status_1: 'Enviant a servidor de correu...',
    status_2: 'Error en el servidor de correu',
    status_3: 'Enviat',
    status_4: 'Correu rebutjat',
    exporter_file_name: 'emails',
    contact: 'Contacte',
    only_not_sent: 'Només correus no enviats',
    aws_ses_tracking: 'Seguiment AWS SES',
    aws_ses_message_id: 'Identificador AWS SES',
    delivery_provider: 'Servei d\'enviament',
    delivery_provider_aws_ses: 'AWS SES',
    delivery_provider_smtp: 'SMTP',
    delivered_at: 'Entregat',
    bounced_at: 'Rebotat',
    complained_at: 'Queixa',
    opened_at: 'Obert',
    clicked_at: 'Clicat',
    aws_ses_status_sending: 'Enviant',
    aws_ses_status_sent: 'Enviat',
    aws_ses_status_delivered: 'Entregat',
    aws_ses_status_bounced: 'Rebotat',
    aws_ses_status_complained: 'Queixa',
    aws_ses_status_opened: 'Obert',
    aws_ses_status_clicked: 'Clicat',
    aws_ses_status_error: 'Error',
    aws_ses_status_pending: 'Pendent',
    details_title: 'Detall dels enviaments',
    details_tooltip: 'Veure detall de l\'enviament',
    details_date_ordered: 'Data de l\'ordre',
    details_date_sent: 'Data d\'enviament',
    details_not_found: 'No s\'ha trobat el detall de l\'enviament'
  }, 
  custom_fields: {
    main_menu_title: 'Camps addicionals',
    main_menu_desc: 'Administra camps addicionals per a emmagatzemar més dades dels contactes',
    target_2: 'Dades de contactes',    
    title_2: 'Camps addicionals',
    target_31: 'Dades generals de federació',
    title_31: 'Camps addicionals generals de Federació',
    target_50: 'Responsable dades esportives',
    title_50: 'Responsable àrea esportiva i d\'activitats de la salut i el benestar',
    create: 'Afegir camp addicional',        
    name: 'Nom',
    type: 'Tipus de camp',
    type_1: 'Text curt',
    type_2: 'Text llarg',
    type_3: 'Text amb format',
    type_4: 'Numèric',
    type_5: 'Data',
    type_6: 'Booleà S/N',
    type_7: 'Selecció',
    type_8: 'Selecció múltiple',
    type_9: 'Títol',
    type_10: 'Paràgraf (HTML)',
    type_11: 'Separador',
    required: 'Emplenat obligatori',
    max_length: 'Màx. longitud',
    default_value: 'Valor per defecte',
    actived: 'Visible',  
    priority: 'Ordre',
    form_web: 'Visible al formulari d\'alta de soci',
    form_annuary: 'Visible al formulari de l\'anuari',
    options: 'Opcions',
    delete_title: 'Segur que vols esborrar el camp addicional? ',
    delete_ask: 'S\'esborraran totes les dades dels contactes introduïdes en aquest camp addicional.',
  }, 
  custom_fields_options: {
    create: 'Afegir opció',    
    name: 'Opcions',
    priority: 'Ordre',
    edit: 'Editar opció',
    delete_title: 'Segur que vols esborrar aquesta opció? ',
    delete_ask: 'S\'esborraran totes les dades dels contactes introduïdes amb aquesta opció.',
  },   
  resources : {
    users : {
      name: 'Contactes'
    },
    events : {
      name: 'Activitats'
    },
    groups : {
      name: 'Grups'
    },
    real_state: {
      name: 'Immobles'      
    },
    agreements: {
      name: 'Convenis'
    },
    insurances: {
      name: 'Assegurances'
    }
  },
  'ra-tree' : {
    action : {
      add_root : 'Afegir grup',
    },
    new_node: 'Nou node',
    item_moved : 'S\'ha desplaçat el grup'
  },
  'ra-search' : {
    recent : 'Cerques recents'
  },


};

